{
  "level": "q310",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q310",
    "objects": "AREAS.E3:q310.e3",
    "mesh": "TREES.E3:q310.e3"
  },
  "spawn_point": {
    "position": [
      868.5097966795986,
      1387.5776849765223,
      1.300048828125
    ],
    "facing_rad": 0.0,
    "look_point": [
      868.5097966795986,
      1487.5776849765223,
      1.300048828125
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -6158.31884765625,
      -2598.9130859375,
      -22.699951171875
    ],
    "bbox_max": [
      3020.6171875,
      7185.4150390625,
      1493.904296875
    ],
    "vertex_count": 1648,
    "vertices": [
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -5545.388671875,
        4741.15380859375,
        334.1224365234375
      ],
      [
        -6158.31884765625,
        3750.8916015625,
        976.300048828125
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.86444091796875
      ],
      [
        -5504.7001953125,
        4729.1015625,
        -22.699951171875
      ],
      [
        -5704.54443359375,
        4430.01318359375,
        976.300048828125
      ],
      [
        -5573.556640625,
        4626.0498046875,
        901.1133422851562
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.839128494262695
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.86444091796875
      ],
      [
        -4474.53173828125,
        4475.62646484375,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        41.128944396972656
      ],
      [
        -5342.23681640625,
        4972.24560546875,
        157.04071044921875
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.7749633789062
      ],
      [
        -3179.908447265625,
        3702.748046875,
        150.0
      ],
      [
        -2916.739501953125,
        3191.2431640625,
        124.09432983398438
      ],
      [
        -5579.1611328125,
        4617.6630859375,
        976.300048828125
      ],
      [
        -5573.556640625,
        4626.0498046875,
        901.1133422851562
      ],
      [
        2769.303955078125,
        7185.4150390625,
        710.5693969726562
      ],
      [
        3020.6171875,
        6729.98193359375,
        570.58251953125
      ],
      [
        -800.0,
        -2100.0,
        508.155517578125
      ],
      [
        -800.0,
        -1855.504150390625,
        287.1609191894531
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2598.9130859375,
        1493.904296875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1550.0001220703125,
        2011.7158203125,
        1060.0
      ],
      [
        1550.0,
        1830.0,
        1060.0
      ],
      [
        1588.2843017578125,
        2050.0,
        1060.0
      ],
      [
        1550.0001220703125,
        2011.7158203125,
        1060.0
      ],
      [
        2020.0,
        1830.0,
        1060.0
      ],
      [
        2011.0,
        1865.199951171875,
        1060.0
      ],
      [
        1975.4892578125,
        1830.0,
        1060.0
      ],
      [
        1975.800048828125,
        1830.0,
        1059.6484375
      ],
      [
        1704.19970703125,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1864.1424560546875,
        1830.0,
        320.0
      ],
      [
        1815.857666015625,
        1830.0,
        320.0
      ],
      [
        1692.8388671875,
        1830.0,
        340.0
      ],
      [
        1692.8388671875,
        1830.0,
        350.0
      ],
      [
        1703.1702880859375,
        1830.0,
        340.0
      ],
      [
        1692.8388671875,
        1830.0,
        340.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1840.0001220703125,
        1830.0,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1973.3603515625,
        1830.0,
        1130.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1872.5,
        1841.2916259765625,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6507568359375,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6507568359375,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6507568359375,
        1115.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1106.0
      ],
      [
        1784.6409912109375,
        1830.0,
        1110.0
      ],
      [
        1784.3255615234375,
        1830.0,
        1110.0
      ],
      [
        1869.4744873046875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1115.0
      ],
      [
        1956.5875244140625,
        1690.0,
        1060.0
      ],
      [
        1723.4124755859375,
        1690.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1690.0,
        1060.0
      ],
      [
        1723.4124755859375,
        1690.0,
        1060.0
      ],
      [
        1956.5875244140625,
        1690.0,
        1060.0
      ],
      [
        1892.9422607421875,
        1690.0,
        1060.0
      ],
      [
        1655.0,
        1830.0,
        350.0
      ],
      [
        1655.0,
        1689.9998779296875,
        350.0
      ],
      [
        371.2994384765625,
        1690.0,
        240.0
      ],
      [
        1057.5947265625,
        1690.0,
        303.5163879394531
      ],
      [
        1225.0,
        1690.0,
        270.0
      ],
      [
        1170.0,
        1690.0,
        230.0
      ],
      [
        1083.078369140625,
        1690.0,
        329.0
      ],
      [
        1057.5947265625,
        1690.0,
        303.5163879394531
      ],
      [
        1815.8575439453125,
        1690.0,
        320.0
      ],
      [
        1864.1422119140625,
        1690.0,
        320.0
      ],
      [
        1756.5230712890625,
        1690.0,
        350.0
      ],
      [
        1770.0,
        1690.0,
        337.5488586425781
      ],
      [
        1703.17041015625,
        1690.0,
        340.0
      ],
      [
        1692.8388671875,
        1690.0,
        340.0
      ],
      [
        1692.8388671875,
        1690.0,
        340.0
      ],
      [
        1692.8388671875,
        1690.0,
        350.0
      ],
      [
        1880.41455078125,
        1690.0,
        1130.0
      ],
      [
        1892.9422607421875,
        1690.0,
        1130.0
      ],
      [
        1840.0,
        1690.0,
        1130.0
      ],
      [
        1880.41455078125,
        1690.0,
        1130.0
      ],
      [
        1961.243408203125,
        1690.0,
        1130.0
      ],
      [
        1973.3599853515625,
        1690.0,
        1130.0
      ],
      [
        1926.6507568359375,
        1772.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      [
        1892.9425048828125,
        1690.0,
        1106.0
      ],
      [
        1892.9422607421875,
        1690.0,
        1130.0
      ],
      [
        1892.9422607421875,
        1690.0,
        1060.0
      ],
      [
        1892.9425048828125,
        1690.0,
        1106.0
      ],
      [
        1894.150634765625,
        1691.2083740234375,
        1110.0
      ],
      [
        1895.3590087890625,
        1690.0,
        1110.0
      ],
      [
        1895.6744384765625,
        1690.0,
        1110.0
      ],
      [
        1908.7916259765625,
        1705.849365234375,
        1110.0
      ],
      [
        1894.150634765625,
        1691.2083740234375,
        1115.0
      ],
      [
        1895.3590087890625,
        1690.0,
        1115.0
      ],
      [
        1895.3590087890625,
        1690.0,
        1110.0
      ],
      [
        1894.150634765625,
        1691.2083740234375,
        1110.0
      ],
      [
        1810.525634765625,
        1690.0,
        1110.0
      ],
      [
        1831.9615478515625,
        1690.0,
        1110.0
      ],
      [
        1810.525634765625,
        1690.0,
        1115.0
      ],
      [
        1810.525634765625,
        1690.0,
        1110.0
      ],
      [
        1549.9998779296875,
        1508.2841796875,
        1060.0
      ],
      [
        1588.2841796875,
        1469.9998779296875,
        1060.0
      ],
      [
        780.0,
        1320.0,
        80.0
      ],
      [
        780.0,
        1310.0,
        80.0
      ],
      [
        780.0,
        1540.0,
        80.0
      ],
      [
        780.0,
        1530.0,
        80.0
      ],
      [
        780.0,
        1170.0,
        80.0
      ],
      [
        780.0,
        1280.0,
        80.0
      ],
      [
        780.0,
        1690.0,
        80.0
      ],
      [
        780.0,
        1570.0,
        80.0
      ],
      [
        780.0,
        970.0,
        80.0
      ],
      [
        780.0,
        1120.0,
        80.0
      ],
      [
        780.0,
        635.8578491210938,
        80.0
      ],
      [
        852.9127807617188,
        707.368408203125,
        80.0
      ],
      [
        950.0,
        1120.0,
        77.00000762939453
      ],
      [
        945.5584716796875,
        1310.0,
        76.55585479736328
      ],
      [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      [
        945.5584716796875,
        1310.0,
        76.55585479736328
      ],
      [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      [
        960.0,
        1570.0,
        80.0
      ],
      [
        780.0,
        1570.0,
        80.0
      ],
      [
        860.0,
        1585.0,
        80.0
      ],
      [
        860.0,
        1630.00390625,
        80.0
      ],
      [
        895.0,
        1630.00390625,
        80.0
      ],
      [
        860.0,
        1630.00390625,
        80.0
      ],
      [
        895.0,
        1650.0,
        80.0
      ],
      [
        895.0,
        1630.00390625,
        80.0
      ],
      [
        870.0,
        1615.0,
        80.0
      ],
      [
        890.0,
        1615.0,
        80.0
      ],
      [
        890.0,
        1625.0,
        80.0
      ],
      [
        890.0,
        1630.0,
        80.0
      ],
      [
        780.0,
        1280.0,
        80.0
      ],
      [
        950.0,
        1120.0,
        78.88888549804688
      ],
      [
        780.0,
        1120.0,
        80.0
      ],
      [
        950.0,
        1120.0,
        80.0
      ],
      [
        950.0,
        1120.0,
        80.0
      ],
      [
        950.0,
        970.0,
        80.0
      ],
      [
        780.0,
        1150.0,
        78.0
      ],
      [
        780.0,
        1130.0,
        78.0
      ],
      [
        780.0,
        1150.0,
        78.0
      ],
      [
        780.0,
        1150.0,
        80.0
      ],
      [
        780.0,
        1310.0,
        78.0
      ],
      [
        780.0,
        1310.0,
        80.0
      ],
      [
        790.0,
        1310.0,
        80.0
      ],
      [
        790.0,
        1310.0,
        78.0
      ],
      [
        820.0,
        1310.0,
        78.0
      ],
      [
        820.0,
        1310.0,
        80.0
      ],
      [
        945.5584716796875,
        1310.0,
        80.0
      ],
      [
        945.5584716796875,
        1310.0,
        78.0
      ],
      [
        780.0,
        1540.0,
        80.0
      ],
      [
        780.0,
        1540.0,
        78.0
      ],
      [
        790.0,
        1540.0,
        78.0
      ],
      [
        790.0,
        1540.0,
        80.0
      ],
      [
        820.0,
        1540.0,
        80.0
      ],
      [
        820.0,
        1540.0,
        78.0
      ],
      [
        945.5584716796875,
        1540.0,
        78.0
      ],
      [
        945.5584716796875,
        1540.0,
        80.0
      ],
      [
        820.0,
        1540.0,
        78.0
      ],
      [
        820.0,
        1540.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        78.0
      ],
      [
        820.0,
        1400.0,
        78.0
      ],
      [
        820.0,
        1400.0,
        80.0
      ],
      [
        820.0,
        1310.0,
        80.0
      ],
      [
        820.0,
        1310.0,
        78.0
      ],
      [
        790.0,
        1320.0,
        80.0
      ],
      [
        790.0,
        1320.0,
        78.0
      ],
      [
        790.0,
        1310.0,
        78.0
      ],
      [
        790.0,
        1310.0,
        80.0
      ],
      [
        790.0,
        1540.0,
        80.0
      ],
      [
        790.0,
        1540.0,
        78.0
      ],
      [
        790.0,
        1530.0,
        78.0
      ],
      [
        790.0,
        1530.0,
        80.0
      ],
      [
        780.0,
        1320.0,
        80.0
      ],
      [
        780.0,
        1320.0,
        78.0
      ],
      [
        790.0,
        1320.0,
        78.0
      ],
      [
        790.0,
        1320.0,
        80.0
      ],
      [
        790.0,
        1530.0,
        80.0
      ],
      [
        790.0,
        1530.0,
        78.0
      ],
      [
        780.0,
        1530.0,
        78.0
      ],
      [
        780.0,
        1530.0,
        80.0
      ],
      [
        890.0,
        1377.16455078125,
        80.0
      ],
      [
        890.0,
        1377.16455078125,
        78.0
      ],
      [
        945.5584716796875,
        1310.0,
        78.0
      ],
      [
        945.5584716796875,
        1310.0,
        80.0
      ],
      [
        820.0,
        1400.0,
        80.0
      ],
      [
        820.0,
        1400.0,
        78.0
      ],
      [
        871.1104736328125,
        1400.0,
        78.0
      ],
      [
        871.1104736328125,
        1400.0,
        80.0
      ],
      [
        827.0,
        1404.0,
        80.0
      ],
      [
        827.0,
        1440.0,
        80.0
      ],
      [
        827.0,
        1440.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        78.0
      ],
      [
        820.0,
        1450.0,
        80.0
      ],
      [
        826.9999389648438,
        1450.0,
        80.0
      ],
      [
        829.75048828125,
        1450.0,
        78.0
      ],
      [
        829.75048828125,
        1450.0,
        80.0
      ],
      [
        890.0,
        1472.83544921875,
        78.0
      ],
      [
        890.0,
        1472.83544921875,
        80.0
      ],
      [
        945.5584716796875,
        1540.0,
        80.0
      ],
      [
        945.5584716796875,
        1540.0,
        78.0
      ],
      [
        871.110595703125,
        1450.0,
        78.0
      ],
      [
        871.110595703125,
        1450.0,
        80.0
      ],
      [
        890.0,
        1377.16455078125,
        78.0
      ],
      [
        890.0,
        1377.16455078125,
        80.0
      ],
      [
        890.0,
        1400.0,
        80.0
      ],
      [
        890.0,
        1400.0,
        78.0
      ],
      [
        890.0,
        1450.0,
        78.0
      ],
      [
        890.0,
        1450.0,
        80.0
      ],
      [
        890.0,
        1472.83544921875,
        80.0
      ],
      [
        890.0,
        1472.83544921875,
        78.0
      ],
      [
        890.0,
        1400.0,
        78.0
      ],
      [
        890.0,
        1400.0,
        80.0
      ],
      [
        890.0,
        1450.0,
        80.0
      ],
      [
        890.0,
        1450.0,
        78.0
      ],
      [
        832.5558471679688,
        1540.0,
        80.0
      ],
      [
        832.5558471679688,
        1570.0,
        80.0
      ],
      [
        960.0,
        1550.0,
        80.0
      ],
      [
        960.0,
        1570.0,
        80.0
      ],
      [
        960.0,
        1550.0,
        80.0
      ],
      [
        832.5558471679688,
        1280.0,
        80.0
      ],
      [
        832.5558471679688,
        1310.0,
        80.0
      ],
      [
        960.0,
        1280.0,
        80.0
      ],
      [
        960.0,
        1300.0,
        80.0
      ],
      [
        960.0,
        1300.0,
        80.0
      ],
      [
        871.1104736328125,
        1400.0,
        69.11104583740234
      ],
      [
        871.1104736328125,
        1400.0,
        78.0
      ],
      [
        829.75048828125,
        1450.0,
        64.97505187988281
      ],
      [
        829.75048828125,
        1450.0,
        78.0
      ],
      [
        871.110595703125,
        1450.0,
        69.1110610961914
      ],
      [
        871.110595703125,
        1450.0,
        78.0
      ],
      [
        740.0,
        1300.0,
        78.0
      ],
      [
        740.0,
        1300.0,
        80.0
      ],
      [
        740.0,
        647.8578491210938,
        78.0
      ],
      [
        740.0,
        1300.0,
        78.0
      ],
      [
        760.0,
        617.2720947265625,
        78.0
      ],
      [
        760.0,
        615.8578491210938,
        80.0
      ],
      [
        740.0,
        595.8578491210938,
        80.0
      ],
      [
        740.0,
        597.2720947265625,
        78.0
      ],
      [
        740.0,
        610.0,
        60.0
      ],
      [
        760.0,
        630.0,
        60.0
      ],
      [
        500.0,
        1300.0,
        80.0
      ],
      [
        500.0,
        1300.0,
        78.0
      ],
      [
        260.0,
        1000.0,
        80.0
      ],
      [
        260.0,
        1250.0,
        80.0
      ],
      [
        500.0,
        930.0,
        60.0
      ],
      [
        500.0,
        920.0,
        80.0
      ],
      [
        500.0,
        1120.0,
        60.0
      ],
      [
        500.0,
        1110.0,
        80.0
      ],
      [
        340.0,
        1240.9998779296875,
        78.0
      ],
      [
        500.0,
        1300.0,
        78.0
      ],
      [
        730.0,
        600.0,
        60.0
      ],
      [
        720.0,
        575.8578491210938,
        80.0
      ],
      [
        721.0000610351562,
        704.1422119140625,
        78.0
      ],
      [
        721.0000610351562,
        750.0,
        78.0
      ],
      [
        721.0000610351562,
        628.85791015625,
        78.0
      ],
      [
        721.0000610351562,
        657.1543579101562,
        78.0
      ],
      [
        721.0000610351562,
        657.1543579101562,
        78.0
      ],
      [
        720.0,
        656.1539306640625,
        80.0
      ],
      [
        721.0000610351562,
        750.0,
        78.0
      ],
      [
        740.0,
        597.2720947265625,
        78.0
      ],
      [
        721.0,
        578.2720947265625,
        78.0
      ],
      [
        721.0,
        940.0,
        78.0
      ],
      [
        721.0,
        960.0,
        78.0
      ],
      [
        721.0,
        960.0,
        78.0
      ],
      [
        730.0,
        1300.0,
        60.0
      ],
      [
        730.0,
        1300.0,
        80.0
      ],
      [
        730.0,
        1130.0,
        78.0
      ],
      [
        730.0,
        1150.0,
        78.0
      ],
      [
        730.0,
        1150.0,
        80.0
      ],
      [
        730.0,
        1150.0,
        78.0
      ],
      [
        760.0,
        1550.0,
        80.0
      ],
      [
        760.0,
        1550.0,
        78.0
      ],
      [
        760.0,
        1570.0,
        78.0
      ],
      [
        760.0,
        1570.0,
        80.0
      ],
      [
        760.0,
        1440.0,
        80.0
      ],
      [
        760.0,
        1440.0,
        78.0
      ],
      [
        260.0,
        1500.0,
        80.0
      ],
      [
        260.0,
        1300.0,
        80.0
      ],
      [
        499.0001525878906,
        1459.0001220703125,
        78.0
      ],
      [
        500.0,
        1459.0001220703125,
        78.0
      ],
      [
        395.0,
        1459.0001220703125,
        78.0
      ],
      [
        499.0001525878906,
        1459.0001220703125,
        78.0
      ],
      [
        260.0,
        1459.0001220703125,
        78.0
      ],
      [
        395.0,
        1459.0001220703125,
        78.0
      ],
      [
        400.0,
        1415.9998779296875,
        78.0
      ],
      [
        390.9998474121094,
        1415.9998779296875,
        78.0
      ],
      [
        390.0,
        1415.9998779296875,
        78.0
      ],
      [
        390.9998474121094,
        1415.9998779296875,
        78.0
      ],
      [
        500.0,
        1416.0,
        78.0
      ],
      [
        480.0,
        1415.9998779296875,
        78.0
      ],
      [
        441.0,
        1400.0,
        78.0
      ],
      [
        441.0,
        1416.0,
        78.0
      ],
      [
        441.0,
        1309.0,
        78.0
      ],
      [
        441.0,
        1400.0,
        78.0
      ],
      [
        400.0,
        1415.9998779296875,
        78.0
      ],
      [
        404.0,
        1415.0,
        80.0
      ],
      [
        404.0,
        1425.0,
        80.0
      ],
      [
        404.0,
        1425.0,
        80.0
      ],
      [
        720.0,
        1460.0,
        80.0
      ],
      [
        720.0,
        1459.0,
        78.0
      ],
      [
        721.0,
        1560.0,
        78.0
      ],
      [
        720.0,
        1459.0,
        78.0
      ],
      [
        721.0,
        1459.0,
        78.0
      ],
      [
        721.0,
        1690.0,
        78.0
      ],
      [
        721.0,
        1560.0,
        78.0
      ],
      [
        550.0,
        1459.0,
        78.0
      ],
      [
        600.0,
        1459.0,
        78.0
      ],
      [
        600.0,
        1459.0,
        78.0
      ],
      [
        721.0000610351562,
        1420.0,
        78.0
      ],
      [
        720.0,
        1420.0,
        80.0
      ],
      [
        721.0,
        1438.9000244140625,
        78.0
      ],
      [
        721.0000610351562,
        1420.0,
        78.0
      ],
      [
        721.0,
        1438.9000244140625,
        78.0
      ],
      [
        504.0,
        1440.0,
        78.0
      ],
      [
        504.0,
        1440.0,
        78.0
      ],
      [
        504.0,
        1450.0,
        78.0
      ],
      [
        504.0,
        1450.0,
        78.0
      ],
      [
        1547.9998779296875,
        1684.999755859375,
        138.0
      ],
      [
        1547.9998779296875,
        1480.0,
        138.0
      ],
      [
        1480.0,
        1610.0,
        138.0
      ],
      [
        1480.0,
        1618.300048828125,
        177.0
      ],
      [
        1480.0,
        1690.0,
        177.0
      ],
      [
        1480.0,
        1610.0,
        177.0
      ],
      [
        1480.0,
        1618.300048828125,
        177.0
      ],
      [
        1480.0,
        1610.0,
        179.0
      ],
      [
        1480.0,
        1610.0,
        177.0
      ],
      [
        1480.0,
        1610.0,
        138.0
      ],
      [
        1480.0,
        1610.0,
        140.0
      ],
      [
        450.0,
        1415.0,
        91.5
      ],
      [
        450.0,
        1415.0,
        98.0
      ],
      [
        440.0,
        920.0,
        140.0
      ],
      [
        440.0,
        920.0,
        460.0
      ],
      [
        430.0000305175781,
        1310.0,
        170.0000457763672
      ],
      [
        440.0,
        1320.0,
        180.0
      ],
      [
        400.0,
        1340.0,
        140.0
      ],
      [
        440.0,
        1340.0,
        180.0
      ],
      [
        440.0,
        1340.0,
        100.0
      ],
      [
        400.0,
        1340.0,
        100.0
      ],
      [
        400.0,
        1340.0,
        100.0
      ],
      [
        400.0,
        1340.0,
        140.0
      ],
      [
        440.0,
        1410.0,
        180.0
      ],
      [
        435.0,
        1415.0,
        175.0
      ],
      [
        450.0,
        920.0,
        140.0
      ],
      [
        450.0,
        920.0,
        460.0
      ],
      [
        450.0,
        1240.0,
        330.0
      ],
      [
        450.0,
        980.0,
        330.0
      ],
      [
        450.0,
        1415.0,
        98.0
      ],
      [
        450.0,
        1310.0,
        98.0
      ],
      [
        450.0,
        1310.0,
        98.0
      ],
      [
        450.0,
        1130.0,
        98.0
      ],
      [
        450.0,
        1310.0,
        100.0
      ],
      [
        450.0,
        1415.0,
        100.0
      ],
      [
        440.0,
        1110.0,
        100.0
      ],
      [
        440.0,
        1110.0,
        98.0
      ],
      [
        450.0,
        1110.0,
        98.0
      ],
      [
        450.0,
        1110.0,
        100.0
      ],
      [
        450.0,
        1090.0,
        160.0
      ],
      [
        450.0,
        1090.0,
        120.0
      ],
      [
        450.0,
        1000.0,
        160.0
      ],
      [
        450.0,
        980.0,
        160.0
      ],
      [
        450.0,
        1110.0,
        160.0
      ],
      [
        450.0,
        1110.0,
        190.0
      ],
      [
        450.0,
        1110.0,
        120.0
      ],
      [
        450.0,
        1110.0,
        160.0
      ],
      [
        450.0,
        1090.0,
        160.0
      ],
      [
        450.0,
        1110.0,
        80.0
      ],
      [
        450.0,
        1320.0,
        91.5
      ],
      [
        450.0,
        1310.0,
        91.5
      ],
      [
        450.0,
        1415.0,
        91.5
      ],
      [
        450.0,
        1405.0,
        91.5
      ],
      [
        450.0,
        1320.0,
        91.5
      ],
      [
        450.0,
        1320.0,
        98.0
      ],
      [
        450.0,
        1405.0,
        98.0
      ],
      [
        450.0,
        1405.0,
        91.5
      ],
      [
        450.0,
        1425.0,
        100.0
      ],
      [
        450.0,
        1425.0,
        98.0
      ],
      [
        444.0,
        1425.0,
        100.0
      ],
      [
        444.0,
        1417.0,
        100.0
      ],
      [
        444.0,
        1415.0,
        100.0
      ],
      [
        444.0,
        1417.0,
        100.0
      ],
      [
        450.0,
        1420.0,
        98.0
      ],
      [
        450.0,
        1425.0,
        98.0
      ],
      [
        450.0,
        1415.0,
        98.0
      ],
      [
        450.0,
        1420.0,
        98.0
      ],
      [
        450.0,
        1425.0,
        100.0
      ],
      [
        450.0,
        1420.0,
        100.0
      ],
      [
        450.0,
        1415.0,
        100.0
      ],
      [
        450.0,
        1420.0,
        100.0
      ],
      [
        450.0,
        1510.0,
        150.0
      ],
      [
        450.0,
        1510.0,
        140.0
      ],
      [
        425.0,
        1510.0,
        95.0
      ],
      [
        450.0,
        1510.0,
        95.0
      ],
      [
        450.0,
        1510.0,
        140.0
      ],
      [
        450.0,
        1495.0,
        140.0
      ],
      [
        450.0,
        1510.0,
        150.0
      ],
      [
        450.0,
        1495.0,
        150.0
      ],
      [
        1030.0,
        1550.0,
        100.0
      ],
      [
        1030.0,
        1570.0,
        100.0
      ],
      [
        1030.0,
        1280.0,
        100.0
      ],
      [
        1030.0,
        1300.0,
        100.0
      ],
      [
        1030.0,
        1170.0,
        100.0
      ],
      [
        1030.0,
        1280.0,
        100.0
      ],
      [
        1030.0,
        1460.0,
        100.0
      ],
      [
        1030.0,
        1550.0,
        100.0
      ],
      [
        1030.0,
        1300.0,
        100.0
      ],
      [
        1030.0,
        1390.0,
        100.0
      ],
      [
        1030.0,
        1120.0,
        82.10526275634766
      ],
      [
        1030.0,
        640.0,
        80.0
      ],
      [
        1030.0,
        640.0,
        100.0
      ],
      [
        1030.0,
        880.0,
        80.0
      ],
      [
        1087.4879150390625,
        867.8525390625,
        98.77336120605469
      ],
      [
        1030.0,
        871.8778076171875,
        92.5525131225586
      ],
      [
        1030.0,
        680.0,
        100.0
      ],
      [
        1030.0,
        680.0,
        98.0
      ],
      [
        1090.0,
        1460.0,
        87.05882263183594
      ],
      [
        1090.0,
        1390.0,
        87.05882263183594
      ],
      [
        1030.0,
        1460.0,
        98.0
      ],
      [
        1030.0,
        1460.0,
        100.0
      ],
      [
        1030.0,
        1460.0,
        100.0
      ],
      [
        1030.0,
        1570.0,
        100.0
      ],
      [
        1030.0,
        1550.0,
        100.0
      ],
      [
        1030.0,
        1390.0,
        98.0
      ],
      [
        1030.0,
        1390.0,
        100.0
      ],
      [
        1030.0,
        1390.0,
        100.0
      ],
      [
        1030.0,
        1300.0,
        100.0
      ],
      [
        1030.0,
        1120.0,
        82.10526275634766
      ],
      [
        1030.0,
        1120.0,
        100.0
      ],
      [
        1030.0,
        867.8525390625,
        98.77336120605469
      ],
      [
        1120.0,
        1453.4285888671875,
        100.0
      ],
      [
        1110.0,
        1446.2857666015625,
        100.0
      ],
      [
        1110.0,
        1403.7142333984375,
        100.0
      ],
      [
        1120.0,
        1396.5714111328125,
        100.0
      ],
      [
        1110.0,
        1403.7142333984375,
        100.0
      ],
      [
        1110.0,
        1392.142822265625,
        100.0
      ],
      [
        1110.0,
        1392.142822265625,
        100.0
      ],
      [
        1120.0,
        1392.7142333984375,
        100.0
      ],
      [
        1120.0,
        1396.5714111328125,
        100.0
      ],
      [
        1120.0,
        1392.7142333984375,
        100.0
      ],
      [
        1110.0,
        1457.857177734375,
        100.0
      ],
      [
        1110.0,
        1446.2857666015625,
        100.0
      ],
      [
        1120.0,
        1457.2857666015625,
        100.0
      ],
      [
        1110.0,
        1457.857177734375,
        100.0
      ],
      [
        1120.0,
        1457.2857666015625,
        100.0
      ],
      [
        1120.0,
        1453.4285888671875,
        100.0
      ],
      [
        1030.0,
        1410.0,
        98.0
      ],
      [
        1030.0,
        1390.0,
        98.0
      ],
      [
        1030.0,
        1460.0,
        98.0
      ],
      [
        1030.0,
        1440.0,
        98.0
      ],
      [
        1030.0,
        1410.0,
        100.0
      ],
      [
        1030.0,
        1410.0,
        98.0
      ],
      [
        1030.0,
        1440.0,
        100.0
      ],
      [
        1030.0,
        1440.0,
        98.0
      ],
      [
        780.0,
        1320.0,
        100.0
      ],
      [
        780.0,
        1310.0,
        100.0
      ],
      [
        780.0,
        1540.0,
        100.0
      ],
      [
        780.0,
        1530.0,
        100.0
      ],
      [
        780.0,
        970.0,
        100.0
      ],
      [
        780.0,
        1120.0,
        100.0
      ],
      [
        780.0,
        930.0,
        100.0
      ],
      [
        780.0,
        750.0,
        100.0
      ],
      [
        980.0,
        1550.0,
        100.0
      ],
      [
        980.0,
        1570.0,
        100.0
      ],
      [
        980.0,
        1280.0,
        100.0
      ],
      [
        980.0,
        1300.0,
        100.0
      ],
      [
        780.0,
        658.2842407226562,
        98.0
      ],
      [
        780.0,
        644.1422119140625,
        98.0
      ],
      [
        980.0,
        1100.0,
        98.0
      ],
      [
        780.0,
        635.8577880859375,
        98.0
      ],
      [
        780.0,
        644.1422119140625,
        98.0
      ],
      [
        780.0,
        1280.0,
        98.0
      ],
      [
        980.0,
        1280.0,
        98.0
      ],
      [
        980.0,
        680.0,
        100.0
      ],
      [
        980.0,
        680.0,
        98.0
      ],
      [
        980.0,
        640.0,
        98.0
      ],
      [
        980.0,
        640.0,
        100.0
      ],
      [
        784.1421508789062,
        640.0,
        98.0
      ],
      [
        784.1421508789062,
        640.0,
        98.0
      ],
      [
        780.0,
        635.8578491210938,
        100.0
      ],
      [
        780.0,
        635.8578491210938,
        98.0
      ],
      [
        780.0,
        658.2842407226562,
        98.0
      ],
      [
        780.0,
        658.2842407226562,
        100.0
      ],
      [
        854.0377807617188,
        707.730224609375,
        100.0
      ],
      [
        854.0377807617188,
        707.730224609375,
        98.0
      ],
      [
        980.0,
        833.6924438476562,
        98.0
      ],
      [
        980.0,
        833.6924438476562,
        100.0
      ],
      [
        942.0,
        930.0,
        98.0
      ],
      [
        960.0,
        930.0,
        98.0
      ],
      [
        942.0,
        930.0,
        98.0
      ],
      [
        780.0,
        930.0,
        100.0
      ],
      [
        780.0,
        930.0,
        98.0
      ],
      [
        780.0,
        1120.0,
        100.0
      ],
      [
        780.0,
        1120.0,
        98.0
      ],
      [
        950.0,
        1120.0,
        98.0
      ],
      [
        950.0,
        1120.0,
        100.0
      ],
      [
        950.0,
        1120.0,
        100.0
      ],
      [
        950.0,
        1120.0,
        98.0
      ],
      [
        950.0,
        970.0,
        98.0
      ],
      [
        950.0,
        970.0,
        100.0
      ],
      [
        960.0,
        1096.0,
        100.0
      ],
      [
        960.0,
        1570.0,
        100.0
      ],
      [
        960.0,
        1570.0,
        98.0
      ],
      [
        980.0,
        1570.0,
        98.0
      ],
      [
        980.0,
        1570.0,
        100.0
      ],
      [
        980.0,
        1570.0,
        98.0
      ],
      [
        780.0,
        1570.0,
        98.0
      ],
      [
        885.0,
        1635.0,
        100.0
      ],
      [
        885.0,
        1625.0,
        100.0
      ],
      [
        885.0,
        1650.0,
        100.0
      ],
      [
        885.0,
        1635.0,
        100.0
      ],
      [
        895.0,
        1625.0,
        100.0
      ],
      [
        895.0,
        1625.0,
        100.0
      ],
      [
        885.0,
        1625.0,
        100.0
      ],
      [
        895.0,
        1635.0,
        100.0
      ],
      [
        780.0,
        1310.0,
        98.0
      ],
      [
        780.0,
        1310.0,
        100.0
      ],
      [
        790.0,
        1310.0,
        100.0
      ],
      [
        790.0,
        1310.0,
        98.0
      ],
      [
        820.0,
        1310.0,
        98.0
      ],
      [
        820.0,
        1310.0,
        100.0
      ],
      [
        945.5584716796875,
        1310.0,
        100.0
      ],
      [
        945.5584716796875,
        1310.0,
        98.0
      ],
      [
        780.0,
        1540.0,
        100.0
      ],
      [
        780.0,
        1540.0,
        98.0
      ],
      [
        790.0,
        1540.0,
        98.0
      ],
      [
        790.0,
        1540.0,
        100.0
      ],
      [
        820.0,
        1540.0,
        100.0
      ],
      [
        820.0,
        1540.0,
        98.0
      ],
      [
        945.5584716796875,
        1540.0,
        98.0
      ],
      [
        945.5584716796875,
        1540.0,
        100.0
      ],
      [
        820.0,
        1540.0,
        98.0
      ],
      [
        820.0,
        1540.0,
        100.0
      ],
      [
        820.0,
        1450.0,
        100.0
      ],
      [
        820.0,
        1450.0,
        98.0
      ],
      [
        820.0,
        1400.0,
        98.0
      ],
      [
        820.0,
        1400.0,
        100.0
      ],
      [
        820.0,
        1310.0,
        100.0
      ],
      [
        820.0,
        1310.0,
        98.0
      ],
      [
        890.0,
        1377.16455078125,
        100.0
      ],
      [
        890.0,
        1377.16455078125,
        98.0
      ],
      [
        945.5584716796875,
        1310.0,
        98.0
      ],
      [
        945.5584716796875,
        1310.0,
        100.0
      ],
      [
        820.0,
        1400.0,
        100.0
      ],
      [
        820.0,
        1400.0,
        98.0
      ],
      [
        871.1104736328125,
        1400.0,
        98.0
      ],
      [
        871.1104736328125,
        1400.0,
        100.0
      ],
      [
        829.75048828125,
        1450.0,
        98.0
      ],
      [
        820.0,
        1450.0,
        98.0
      ],
      [
        820.0,
        1450.0,
        100.0
      ],
      [
        829.75048828125,
        1450.0,
        100.0
      ],
      [
        890.0,
        1472.83544921875,
        98.0
      ],
      [
        890.0,
        1472.83544921875,
        100.0
      ],
      [
        945.5584716796875,
        1540.0,
        100.0
      ],
      [
        945.5584716796875,
        1540.0,
        98.0
      ],
      [
        871.110595703125,
        1450.0,
        98.0
      ],
      [
        871.110595703125,
        1450.0,
        100.0
      ],
      [
        883.0,
        1440.0,
        98.0
      ],
      [
        883.0,
        1404.0,
        98.0
      ],
      [
        890.0,
        1377.16455078125,
        98.0
      ],
      [
        890.0,
        1377.16455078125,
        100.0
      ],
      [
        890.0,
        1400.0,
        100.0
      ],
      [
        890.0,
        1400.0,
        98.0
      ],
      [
        890.0,
        1450.0,
        98.0
      ],
      [
        890.0,
        1450.0,
        100.0
      ],
      [
        890.0,
        1472.83544921875,
        100.0
      ],
      [
        890.0,
        1472.83544921875,
        98.0
      ],
      [
        883.0,
        1440.0,
        98.0
      ],
      [
        882.9999389648438,
        1400.0,
        98.0
      ],
      [
        890.0,
        1400.0,
        98.0
      ],
      [
        890.0,
        1400.0,
        100.0
      ],
      [
        890.0,
        1450.0,
        100.0
      ],
      [
        890.0,
        1450.0,
        98.0
      ],
      [
        882.9999389648438,
        1450.0,
        98.0
      ],
      [
        790.0,
        1320.0,
        100.0
      ],
      [
        790.0,
        1320.0,
        98.0
      ],
      [
        790.0,
        1310.0,
        98.0
      ],
      [
        790.0,
        1310.0,
        100.0
      ],
      [
        790.0,
        1540.0,
        100.0
      ],
      [
        790.0,
        1540.0,
        98.0
      ],
      [
        790.0,
        1530.0,
        98.0
      ],
      [
        790.0,
        1530.0,
        100.0
      ],
      [
        780.0,
        1320.0,
        100.0
      ],
      [
        780.0,
        1320.0,
        98.0
      ],
      [
        790.0,
        1320.0,
        98.0
      ],
      [
        790.0,
        1320.0,
        100.0
      ],
      [
        790.0,
        1530.0,
        100.0
      ],
      [
        790.0,
        1530.0,
        98.0
      ],
      [
        780.0,
        1530.0,
        98.0
      ],
      [
        780.0,
        1530.0,
        100.0
      ],
      [
        933.0026245117188,
        1540.0,
        98.0
      ],
      [
        933.0026245117188,
        1570.0,
        98.0
      ],
      [
        960.0,
        1550.0,
        100.0
      ],
      [
        960.0,
        1550.0,
        98.0
      ],
      [
        960.0,
        1570.0,
        98.0
      ],
      [
        960.0,
        1570.0,
        100.0
      ],
      [
        960.0,
        1550.0,
        98.0
      ],
      [
        960.0,
        1550.0,
        100.0
      ],
      [
        980.0,
        1550.0,
        100.0
      ],
      [
        980.0,
        1550.0,
        98.0
      ],
      [
        933.0026245117188,
        1310.0,
        98.0
      ],
      [
        933.0026245117188,
        1280.0,
        98.0
      ],
      [
        960.0,
        1280.0,
        100.0
      ],
      [
        960.0,
        1280.0,
        98.0
      ],
      [
        960.0,
        1300.0,
        98.0
      ],
      [
        960.0,
        1300.0,
        100.0
      ],
      [
        960.0,
        1300.0,
        100.0
      ],
      [
        960.0,
        1300.0,
        98.0
      ],
      [
        980.0,
        1300.0,
        98.0
      ],
      [
        980.0,
        1300.0,
        100.0
      ],
      [
        980.0,
        640.0,
        80.0
      ],
      [
        780.0,
        635.8578491210938,
        80.0
      ],
      [
        980.0,
        833.6924438476562,
        94.97779846191406
      ],
      [
        980.0,
        847.0313720703125,
        80.0
      ],
      [
        980.0,
        833.6924438476562,
        94.97779846191406
      ],
      [
        838.0225219726562,
        1440.0,
        85.1492919921875
      ],
      [
        867.8016357421875,
        1404.0,
        93.6576156616211
      ],
      [
        871.1104736328125,
        1400.0,
        80.0
      ],
      [
        871.1104736328125,
        1400.0,
        94.6030044555664
      ],
      [
        867.8016357421875,
        1404.0,
        91.6576156616211
      ],
      [
        838.0225219726562,
        1440.0,
        83.14928436279297
      ],
      [
        838.0225219726562,
        1440.0,
        83.14928436279297
      ],
      [
        838.0225219726562,
        1440.0,
        85.1492919921875
      ],
      [
        826.9999389648438,
        1450.0,
        80.0
      ],
      [
        829.75048828125,
        1450.0,
        82.7858657836914
      ],
      [
        829.75048828125,
        1450.0,
        80.7858657836914
      ],
      [
        829.75048828125,
        1450.0,
        80.0
      ],
      [
        871.1104736328125,
        1400.0,
        98.0
      ],
      [
        829.75048828125,
        1450.0,
        98.0
      ],
      [
        871.110595703125,
        1450.0,
        80.0
      ],
      [
        871.110595703125,
        1450.0,
        98.0
      ],
      [
        862.8385620117188,
        1440.0,
        92.23958587646484
      ],
      [
        850.4305419921875,
        1424.9998779296875,
        88.69444274902344
      ],
      [
        862.8385620117188,
        1440.0,
        90.23957824707031
      ],
      [
        850.4305419921875,
        1424.9998779296875,
        86.6944351196289
      ],
      [
        862.8385620117188,
        1440.0,
        90.23957824707031
      ],
      [
        862.8385620117188,
        1440.0,
        92.23958587646484
      ],
      [
        882.9999389648438,
        1400.0,
        98.0
      ],
      [
        871.1104736328125,
        1400.0,
        94.60298919677734
      ],
      [
        871.1104736328125,
        1400.0,
        92.60299682617188
      ],
      [
        871.110595703125,
        1450.0,
        92.60302734375
      ],
      [
        871.110595703125,
        1450.0,
        94.60301971435547
      ],
      [
        882.9999389648438,
        1450.0,
        98.0
      ],
      [
        1010.0,
        930.0,
        100.0
      ],
      [
        1010.0,
        1120.0,
        100.0
      ],
      [
        1010.0,
        1290.0,
        98.0
      ],
      [
        1010.0,
        1300.0,
        98.0
      ],
      [
        1010.0,
        1140.0,
        98.0
      ],
      [
        1010.0,
        1150.0,
        98.0
      ],
      [
        1010.0,
        1290.0,
        98.0
      ],
      [
        1010.0,
        1690.0,
        98.0
      ],
      [
        1010.0,
        1640.0,
        98.0
      ],
      [
        1010.0,
        1410.0,
        98.0
      ],
      [
        1010.0,
        1460.0,
        98.0
      ],
      [
        1010.0,
        1440.0,
        98.0
      ],
      [
        1010.0,
        1150.0,
        98.0
      ],
      [
        1020.0,
        1246.0,
        100.0
      ],
      [
        1010.0,
        1300.0,
        98.0
      ],
      [
        1010.0,
        1300.0,
        100.0
      ],
      [
        1020.0,
        680.0,
        100.0
      ],
      [
        1010.0,
        680.0,
        100.0
      ],
      [
        1010.0,
        680.0,
        98.0
      ],
      [
        1020.0,
        680.0,
        98.0
      ],
      [
        1020.0,
        640.0,
        100.0
      ],
      [
        1010.0,
        640.0,
        100.0
      ],
      [
        1010.0,
        640.0,
        98.0
      ],
      [
        1020.0,
        640.0,
        98.0
      ],
      [
        1010.0,
        1120.0,
        100.0
      ],
      [
        1010.0,
        1120.0,
        98.0
      ],
      [
        1020.0,
        1120.0,
        98.0
      ],
      [
        1020.0,
        1120.0,
        100.0
      ],
      [
        1013.9887084960938,
        868.3529663085938,
        98.0
      ],
      [
        1010.0,
        863.6924438476562,
        98.31112670898438
      ],
      [
        1010.0,
        863.9695434570312,
        98.0
      ],
      [
        1020.0,
        867.8525390625,
        98.77336120605469
      ],
      [
        1013.9887084960938,
        868.3529663085938,
        98.0
      ],
      [
        1020.0,
        868.3529663085938,
        98.0
      ],
      [
        1010.0,
        863.6924438476562,
        98.31112670898438
      ],
      [
        1014.1600952148438,
        867.8525390625,
        100.0
      ],
      [
        1010.0,
        863.6924438476562,
        100.0
      ],
      [
        1010.0,
        1440.0,
        100.0
      ],
      [
        1020.0,
        1440.0,
        100.0
      ],
      [
        1020.0,
        1440.0,
        98.0
      ],
      [
        1010.0,
        1440.0,
        98.0
      ],
      [
        1010.0,
        1460.0,
        98.0
      ],
      [
        1020.0,
        1460.0,
        98.0
      ],
      [
        1020.0,
        1460.0,
        100.0
      ],
      [
        1010.0,
        1460.0,
        100.0
      ],
      [
        1020.0,
        1640.0,
        98.0
      ],
      [
        1010.0,
        1640.0,
        98.0
      ],
      [
        1010.0,
        1640.0,
        100.0
      ],
      [
        1020.0,
        1640.0,
        100.0
      ],
      [
        1020.0,
        1410.0,
        100.0
      ],
      [
        1010.0,
        1410.0,
        100.0
      ],
      [
        1010.0,
        1410.0,
        98.0
      ],
      [
        1020.0,
        1410.0,
        98.0
      ],
      [
        1020.0,
        1390.0,
        98.0
      ],
      [
        1020.0,
        1390.0,
        100.0
      ],
      [
        1030.0,
        1120.0,
        98.0
      ],
      [
        1030.0,
        640.0,
        98.0
      ],
      [
        1030.0,
        868.3529663085938,
        98.0
      ],
      [
        1010.0,
        640.0,
        80.0
      ],
      [
        1030.0,
        871.8778076171875,
        92.5525131225586
      ],
      [
        1012.3585205078125,
        873.113037109375,
        90.64350891113281
      ],
      [
        1012.3585205078125,
        873.113037109375,
        90.64350891113281
      ],
      [
        1010.0,
        870.6498413085938,
        90.49895477294922
      ],
      [
        1000.0,
        1386.0,
        98.0
      ],
      [
        1000.0,
        853.6924438476562,
        100.0
      ],
      [
        980.0,
        833.6924438476562,
        98.0
      ],
      [
        1000.0,
        853.6924438476562,
        98.0
      ],
      [
        1000.0,
        640.0,
        100.0
      ],
      [
        980.0,
        640.0,
        98.0
      ],
      [
        1000.0,
        640.0,
        98.0
      ],
      [
        1000.0,
        680.0,
        100.0
      ],
      [
        1000.0,
        680.0,
        98.0
      ],
      [
        1007.1998291015625,
        860.8922729492188,
        98.0
      ],
      [
        1010.0,
        640.0,
        98.0
      ],
      [
        1010.0,
        1386.0,
        98.0
      ],
      [
        1000.0,
        1386.0,
        98.0
      ],
      [
        1003.75,
        1610.0,
        100.0
      ],
      [
        1003.75,
        1620.0,
        100.0
      ],
      [
        1003.75,
        1620.0,
        100.0
      ],
      [
        1003.75,
        1610.0,
        100.0
      ],
      [
        1010.0,
        863.9695434570312,
        98.0
      ],
      [
        1007.1998291015625,
        860.8922729492188,
        98.0
      ],
      [
        1000.0,
        1361.5,
        83.74996948242188
      ],
      [
        1010.0,
        1361.5,
        83.74996948242188
      ],
      [
        720.0,
        1110.0,
        100.0
      ],
      [
        720.0,
        980.0,
        100.0
      ],
      [
        720.0,
        1640.0,
        100.0
      ],
      [
        720.0,
        1460.0,
        100.0
      ],
      [
        450.0,
        1690.0,
        98.0
      ],
      [
        450.0,
        1690.0,
        100.0
      ],
      [
        460.0,
        1688.0108642578125,
        100.0
      ],
      [
        460.0,
        1688.0108642578125,
        98.0
      ],
      [
        460.0,
        1110.0,
        100.0
      ],
      [
        450.0,
        1110.0,
        100.0
      ],
      [
        450.0,
        1110.0,
        98.0
      ],
      [
        460.0,
        1110.0,
        98.0
      ],
      [
        500.0,
        1680.0543212890625,
        100.0
      ],
      [
        500.0,
        1680.0543212890625,
        98.0
      ],
      [
        500.0,
        1110.0,
        98.0
      ],
      [
        500.0,
        1110.0,
        100.0
      ],
      [
        500.0,
        1680.0543212890625,
        80.0
      ],
      [
        500.0,
        1110.0,
        80.0
      ],
      [
        720.0,
        1110.0,
        100.0
      ],
      [
        720.0,
        575.8578491210938,
        80.0
      ],
      [
        720.0,
        575.8578491210938,
        100.0
      ],
      [
        720.0,
        575.8578491210938,
        98.0
      ],
      [
        720.0,
        604.2505493164062,
        98.0
      ],
      [
        720.0,
        604.2505493164062,
        100.0
      ],
      [
        720.0,
        604.2505493164062,
        98.0
      ],
      [
        720.0,
        1254.22314453125,
        80.0
      ],
      [
        720.0,
        1285.0,
        99.02108764648438
      ],
      [
        720.0,
        1315.77685546875,
        80.0
      ],
      [
        720.0,
        1285.0,
        99.02108001708984
      ],
      [
        640.0,
        1460.0,
        100.0
      ],
      [
        720.0,
        1460.0,
        100.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        100.0
      ],
      [
        625.537109375,
        1572.7098388671875,
        100.0
      ],
      [
        720.0,
        1640.0,
        100.0
      ],
      [
        660.0,
        1640.0,
        100.0
      ],
      [
        660.0,
        1640.0,
        100.0
      ],
      [
        660.0,
        1690.0,
        100.0
      ],
      [
        625.537109375,
        1572.7098388671875,
        100.0
      ],
      [
        640.0,
        1500.0,
        100.0
      ],
      [
        522.7098388671875,
        1675.537109375,
        100.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        100.0
      ],
      [
        522.7098388671875,
        1675.537109375,
        100.0
      ],
      [
        760.0,
        1690.0,
        98.0
      ],
      [
        740.0,
        1690.0,
        98.0
      ],
      [
        740.0,
        1670.0,
        98.0
      ],
      [
        740.0,
        595.8578491210938,
        98.0
      ],
      [
        760.0,
        615.8577880859375,
        98.0
      ],
      [
        760.0,
        644.1637573242188,
        98.0
      ],
      [
        740.0,
        624.2071533203125,
        98.0
      ],
      [
        760.0,
        615.8578491210938,
        98.0
      ],
      [
        760.0,
        615.8578491210938,
        100.0
      ],
      [
        740.0,
        595.8578491210938,
        100.0
      ],
      [
        740.0,
        595.8578491210938,
        98.0
      ],
      [
        760.0,
        644.1637573242188,
        100.0
      ],
      [
        740.0,
        624.2071533203125,
        100.0
      ],
      [
        740.0,
        624.2071533203125,
        98.0
      ],
      [
        760.0,
        644.1637573242188,
        98.0
      ],
      [
        740.0,
        1670.0,
        100.0
      ],
      [
        740.0,
        1670.0,
        98.0
      ],
      [
        740.0,
        595.8578491210938,
        80.0
      ],
      [
        760.0,
        615.8578491210938,
        80.0
      ],
      [
        780.0,
        635.8578491210938,
        98.0
      ],
      [
        760.0,
        615.8578491210938,
        98.0
      ],
      [
        740.0,
        595.8578491210938,
        98.0
      ],
      [
        720.0,
        575.8578491210938,
        98.0
      ],
      [
        720.0,
        1283.347900390625,
        98.0
      ],
      [
        720.5368041992188,
        1285.0,
        98.0
      ],
      [
        720.5368041992188,
        1285.0,
        98.0
      ],
      [
        720.0,
        1286.652099609375,
        98.0
      ],
      [
        1030.0,
        1550.0,
        180.0
      ],
      [
        1030.0,
        1550.0,
        160.0
      ],
      [
        1250.0,
        1550.0,
        140.0
      ],
      [
        1250.0,
        1550.0,
        100.0
      ],
      [
        1250.0,
        1610.0,
        156.46153259277344
      ],
      [
        1250.0,
        1610.0,
        158.46153259277344
      ],
      [
        1480.0,
        1610.0,
        120.0
      ],
      [
        1250.0,
        1610.0,
        100.0
      ],
      [
        1258.199951171875,
        1633.59228515625,
        148.0
      ],
      [
        1258.199951171875,
        1638.573486328125,
        158.0
      ],
      [
        1258.199951171875,
        1690.0,
        261.2411804199219
      ],
      [
        1480.0,
        1638.430419921875,
        177.0
      ],
      [
        1468.300048828125,
        1638.9371337890625,
        177.0
      ],
      [
        1258.199951171875,
        1633.59228515625,
        148.0
      ],
      [
        1250.0,
        1660.0,
        148.0
      ],
      [
        1250.0,
        1635.405029296875,
        148.0
      ],
      [
        1252.3668212890625,
        1633.844970703125,
        148.0
      ],
      [
        1250.0,
        1684.594970703125,
        148.0
      ],
      [
        1250.0,
        1660.0,
        148.0
      ],
      [
        1252.3668212890625,
        1633.844970703125,
        148.0
      ],
      [
        1250.0,
        1635.405029296875,
        148.0
      ],
      [
        1250.0,
        1633.9473876953125,
        148.0
      ],
      [
        1250.0,
        1630.0,
        158.0
      ],
      [
        1250.0,
        1630.0,
        148.0
      ],
      [
        1250.0,
        1630.0,
        429.0
      ],
      [
        1250.0,
        1630.0,
        379.0
      ],
      [
        1480.0,
        1630.0,
        177.0
      ],
      [
        1250.0,
        1690.0,
        379.0
      ],
      [
        1250.0,
        1630.0,
        379.0
      ],
      [
        1250.0,
        1630.0,
        148.0
      ],
      [
        1355.0,
        1620.0,
        177.0
      ],
      [
        1350.0,
        1620.0,
        177.0
      ],
      [
        1478.300048828125,
        1620.0,
        177.0
      ],
      [
        1480.0,
        1620.0,
        177.0
      ],
      [
        1355.0,
        1620.0,
        177.0
      ],
      [
        1478.300048828125,
        1620.0,
        177.0
      ],
      [
        1350.0,
        1620.0,
        177.0
      ],
      [
        1350.0,
        1620.0,
        179.0
      ],
      [
        1300.0,
        1620.0,
        158.0
      ],
      [
        1250.0,
        1630.0,
        156.46153259277344
      ],
      [
        1250.0,
        1620.0,
        156.46153259277344
      ],
      [
        1310.0,
        1620.0,
        158.0
      ],
      [
        1300.0,
        1620.0,
        158.0
      ],
      [
        1320.0,
        1620.0,
        158.0
      ],
      [
        1310.0,
        1620.0,
        158.0
      ],
      [
        1250.0,
        1610.0,
        156.46153259277344
      ],
      [
        1466.5,
        1570.0,
        158.0
      ],
      [
        1466.5,
        1580.0,
        158.0
      ],
      [
        1466.5,
        1580.0,
        158.0
      ],
      [
        1415.0,
        1580.0,
        138.0
      ],
      [
        1415.0,
        1580.0,
        140.0
      ],
      [
        1266.5,
        1580.0,
        138.0
      ],
      [
        1266.5,
        1590.0,
        138.0
      ],
      [
        1266.5,
        1590.0,
        138.0
      ],
      [
        1250.0,
        1580.0,
        128.57142639160156
      ],
      [
        1250.0,
        1590.0,
        128.57142639160156
      ],
      [
        1250.0,
        1590.0,
        112.11428833007812
      ],
      [
        1250.0,
        1590.0,
        110.11428833007812
      ],
      [
        1250.0,
        1590.0,
        128.57142639160156
      ],
      [
        1250.0,
        1590.0,
        126.57142639160156
      ],
      [
        1250.0,
        1598.0,
        110.11428833007812
      ],
      [
        1250.0,
        1598.0,
        112.11428833007812
      ],
      [
        1250.0,
        1590.0,
        110.11428833007812
      ],
      [
        1250.0,
        1598.0,
        110.11428833007812
      ],
      [
        1266.0,
        1570.0,
        160.0
      ],
      [
        1290.0,
        1550.0,
        190.0
      ],
      [
        1266.0,
        1550.0,
        160.0
      ],
      [
        1250.0,
        1550.0,
        140.0
      ],
      [
        1030.0,
        1610.0,
        118.0
      ],
      [
        1030.0,
        1610.0,
        120.0
      ],
      [
        1030.0,
        1610.0,
        116.0
      ],
      [
        1030.0,
        1610.0,
        114.0
      ],
      [
        1200.0,
        1610.0,
        251.81817626953125
      ],
      [
        1200.0,
        1690.0,
        251.81817626953125
      ],
      [
        1200.0,
        1690.0,
        379.0
      ],
      [
        1200.0,
        1630.0,
        379.0
      ],
      [
        1200.0,
        1630.0,
        429.0
      ],
      [
        1200.0,
        1630.0,
        379.0
      ],
      [
        1200.0,
        1630.0,
        158.0
      ],
      [
        1200.0,
        1630.0,
        148.0
      ],
      [
        1200.0,
        1630.0,
        148.0
      ],
      [
        1200.0,
        1640.7330322265625,
        148.0
      ],
      [
        1235.0,
        1630.0,
        120.0
      ],
      [
        1215.0,
        1630.0,
        120.0
      ],
      [
        1215.0,
        1630.0,
        118.0
      ],
      [
        1235.0,
        1630.0,
        118.0
      ],
      [
        1215.0,
        1630.0,
        120.0
      ],
      [
        1215.0,
        1630.0,
        118.0
      ],
      [
        1235.0,
        1610.0,
        120.0
      ],
      [
        1235.0,
        1610.0,
        118.0
      ],
      [
        1030.0,
        1620.0,
        114.0
      ],
      [
        1030.0,
        1620.0,
        116.0
      ],
      [
        1200.0,
        1685.4576416015625,
        251.81817626953125
      ],
      [
        1170.0,
        1676.3758544921875,
        230.0
      ],
      [
        1200.0,
        1633.904052734375,
        148.0
      ],
      [
        1192.6827392578125,
        1634.3314208984375,
        148.0
      ],
      [
        1037.5947265625,
        1648.357666015625,
        158.0
      ],
      [
        1057.5947265625,
        1657.6171875,
        179.0
      ],
      [
        1057.5947265625,
        1663.07958984375,
        190.0
      ],
      [
        1057.5947265625,
        1663.07958984375,
        190.0
      ],
      [
        1057.5947265625,
        1690.0,
        244.21194458007812
      ],
      [
        1037.5947265625,
        1648.357666015625,
        158.0
      ],
      [
        1057.5947265625,
        1657.6171875,
        179.0
      ],
      [
        1057.5947265625,
        1630.0,
        303.5163879394531
      ],
      [
        1200.0,
        1630.0,
        251.81817626953125
      ],
      [
        1170.0,
        1630.0,
        230.0
      ],
      [
        1083.078369140625,
        1630.0,
        329.0
      ],
      [
        1057.5947265625,
        1630.0,
        303.5163879394531
      ],
      [
        1057.5947265625,
        1620.0,
        303.5163879394531
      ],
      [
        1057.5947265625,
        1620.0,
        210.0
      ],
      [
        1170.0,
        1620.0,
        230.0
      ],
      [
        1100.0,
        1620.0,
        230.0
      ],
      [
        1200.0,
        1620.0,
        251.81817626953125
      ],
      [
        1170.0,
        1620.0,
        230.0
      ],
      [
        1083.078369140625,
        1620.0,
        329.0
      ],
      [
        1057.5947265625,
        1620.0,
        303.5163879394531
      ],
      [
        1057.5947265625,
        1620.0,
        210.0
      ],
      [
        1100.0,
        1620.0,
        210.0
      ],
      [
        1100.0,
        1620.0,
        210.0
      ],
      [
        1100.0,
        1620.0,
        230.0
      ],
      [
        1030.0,
        1610.0,
        114.0
      ],
      [
        1030.0,
        1620.0,
        114.0
      ],
      [
        1030.0,
        1620.0,
        116.0
      ],
      [
        1030.0,
        1610.0,
        116.0
      ],
      [
        1215.0,
        1550.0,
        120.0
      ],
      [
        1235.0,
        1550.0,
        120.0
      ],
      [
        1200.0,
        1610.0,
        120.0
      ],
      [
        1200.0,
        1590.0,
        120.0
      ],
      [
        1235.0,
        1550.0,
        118.0
      ],
      [
        1215.0,
        1550.0,
        118.0
      ],
      [
        1200.0,
        1590.0,
        118.0
      ],
      [
        1200.0,
        1610.0,
        118.0
      ],
      [
        1215.0,
        1550.0,
        118.0
      ],
      [
        1215.0,
        1550.0,
        120.0
      ],
      [
        1238.8043212890625,
        1590.0,
        118.0
      ],
      [
        1238.5,
        1590.0,
        120.0
      ],
      [
        1238.8043212890625,
        1598.0,
        118.0
      ],
      [
        1200.0,
        1590.0,
        118.0
      ],
      [
        1200.0,
        1590.0,
        120.0
      ],
      [
        1030.0,
        1570.0,
        160.0
      ],
      [
        1030.0,
        1570.0,
        180.0
      ],
      [
        1030.0,
        1550.0,
        160.0
      ],
      [
        1030.0,
        1570.0,
        160.0
      ],
      [
        1030.0,
        1550.0,
        180.0
      ],
      [
        1030.0,
        1570.0,
        180.0
      ],
      [
        1030.0,
        1590.0,
        118.0
      ],
      [
        1030.0,
        1590.0,
        120.0
      ],
      [
        1030.0,
        1610.0,
        120.0
      ],
      [
        1030.0,
        1590.0,
        120.0
      ],
      [
        1030.0,
        1590.0,
        118.0
      ],
      [
        1030.0,
        1610.0,
        118.0
      ],
      [
        1350.0,
        1469.9998779296875,
        636.467529296875
      ],
      [
        1350.0,
        1469.9998779296875,
        490.0
      ],
      [
        1350.0,
        1469.9998779296875,
        490.0
      ],
      [
        1350.0,
        1469.9998779296875,
        190.0
      ],
      [
        1350.0,
        1469.9998779296875,
        490.0
      ],
      [
        1350.0,
        1469.9998779296875,
        272.50018310546875
      ],
      [
        1266.0,
        1550.0,
        160.0
      ],
      [
        1290.0,
        1469.9998779296875,
        190.0
      ],
      [
        1266.0,
        1469.9998779296875,
        160.0
      ],
      [
        1250.0,
        1469.9998779296875,
        140.0
      ],
      [
        1350.0,
        1450.0,
        190.0
      ],
      [
        1350.0,
        1450.0,
        140.0
      ],
      [
        1350.0,
        1450.0,
        622.3255004882812
      ],
      [
        1350.0,
        1450.0,
        490.0
      ],
      [
        1350.0,
        1450.0,
        490.0
      ],
      [
        1350.0,
        1450.0,
        190.0
      ],
      [
        1350.0,
        1450.0,
        490.0
      ],
      [
        1350.0,
        1450.0,
        301.5
      ],
      [
        1030.0,
        1300.0,
        160.0
      ],
      [
        1030.0,
        1300.0,
        180.0
      ],
      [
        1075.0,
        1310.0,
        580.0
      ],
      [
        1175.0,
        1310.0,
        580.0
      ],
      [
        1030.0,
        1310.0,
        370.0852355957031
      ],
      [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      [
        1075.0,
        1380.0,
        580.0
      ],
      [
        1175.0,
        1380.0,
        580.0
      ],
      [
        1075.0,
        1380.0,
        580.0
      ],
      [
        1075.0,
        1310.0,
        580.0
      ],
      [
        1030.0,
        1310.0,
        370.0852355957031
      ],
      [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      [
        1050.0,
        1380.0,
        390.0852355957031
      ],
      [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      [
        1030.0,
        1380.0,
        370.0852355957031
      ],
      [
        1030.0,
        1380.0,
        370.0852355957031
      ],
      [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      [
        1050.0,
        1380.0,
        390.0852355957031
      ],
      [
        1030.0,
        1330.0,
        355.9431457519531
      ],
      [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      [
        1030.0,
        1330.0,
        355.9431457519531
      ],
      [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      [
        1050.0,
        1390.0,
        390.0852355957031
      ],
      [
        1030.0,
        1390.0,
        370.0852355957031
      ],
      [
        1030.0,
        1390.0,
        370.0852355957031
      ],
      [
        1050.0,
        1390.0,
        390.0852355957031
      ],
      [
        1030.0,
        1280.0,
        160.0
      ],
      [
        1030.0,
        1300.0,
        160.0
      ],
      [
        1030.0,
        1300.0,
        180.0
      ],
      [
        1030.0,
        1280.0,
        180.0
      ],
      [
        1050.0,
        1460.0,
        390.0852355957031
      ],
      [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      [
        1050.0,
        1460.0,
        390.0852355957031
      ],
      [
        1030.0,
        1110.0,
        130.0
      ],
      [
        1037.0,
        1092.0,
        580.0
      ],
      [
        1030.0,
        975.0,
        255.0
      ],
      [
        1030.0,
        1120.0,
        130.0
      ],
      [
        1039.999755859375,
        1120.0,
        130.0
      ],
      [
        1030.0,
        1120.0,
        130.0
      ],
      [
        1030.0,
        1120.0,
        100.0
      ],
      [
        1041.199951171875,
        1120.0,
        100.0
      ],
      [
        1030.0,
        1120.0,
        118.0
      ],
      [
        1040.47998046875,
        1120.0,
        118.0
      ],
      [
        1039.52001953125,
        1120.9599609375,
        118.0
      ],
      [
        1030.0,
        1120.9599609375,
        118.0
      ],
      [
        1040.3997802734375,
        1120.0,
        120.0
      ],
      [
        1030.0,
        1120.0,
        120.0
      ],
      [
        1030.0,
        1120.7999267578125,
        120.0
      ],
      [
        1039.5999755859375,
        1120.7999267578125,
        120.0
      ],
      [
        1110.0,
        1120.9599609375,
        118.0
      ],
      [
        1110.0,
        1120.7999267578125,
        120.0
      ],
      [
        1030.0,
        1140.0,
        120.0
      ],
      [
        1030.0,
        1140.0,
        118.0
      ],
      [
        1030.0,
        1140.0,
        120.0
      ],
      [
        1030.0,
        1140.0,
        118.0
      ],
      [
        1075.0,
        1310.0,
        750.0
      ],
      [
        1175.0,
        1310.0,
        750.0
      ],
      [
        1075.0,
        1380.0,
        750.0
      ],
      [
        1175.0,
        1380.0,
        750.0
      ],
      [
        1075.0,
        1380.0,
        750.0
      ],
      [
        1075.0,
        1310.0,
        750.0
      ],
      [
        1030.0,
        608.0,
        120.0
      ],
      [
        1030.0,
        608.0,
        250.0
      ],
      [
        1030.0,
        1540.0,
        355.9431457519531
      ],
      [
        1030.0,
        1540.0,
        370.0852355957031
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1540.0,
        370.0852355957031
      ],
      [
        1050.0,
        1470.0,
        390.0852355957031
      ],
      [
        1030.0,
        1470.0,
        370.0852355957031
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1470.0,
        370.0852355957031
      ],
      [
        1050.0,
        1470.0,
        390.0852355957031
      ],
      [
        1030.0,
        1540.0,
        355.9431457519531
      ],
      [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      [
        720.0,
        1550.0,
        190.0
      ],
      [
        720.0,
        1550.0,
        100.0
      ],
      [
        519.3519287109375,
        1550.0,
        150.0
      ],
      [
        519.3518676757812,
        1550.0,
        140.0
      ],
      [
        519.3518676757812,
        1550.0,
        190.0
      ],
      [
        519.3518676757812,
        1550.0,
        150.0
      ],
      [
        450.0,
        1550.0,
        120.0
      ],
      [
        519.3519897460938,
        1550.0,
        120.0
      ],
      [
        450.0,
        1690.0,
        120.0
      ],
      [
        522.7098388671875,
        1675.537109375,
        120.0
      ],
      [
        522.7098388671875,
        1675.537109375,
        120.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        120.0
      ],
      [
        630.0543823242188,
        1550.0,
        140.0
      ],
      [
        519.3518676757812,
        1550.0,
        140.0
      ],
      [
        630.0543823242188,
        1550.0,
        120.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        120.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        140.0
      ],
      [
        625.537109375,
        1572.7098388671875,
        140.0
      ],
      [
        625.537109375,
        1572.7098388671875,
        120.0
      ],
      [
        720.0,
        1640.0,
        120.0
      ],
      [
        720.0,
        1640.0,
        140.0
      ],
      [
        660.0,
        1640.0,
        140.0
      ],
      [
        660.0,
        1640.0,
        120.0
      ],
      [
        660.0,
        1640.0,
        120.0
      ],
      [
        660.0,
        1640.0,
        140.0
      ],
      [
        660.0,
        1690.0,
        140.0
      ],
      [
        660.0,
        1690.0,
        120.0
      ],
      [
        625.537109375,
        1572.7098388671875,
        120.0
      ],
      [
        625.537109375,
        1572.7098388671875,
        140.0
      ],
      [
        630.0543823242188,
        1550.0,
        140.0
      ],
      [
        630.0543823242188,
        1550.0,
        120.0
      ],
      [
        630.0543823242188,
        1550.0,
        100.0
      ],
      [
        720.0,
        1550.0,
        190.0
      ],
      [
        630.0543823242188,
        1550.0,
        190.0
      ],
      [
        630.0543823242188,
        1550.0,
        190.0
      ],
      [
        806.0,
        1580.0,
        150.0
      ],
      [
        806.0,
        1580.0,
        200.0
      ],
      [
        815.0,
        1595.0,
        200.0
      ],
      [
        815.0,
        1595.0,
        150.0
      ],
      [
        790.0,
        1664.0,
        200.0
      ],
      [
        805.0,
        1655.0,
        200.0
      ],
      [
        805.0,
        1655.0,
        150.0
      ],
      [
        790.0,
        1664.0,
        150.0
      ],
      [
        815.0,
        1665.0,
        150.0
      ],
      [
        815.0,
        1665.0,
        200.0
      ],
      [
        806.0,
        1680.0,
        200.0
      ],
      [
        806.0,
        1680.0,
        150.0
      ],
      [
        805.0,
        1655.0,
        150.0
      ],
      [
        805.0,
        1655.0,
        200.0
      ],
      [
        815.0,
        1665.0,
        200.0
      ],
      [
        815.0,
        1665.0,
        150.0
      ],
      [
        805.0,
        1605.0,
        150.0
      ],
      [
        805.0,
        1605.0,
        200.0
      ],
      [
        790.0,
        1596.0,
        200.0
      ],
      [
        790.0,
        1596.0,
        150.0
      ],
      [
        815.0,
        1595.0,
        150.0
      ],
      [
        815.0,
        1595.0,
        200.0
      ],
      [
        805.0,
        1605.0,
        200.0
      ],
      [
        805.0,
        1605.0,
        150.0
      ],
      [
        970.0,
        1596.0,
        200.0
      ],
      [
        955.0,
        1605.0,
        200.0
      ],
      [
        955.0,
        1605.0,
        150.0
      ],
      [
        970.0,
        1596.0,
        150.0
      ],
      [
        945.0,
        1595.0,
        150.0
      ],
      [
        945.0,
        1595.0,
        200.0
      ],
      [
        954.0,
        1580.0,
        200.0
      ],
      [
        954.0,
        1580.0,
        150.0
      ],
      [
        955.0,
        1605.0,
        150.0
      ],
      [
        955.0,
        1605.0,
        200.0
      ],
      [
        945.0,
        1595.0,
        200.0
      ],
      [
        945.0,
        1595.0,
        150.0
      ],
      [
        954.0,
        1680.0,
        150.0
      ],
      [
        954.0,
        1680.0,
        200.0
      ],
      [
        945.0,
        1665.0,
        200.0
      ],
      [
        945.0,
        1665.0,
        150.0
      ],
      [
        955.0,
        1655.0,
        150.0
      ],
      [
        955.0,
        1655.0,
        200.0
      ],
      [
        970.0,
        1664.0,
        200.0
      ],
      [
        970.0,
        1664.0,
        150.0
      ],
      [
        945.0,
        1665.0,
        150.0
      ],
      [
        945.0,
        1665.0,
        200.0
      ],
      [
        955.0,
        1655.0,
        200.0
      ],
      [
        955.0,
        1655.0,
        150.0
      ],
      [
        970.0,
        1580.0,
        150.0
      ],
      [
        970.0,
        1580.0,
        200.0
      ],
      [
        980.0,
        1590.0,
        200.0
      ],
      [
        980.0,
        1590.0,
        150.0
      ],
      [
        980.0,
        1670.0,
        150.0
      ],
      [
        980.0,
        1670.0,
        200.0
      ],
      [
        970.0,
        1680.0,
        200.0
      ],
      [
        970.0,
        1680.0,
        150.0
      ],
      [
        980.0,
        1590.0,
        150.0
      ],
      [
        980.0,
        1590.0,
        200.0
      ],
      [
        980.0,
        1670.0,
        200.0
      ],
      [
        980.0,
        1670.0,
        150.0
      ],
      [
        780.0,
        1590.0,
        150.0
      ],
      [
        780.0,
        1590.0,
        200.0
      ],
      [
        790.0,
        1580.0,
        200.0
      ],
      [
        790.0,
        1580.0,
        150.0
      ],
      [
        790.0,
        1680.0,
        150.0
      ],
      [
        790.0,
        1680.0,
        200.0
      ],
      [
        780.0,
        1670.0,
        200.0
      ],
      [
        780.0,
        1670.0,
        150.0
      ],
      [
        780.0,
        1590.0,
        200.0
      ],
      [
        780.0,
        1590.0,
        150.0
      ],
      [
        780.0,
        1670.0,
        150.0
      ],
      [
        780.0,
        1670.0,
        200.0
      ],
      [
        815.0,
        1595.0,
        145.0
      ],
      [
        805.0,
        1605.0,
        144.9999542236328
      ],
      [
        810.0,
        1600.0,
        140.0
      ],
      [
        805.0,
        1605.0,
        144.9999542236328
      ],
      [
        799.9999389648438,
        1602.0,
        150.0
      ],
      [
        812.0000610351562,
        1590.0,
        150.0
      ],
      [
        815.0,
        1595.0,
        145.0
      ],
      [
        805.0,
        1655.0,
        144.9999542236328
      ],
      [
        815.0,
        1665.0,
        145.0
      ],
      [
        810.0,
        1660.0,
        140.0
      ],
      [
        799.9999389648438,
        1658.0,
        150.0
      ],
      [
        805.0,
        1655.0,
        144.9999542236328
      ],
      [
        815.0,
        1665.0,
        145.0
      ],
      [
        812.0,
        1670.0,
        150.0
      ],
      [
        955.0,
        1605.0,
        145.0000457763672
      ],
      [
        945.0,
        1595.0,
        145.0
      ],
      [
        950.0,
        1600.0,
        140.0
      ],
      [
        945.0,
        1595.0,
        145.0
      ],
      [
        947.9999389648438,
        1590.0,
        150.0
      ],
      [
        960.0,
        1602.0,
        150.0
      ],
      [
        955.0,
        1605.0,
        145.0000457763672
      ],
      [
        945.0,
        1665.0,
        145.0
      ],
      [
        955.0,
        1655.0,
        145.0000457763672
      ],
      [
        950.0,
        1660.0,
        140.0
      ],
      [
        948.0,
        1670.0,
        150.0
      ],
      [
        945.0,
        1665.0,
        145.0
      ],
      [
        955.0,
        1655.0,
        145.0000457763672
      ],
      [
        960.0,
        1658.0,
        150.0
      ],
      [
        955.0,
        1605.0,
        140.0
      ],
      [
        963.3333129882812,
        1600.0,
        140.0
      ],
      [
        955.0,
        1605.0,
        140.0
      ],
      [
        955.0,
        1655.0,
        140.0
      ],
      [
        963.3333129882812,
        1660.0,
        140.0
      ],
      [
        955.0,
        1655.0,
        140.0
      ],
      [
        805.0,
        1605.0,
        140.0
      ],
      [
        796.6666870117188,
        1600.0,
        140.0
      ],
      [
        805.0,
        1605.0,
        140.0
      ],
      [
        805.0,
        1655.0,
        140.0
      ],
      [
        796.6666870117188,
        1660.0,
        140.0
      ],
      [
        805.0,
        1655.0,
        140.0
      ],
      [
        780.0,
        1590.0,
        140.0
      ],
      [
        980.0,
        1590.0,
        140.0
      ],
      [
        806.0,
        1580.0,
        140.0
      ],
      [
        815.0,
        1595.0,
        140.0
      ],
      [
        780.0,
        1590.0,
        140.0
      ],
      [
        790.0,
        1580.0,
        140.0
      ],
      [
        815.0,
        1595.0,
        140.0
      ],
      [
        945.0,
        1595.0,
        140.0
      ],
      [
        954.0,
        1580.0,
        140.0
      ],
      [
        970.0,
        1580.0,
        140.0
      ],
      [
        980.0,
        1590.0,
        140.0
      ],
      [
        945.0,
        1595.0,
        140.0
      ],
      [
        780.0,
        1670.0,
        140.0
      ],
      [
        980.0,
        1670.0,
        140.0
      ],
      [
        815.0,
        1665.0,
        140.0
      ],
      [
        806.0,
        1680.0,
        140.0
      ],
      [
        790.0,
        1680.0,
        140.0
      ],
      [
        780.0,
        1670.0,
        140.0
      ],
      [
        815.0,
        1665.0,
        140.0
      ],
      [
        954.0,
        1680.0,
        140.0
      ],
      [
        945.0,
        1665.0,
        140.0
      ],
      [
        980.0,
        1670.0,
        140.0
      ],
      [
        970.0,
        1680.0,
        140.0
      ],
      [
        945.0,
        1665.0,
        140.0
      ],
      [
        806.0,
        1680.0,
        100.0
      ],
      [
        806.0,
        1680.0,
        120.0
      ],
      [
        806.0,
        1680.0,
        120.0
      ],
      [
        790.0,
        1680.0,
        100.0
      ],
      [
        790.0,
        1680.0,
        120.0
      ],
      [
        790.0,
        1680.0,
        120.0
      ],
      [
        954.0,
        1680.0,
        100.0
      ],
      [
        954.0,
        1680.0,
        120.0
      ],
      [
        954.0,
        1680.0,
        120.0
      ],
      [
        970.0,
        1680.0,
        100.0
      ],
      [
        970.0,
        1680.0,
        120.0
      ],
      [
        970.0,
        1680.0,
        120.0
      ],
      [
        806.0,
        1580.0,
        100.0
      ],
      [
        806.0,
        1580.0,
        120.0
      ],
      [
        806.0,
        1580.0,
        120.0
      ],
      [
        790.0,
        1580.0,
        100.0
      ],
      [
        790.0,
        1580.0,
        120.0
      ],
      [
        790.0,
        1580.0,
        120.0
      ],
      [
        954.0,
        1580.0,
        100.0
      ],
      [
        954.0,
        1580.0,
        120.0
      ],
      [
        954.0,
        1580.0,
        120.0
      ],
      [
        970.0,
        1580.0,
        100.0
      ],
      [
        970.0,
        1580.0,
        120.0
      ],
      [
        970.0,
        1580.0,
        120.0
      ],
      [
        800.0,
        1690.0,
        200.0
      ],
      [
        960.0,
        1690.0,
        200.0
      ],
      [
        800.0,
        1690.0,
        200.0
      ],
      [
        960.0,
        1690.0,
        200.0
      ],
      [
        820.0,
        1550.0,
        180.0
      ],
      [
        820.0,
        1550.0,
        120.0
      ],
      [
        945.5584716796875,
        1550.0,
        120.0
      ],
      [
        820.0,
        1550.0,
        120.0
      ],
      [
        820.0,
        1550.0,
        180.0
      ],
      [
        945.5584716796875,
        1550.0,
        140.0
      ],
      [
        960.0,
        1550.0,
        120.0
      ],
      [
        960.0,
        1570.0,
        120.0
      ],
      [
        980.0,
        1550.0,
        120.0
      ],
      [
        980.0,
        1570.0,
        120.0
      ],
      [
        945.5584716796875,
        1550.0,
        120.0
      ],
      [
        945.5584716796875,
        1550.0,
        140.0
      ],
      [
        790.0,
        1580.0,
        180.0
      ],
      [
        800.0,
        1570.0,
        180.0
      ],
      [
        960.0,
        1570.0,
        180.0
      ],
      [
        970.0,
        1580.0,
        180.0
      ],
      [
        800.0,
        1570.0,
        180.0
      ],
      [
        806.0,
        1580.0,
        180.0
      ],
      [
        954.0,
        1580.0,
        180.0
      ],
      [
        960.0,
        1570.0,
        180.0
      ],
      [
        800.0,
        1570.0,
        200.0
      ],
      [
        960.0,
        1570.0,
        200.0
      ],
      [
        800.0,
        1570.0,
        200.0
      ],
      [
        960.0,
        1570.0,
        200.0
      ],
      [
        950.0,
        950.0,
        140.0
      ],
      [
        950.0,
        950.0,
        220.0
      ],
      [
        1020.0,
        950.0,
        130.0
      ],
      [
        1020.0,
        1120.0,
        130.0
      ],
      [
        1020.0,
        1120.0,
        130.0
      ],
      [
        1018.7999877929688,
        1120.0,
        100.0
      ],
      [
        1019.5199584960938,
        1120.0,
        118.0
      ],
      [
        1030.0,
        1120.9599609375,
        118.0
      ],
      [
        1019.5199584960938,
        1120.9599609375,
        118.0
      ],
      [
        1030.0,
        1120.7999267578125,
        120.0
      ],
      [
        1019.5999755859375,
        1120.0,
        120.0
      ],
      [
        1019.5999755859375,
        1120.7999267578125,
        120.0
      ],
      [
        1026.7122802734375,
        1166.1483154296875,
        297.8082275390625
      ],
      [
        1026.7122802734375,
        1280.0,
        297.8082275390625
      ],
      [
        1020.0,
        1140.0,
        120.0
      ],
      [
        1020.0,
        1120.7999267578125,
        120.0
      ],
      [
        1020.0,
        1140.0,
        118.0
      ],
      [
        1020.0,
        1120.9599609375,
        118.0
      ],
      [
        1020.0,
        1140.0,
        120.0
      ],
      [
        1020.0,
        1140.0,
        118.0
      ],
      [
        1019.5999755859375,
        1140.0,
        120.0
      ],
      [
        1019.5199584960938,
        1140.0,
        118.0
      ],
      [
        1019.5999755859375,
        1140.0,
        120.0
      ],
      [
        1019.5199584960938,
        1140.0,
        118.0
      ],
      [
        1010.0,
        950.0,
        130.0
      ],
      [
        1010.0,
        960.0,
        130.0
      ],
      [
        1010.0,
        950.0,
        130.0
      ],
      [
        1010.0,
        950.0,
        100.0
      ],
      [
        1010.0,
        961.199951171875,
        100.0
      ],
      [
        1019.5999755859375,
        1120.7999267578125,
        120.0
      ],
      [
        1010.0,
        1120.0,
        120.0
      ],
      [
        1010.0,
        1120.7999267578125,
        120.0
      ],
      [
        1010.0,
        1120.0,
        118.0
      ],
      [
        1019.5199584960938,
        1120.9599609375,
        118.0
      ],
      [
        1010.0,
        1120.9599609375,
        118.0
      ],
      [
        1009.0399780273438,
        1120.0,
        118.0
      ],
      [
        1009.0399780273438,
        1120.9599609375,
        118.0
      ],
      [
        1009.2000122070312,
        1120.0,
        120.0
      ],
      [
        1009.2000122070312,
        1120.7999267578125,
        120.0
      ],
      [
        1023.239501953125,
        1166.1483154296875,
        295.4930419921875
      ],
      [
        1023.239501953125,
        1280.0,
        295.4930419921875
      ],
      [
        1009.2000122070312,
        1140.0,
        120.0
      ],
      [
        1009.0399780273438,
        1140.0,
        118.0
      ],
      [
        1009.2000122070312,
        1140.0,
        120.0
      ],
      [
        1009.0399780273438,
        1140.0,
        118.0
      ],
      [
        1000.0,
        950.0,
        118.0
      ],
      [
        1000.0,
        950.0,
        120.0
      ],
      [
        1000.0,
        950.0,
        118.0
      ],
      [
        989.0,
        1168.266845703125,
        118.0
      ],
      [
        990.0,
        1168.07421875,
        120.0
      ],
      [
        990.0,
        1280.0,
        120.0
      ],
      [
        989.0,
        1280.0,
        118.0
      ],
      [
        990.0,
        1140.0,
        120.0
      ],
      [
        988.9999389648438,
        1140.0,
        118.0
      ],
      [
        976.0,
        990.0,
        118.0
      ],
      [
        960.0,
        1084.0,
        108.00000762939453
      ],
      [
        950.0,
        1094.0,
        103.00000762939453
      ],
      [
        960.0,
        1084.0,
        108.00000762939453
      ],
      [
        950.0,
        950.0,
        220.0
      ],
      [
        950.0,
        924.773681640625,
        337.72265625
      ],
      [
        950.0,
        950.0,
        140.0
      ],
      [
        950.0,
        930.0,
        140.0
      ],
      [
        950.0,
        920.0,
        140.0
      ],
      [
        950.0,
        900.0,
        140.0
      ],
      [
        958.2842407226562,
        900.0,
        140.0
      ],
      [
        1000.0,
        900.0,
        118.0
      ],
      [
        980.0,
        900.0,
        118.0
      ],
      [
        958.2843017578125,
        900.0,
        118.0
      ],
      [
        950.0,
        920.0,
        118.0
      ],
      [
        950.0,
        900.0,
        118.0
      ],
      [
        950.0,
        920.0,
        118.0
      ],
      [
        950.0,
        920.0,
        120.0
      ],
      [
        980.0,
        900.0,
        120.0
      ],
      [
        1000.0,
        900.0,
        120.0
      ],
      [
        1000.0,
        900.0,
        120.0
      ],
      [
        1000.0,
        900.0,
        118.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        950.0,
        930.0,
        140.0
      ],
      [
        950.0,
        930.0,
        118.0
      ],
      [
        950.0,
        930.0,
        100.0
      ],
      [
        950.0,
        803.6924438476562,
        120.0
      ],
      [
        950.0,
        803.6924438476562,
        100.0
      ],
      [
        950.0,
        803.6924438476562,
        170.0
      ],
      [
        950.0,
        803.6924438476562,
        120.0
      ],
      [
        1014.2000122070312,
        867.8925170898438,
        118.0
      ],
      [
        1014.179931640625,
        867.8724365234375,
        118.0
      ],
      [
        1014.179931640625,
        867.8724365234375,
        118.0
      ],
      [
        950.0,
        803.6924438476562,
        118.0
      ],
      [
        950.0,
        803.656982421875,
        118.0
      ],
      [
        950.0,
        803.656982421875,
        120.0
      ],
      [
        950.0,
        803.6924438476562,
        120.0
      ],
      [
        1014.179931640625,
        867.8724365234375,
        120.0
      ],
      [
        950.0,
        891.7156982421875,
        118.0
      ],
      [
        950.0,
        832.009765625,
        118.0
      ],
      [
        950.0,
        832.009765625,
        120.0
      ],
      [
        950.0,
        832.009765625,
        120.0
      ],
      [
        950.0,
        832.009765625,
        118.0
      ],
      [
        1000.0,
        882.0472412109375,
        120.0
      ],
      [
        1000.0,
        882.0472412109375,
        118.0
      ],
      [
        950.0,
        891.7157592773438,
        140.0
      ],
      [
        780.0,
        950.0,
        120.0
      ],
      [
        780.0,
        950.0,
        118.0
      ],
      [
        780.0,
        950.0,
        140.0
      ],
      [
        780.0,
        950.0,
        220.0
      ],
      [
        840.0,
        1111.9007568359375,
        600.0
      ],
      [
        840.0,
        1111.9007568359375,
        170.0
      ],
      [
        840.0,
        1079.81103515625,
        170.0
      ],
      [
        840.0,
        1111.9007568359375,
        170.0
      ],
      [
        861.3306274414062,
        1120.0,
        100.0
      ],
      [
        868.66943359375,
        1120.0,
        100.0
      ],
      [
        868.6693725585938,
        1120.0,
        110.0
      ],
      [
        861.3306274414062,
        1120.0,
        110.0
      ],
      [
        840.0,
        1120.0,
        100.0
      ],
      [
        840.0,
        1120.0,
        110.0
      ],
      [
        842.3323364257812,
        1130.0,
        108.0
      ],
      [
        840.0,
        1130.0,
        108.0
      ],
      [
        840.0,
        1120.0,
        108.0
      ],
      [
        845.0,
        1128.9871826171875,
        108.0
      ],
      [
        842.3323364257812,
        1130.0,
        110.0
      ],
      [
        840.0,
        1130.0,
        110.0
      ],
      [
        840.0,
        1130.0,
        108.0
      ],
      [
        842.3323364257812,
        1130.0,
        108.0
      ],
      [
        874.6409912109375,
        1252.0,
        140.0
      ],
      [
        874.6409912109375,
        1150.0,
        140.0
      ],
      [
        840.0,
        1150.0,
        140.0
      ],
      [
        840.0,
        1272.0,
        140.0
      ],
      [
        874.6409912109375,
        1120.0,
        100.0
      ],
      [
        874.6409912109375,
        1120.0,
        110.0
      ],
      [
        840.0,
        1280.0,
        140.0
      ],
      [
        874.6409912109375,
        1280.0,
        140.0
      ],
      [
        910.0,
        1120.0,
        100.0
      ],
      [
        910.0,
        1120.0,
        110.0
      ],
      [
        805.0,
        1045.0,
        170.0
      ],
      [
        794.0264282226562,
        1020.7152099609375,
        170.0
      ],
      [
        822.5736694335938,
        1083.890869140625,
        170.0
      ],
      [
        805.0,
        1045.0,
        170.0
      ],
      [
        834.24267578125,
        1109.7147216796875,
        170.0
      ],
      [
        822.5736694335938,
        1083.890869140625,
        170.0
      ],
      [
        816.9431762695312,
        1120.0,
        100.0
      ],
      [
        816.9431762695312,
        1120.0,
        110.0
      ],
      [
        821.4618530273438,
        1130.0,
        108.0
      ],
      [
        816.9431762695312,
        1120.0,
        108.0
      ],
      [
        840.0,
        1171.0252685546875,
        140.0
      ],
      [
        830.499267578125,
        1150.0,
        140.0
      ],
      [
        821.4618530273438,
        1130.0,
        110.0
      ],
      [
        821.4618530273438,
        1130.0,
        108.0
      ],
      [
        840.0,
        1272.0,
        140.0
      ],
      [
        805.3590087890625,
        1150.0,
        140.0
      ],
      [
        805.3590087890625,
        1252.0,
        140.0
      ],
      [
        805.3590087890625,
        1130.0,
        110.0
      ],
      [
        805.3590087890625,
        1130.0,
        108.0
      ],
      [
        805.3590087890625,
        1130.0,
        108.0
      ],
      [
        805.3590087890625,
        1120.0,
        108.0
      ],
      [
        816.9431762695312,
        1120.0,
        108.0
      ],
      [
        805.3590087890625,
        1120.0,
        110.0
      ],
      [
        805.3590087890625,
        1120.0,
        108.0
      ],
      [
        805.3590087890625,
        1120.0,
        100.0
      ],
      [
        780.0,
        1150.0,
        140.0
      ],
      [
        780.0,
        1237.35888671875,
        140.0
      ],
      [
        780.0,
        1130.0,
        108.0
      ],
      [
        780.0,
        1130.0,
        110.0
      ],
      [
        780.0,
        1130.0,
        108.0
      ],
      [
        780.0,
        1280.0,
        140.0
      ],
      [
        780.0,
        516.0,
        190.0
      ],
      [
        780.0,
        516.0,
        140.0
      ],
      [
        780.0,
        460.0,
        140.0
      ],
      [
        780.0,
        516.0,
        140.0
      ],
      [
        780.0,
        460.0,
        140.0
      ],
      [
        780.0,
        460.0,
        100.0
      ],
      [
        780.0,
        950.0,
        220.0
      ],
      [
        780.0,
        930.0,
        313.3333435058594
      ],
      [
        780.0,
        930.0,
        313.33331298828125
      ],
      [
        780.0,
        747.9248657226562,
        313.3333435058594
      ],
      [
        780.0,
        950.0,
        140.0
      ],
      [
        780.0,
        721.7157592773438,
        140.0
      ],
      [
        854.0377807617188,
        707.730224609375,
        140.0
      ],
      [
        950.0,
        803.6924438476562,
        140.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      [
        950.0,
        803.6924438476562,
        118.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        120.0
      ],
      [
        950.0,
        803.6924438476562,
        120.0
      ],
      [
        780.0,
        710.0,
        118.0
      ],
      [
        780.0,
        950.0,
        118.0
      ],
      [
        490.0,
        1090.0,
        160.0
      ],
      [
        490.0,
        1090.0,
        120.0
      ],
      [
        490.0,
        1000.0,
        160.0
      ],
      [
        490.0,
        980.0,
        160.0
      ],
      [
        490.0,
        1110.0,
        160.0
      ],
      [
        490.0,
        1110.0,
        190.0
      ],
      [
        490.0,
        1110.0,
        120.0
      ],
      [
        490.0,
        1110.0,
        100.0
      ],
      [
        490.0,
        1110.0,
        160.0
      ],
      [
        490.0,
        1090.0,
        160.0
      ],
      [
        500.0,
        1090.0,
        160.0
      ],
      [
        500.0,
        1090.0,
        120.0
      ],
      [
        500.0,
        1000.0,
        160.0
      ],
      [
        500.0,
        980.0,
        160.0
      ],
      [
        500.0,
        1110.0,
        160.0
      ],
      [
        500.0,
        1110.0,
        190.0
      ],
      [
        500.0,
        1110.0,
        120.0
      ],
      [
        500.0,
        1110.0,
        100.0
      ],
      [
        500.0,
        1110.0,
        160.0
      ],
      [
        500.0,
        1090.0,
        160.0
      ],
      [
        717.8607788085938,
        1280.0,
        140.0
      ],
      [
        717.8607788085938,
        1280.0,
        160.0
      ],
      [
        717.8607788085938,
        1280.0,
        520.0
      ],
      [
        717.8607788085938,
        1280.0,
        550.0
      ],
      [
        717.8607788085938,
        1280.0,
        100.0
      ],
      [
        717.8607788085938,
        1280.0,
        140.0
      ],
      [
        717.8607788085938,
        1280.0,
        160.0
      ],
      [
        717.8607788085938,
        1280.0,
        520.0
      ],
      [
        662.6244506835938,
        1110.0,
        160.0
      ],
      [
        662.6243896484375,
        1110.0,
        190.0
      ],
      [
        662.6243896484375,
        1110.0,
        120.0
      ],
      [
        662.6244506835938,
        1110.0,
        100.0
      ],
      [
        656.1259765625,
        1090.0,
        160.0
      ],
      [
        656.1259765625,
        1090.0,
        120.0
      ],
      [
        626.8832397460938,
        1000.0,
        160.0
      ],
      [
        620.3848876953125,
        980.0,
        160.0
      ],
      [
        662.6243896484375,
        1110.0,
        160.0
      ],
      [
        656.1259765625,
        1090.0,
        160.0
      ],
      [
        700.0,
        1110.0,
        120.0
      ],
      [
        700.0,
        1110.0,
        100.0
      ],
      [
        776.0,
        1130.0,
        108.0
      ],
      [
        776.0,
        1122.0,
        108.0
      ],
      [
        776.0,
        1122.0,
        108.0
      ],
      [
        776.0,
        1040.0,
        108.0
      ],
      [
        775.0000610351562,
        1130.0,
        110.0
      ],
      [
        776.0,
        1130.0,
        108.0
      ],
      [
        720.0,
        516.0999755859375,
        175.0
      ],
      [
        720.0,
        516.0999755859375,
        145.0
      ],
      [
        760.0,
        516.0999755859375,
        175.0
      ],
      [
        760.0,
        516.0999755859375,
        145.0
      ],
      [
        840.0,
        1310.0,
        180.08523559570312
      ],
      [
        840.0,
        1330.0,
        180.085205078125
      ],
      [
        840.0,
        1330.0,
        180.085205078125
      ],
      [
        840.0,
        1460.0,
        180.085205078125
      ],
      [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      [
        840.0,
        1330.0,
        180.085205078125
      ],
      [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      [
        840.0,
        1460.0,
        180.085205078125
      ],
      [
        840.0,
        1310.0,
        120.0
      ],
      [
        840.0,
        1310.0,
        100.0
      ],
      [
        840.0,
        1310.0,
        180.08523559570312
      ],
      [
        840.0,
        1310.0,
        180.00003051757812
      ],
      [
        840.0,
        1330.0,
        180.0
      ],
      [
        840.0,
        1330.0,
        180.085205078125
      ],
      [
        854.056884765625,
        1310.0,
        180.0
      ],
      [
        840.0,
        1310.0,
        180.0
      ],
      [
        840.0,
        1330.0,
        180.0
      ],
      [
        854.056884765625,
        1330.0,
        180.0
      ],
      [
        929.0144653320312,
        1330.0,
        180.0
      ],
      [
        929.0144653320312,
        1330.0,
        100.0
      ],
      [
        929.0144653320312,
        1330.0,
        180.0
      ],
      [
        840.0,
        1377.18115234375,
        180.0
      ],
      [
        840.0,
        1437.609375,
        180.0
      ],
      [
        840.0,
        1377.18115234375,
        180.0
      ],
      [
        871.1104736328125,
        1400.0,
        140.0
      ],
      [
        840.0,
        1400.0,
        140.0
      ],
      [
        840.0,
        1400.0,
        100.0
      ],
      [
        871.1104736328125,
        1400.0,
        100.0
      ],
      [
        840.0,
        1434.0,
        140.0
      ],
      [
        842.9856567382812,
        1434.0,
        140.0
      ],
      [
        850.0,
        1425.5203857421875,
        140.0
      ],
      [
        840.0,
        1416.0,
        140.0
      ],
      [
        840.0,
        1437.609375,
        140.0
      ],
      [
        840.0,
        1400.0,
        140.0
      ],
      [
        871.1104736328125,
        1400.0,
        140.0
      ],
      [
        840.0,
        1416.0,
        155.0
      ],
      [
        850.0,
        1425.5203857421875,
        155.0
      ],
      [
        842.9856567382812,
        1434.0,
        155.0
      ],
      [
        840.0,
        1434.0,
        155.0
      ],
      [
        840.0,
        1416.0,
        140.0
      ],
      [
        840.0,
        1416.0,
        155.0
      ],
      [
        850.0,
        1425.5203857421875,
        140.0
      ],
      [
        850.0,
        1425.5203857421875,
        155.0
      ],
      [
        840.0,
        1434.0,
        155.0
      ],
      [
        842.9856567382812,
        1434.0,
        155.0
      ],
      [
        842.9856567382812,
        1434.0,
        140.0
      ],
      [
        840.0,
        1434.0,
        140.0
      ],
      [
        890.0,
        1460.0,
        180.0
      ],
      [
        840.0,
        1460.0,
        180.0
      ],
      [
        890.0,
        1460.0,
        140.0
      ],
      [
        890.0,
        1460.0,
        100.0
      ],
      [
        890.0,
        1460.0,
        140.0
      ],
      [
        890.0,
        1460.0,
        180.0
      ],
      [
        840.0,
        1450.0,
        140.0
      ],
      [
        840.0,
        1450.0,
        100.0
      ],
      [
        840.0,
        1450.0,
        140.0
      ],
      [
        840.0,
        1280.0,
        180.0
      ],
      [
        840.0,
        1310.0,
        180.0
      ],
      [
        840.0,
        1280.0,
        120.0
      ],
      [
        840.0,
        1310.0,
        120.0
      ],
      [
        945.5584716796875,
        1310.0,
        160.0
      ],
      [
        960.0,
        1280.0,
        120.0
      ],
      [
        960.0,
        1300.0,
        120.0
      ],
      [
        960.0,
        1300.0,
        120.0
      ],
      [
        980.0,
        1300.0,
        120.0
      ],
      [
        980.0,
        1280.0,
        120.0
      ],
      [
        980.0,
        1300.0,
        120.0
      ],
      [
        820.0,
        1460.0,
        180.0
      ],
      [
        780.0,
        1460.0,
        140.0
      ],
      [
        839.914794921875,
        1460.0,
        180.0
      ],
      [
        839.914794921875,
        1460.0,
        180.0
      ],
      [
        780.0,
        1460.0,
        120.0
      ],
      [
        820.0,
        1460.0,
        120.0
      ],
      [
        780.0,
        1310.0,
        120.08523559570312
      ],
      [
        780.0,
        1400.0,
        120.08523559570312
      ],
      [
        780.0,
        1450.0,
        120.08523559570312
      ],
      [
        780.0,
        1460.0,
        120.0
      ],
      [
        780.0,
        1460.0,
        120.08523559570312
      ],
      [
        839.914794921875,
        1377.18115234375,
        180.0
      ],
      [
        839.914794921875,
        1460.0,
        180.0
      ],
      [
        839.914794921875,
        1377.18115234375,
        180.0
      ],
      [
        839.914794921875,
        1310.0,
        180.0
      ],
      [
        839.914794921875,
        1280.0,
        180.0
      ],
      [
        839.914794921875,
        1310.0,
        180.0
      ],
      [
        820.0,
        1310.0,
        160.08517456054688
      ],
      [
        780.0,
        1310.0,
        120.08523559570312
      ],
      [
        799.914794921875,
        1450.0,
        140.0
      ],
      [
        799.914794921875,
        1400.0,
        140.0
      ],
      [
        780.0,
        1450.0,
        120.08523559570312
      ],
      [
        799.914794921875,
        1450.0,
        140.0
      ],
      [
        840.0,
        1450.0,
        120.0
      ],
      [
        799.914794921875,
        1400.0,
        140.0
      ],
      [
        780.0,
        1400.0,
        120.08523559570312
      ],
      [
        840.0,
        1400.0,
        120.0
      ],
      [
        820.0,
        1310.0,
        160.08517456054688
      ],
      [
        820.0,
        1280.0,
        160.08518981933594
      ],
      [
        820.0,
        1460.0,
        120.0
      ],
      [
        820.0,
        1460.0,
        100.0
      ],
      [
        780.0,
        1460.0,
        140.0
      ],
      [
        820.0,
        1460.0,
        180.0
      ],
      [
        519.3519897460938,
        1550.0,
        120.0
      ],
      [
        640.0,
        1500.0,
        140.0
      ],
      [
        640.0,
        1500.0,
        120.0
      ],
      [
        630.0543823242188,
        1550.0,
        120.0
      ],
      [
        630.0543823242188,
        1550.0,
        140.0
      ],
      [
        820.0,
        1540.0,
        160.08517456054688
      ],
      [
        780.0,
        1540.0,
        120.08523559570312
      ],
      [
        839.914794921875,
        1540.0,
        180.0
      ],
      [
        854.056884765625,
        1540.0,
        180.0
      ],
      [
        854.056884765625,
        1520.0,
        180.0
      ],
      [
        839.914794921875,
        1520.0,
        180.0
      ],
      [
        780.0,
        1520.0,
        120.0
      ],
      [
        794.056884765625,
        1520.0,
        120.0
      ],
      [
        794.056884765625,
        1540.0,
        120.0
      ],
      [
        780.0,
        1520.0,
        120.0
      ],
      [
        780.0,
        1540.0,
        120.08523559570312
      ],
      [
        780.0,
        1520.0,
        120.08523559570312
      ],
      [
        780.0,
        1540.0,
        105.943115234375
      ],
      [
        780.0,
        1530.0,
        105.943115234375
      ],
      [
        790.0,
        1530.0,
        115.94307708740234
      ],
      [
        780.0,
        1530.0,
        105.943115234375
      ],
      [
        790.0,
        1540.0,
        115.94307708740234
      ],
      [
        790.0,
        1530.0,
        115.94307708740234
      ],
      [
        929.0144653320312,
        1520.0,
        180.0
      ],
      [
        929.0144653320312,
        1520.0,
        180.0
      ],
      [
        929.0144653320312,
        1520.0,
        100.0
      ],
      [
        820.0,
        1520.0,
        120.0
      ],
      [
        820.0,
        1520.0,
        120.0
      ],
      [
        820.0,
        1520.0,
        100.0
      ],
      [
        879.382568359375,
        1460.0,
        180.0
      ],
      [
        839.914794921875,
        1460.0,
        180.0
      ],
      [
        839.914794921875,
        1472.8187255859375,
        180.0
      ],
      [
        839.914794921875,
        1472.8187255859375,
        180.0
      ],
      [
        780.0,
        1460.0,
        120.08523559570312
      ],
      [
        839.914794921875,
        1550.0,
        180.0
      ],
      [
        839.914794921875,
        1540.0,
        180.0
      ],
      [
        820.0,
        1550.0,
        160.08517456054688
      ],
      [
        820.0,
        1540.0,
        160.08517456054688
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -6971.595703125,
        -3700.0,
        -300.0
      ],
      "bbox_max": [
        6306.5068359375,
        7558.81884765625,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -2619.10009765625,
        -22.699951171875
      ],
      "bbox_max": [
        -2669.724609375,
        5224.01171875,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.213623046875,
      "bbox_min": [
        -6971.595703125,
        2154.178466796875,
        -22.699951171875
      ],
      "bbox_max": [
        -4912.15185546875,
        4741.15380859375,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6821.484375,
        2758.39404296875,
        -22.699951171875
      ],
      "bbox_max": [
        -5504.7001953125,
        4729.1015625,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6158.31884765625,
        3750.8916015625,
        347.86444091796875
      ],
      "bbox_max": [
        -5532.3203125,
        4687.76513671875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -5573.556640625,
        -2269.10009765625,
        -22.699951171875
      ],
      "bbox_max": [
        -2916.739501953125,
        5224.01171875,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.213623046875,
      "bbox_min": [
        -5573.556640625,
        2154.178466796875,
        -22.699951171875
      ],
      "bbox_max": [
        -4474.53173828125,
        5224.01171875,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5342.23681640625,
        4972.24560546875,
        -11.839128494262695
      ],
      "bbox_max": [
        -5174.01171875,
        5224.01171875,
        157.04071044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5573.556640625,
        4626.0498046875,
        41.128944396972656
      ],
      "bbox_max": [
        -5174.01171875,
        5224.01171875,
        901.1133422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667114257812,
      "bbox_min": [
        -4912.15185546875,
        2154.178466796875,
        0.0
      ],
      "bbox_max": [
        -2916.739501953125,
        4475.62646484375,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        2154.178466796875,
        0.0
      ],
      "bbox_max": [
        -2916.739501953125,
        3191.2431640625,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -5704.54443359375,
        -2329.10009765625,
        124.09432983398438
      ],
      "bbox_max": [
        -2669.724609375,
        5224.01171875,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        2154.178466796875,
        124.09432983398438
      ],
      "bbox_max": [
        -2669.724609375,
        3398.1728515625,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5579.1611328125,
        4617.6630859375,
        671.7749633789062
      ],
      "bbox_max": [
        -5174.01171875,
        5224.01171875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        249.411865234375,
        4951.876953125,
        -33.027774810791016
      ],
      "bbox_max": [
        6306.5068359375,
        7196.82421875,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        943.3017578125,
        4951.876953125,
        0.0
      ],
      "bbox_max": [
        6306.5068359375,
        7196.82421875,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        2769.303955078125,
        4951.876953125,
        0.0
      ],
      "bbox_max": [
        4964.0634765625,
        7185.4150390625,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        2769.303955078125,
        6729.98193359375,
        570.58251953125
      ],
      "bbox_max": [
        3020.6171875,
        7185.4150390625,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        943.3017578125,
        5034.5224609375,
        0.0
      ],
      "bbox_max": [
        3045.157470703125,
        7196.82421875,
        710.5693969726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1201.24462890625,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2021.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -825.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2275.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3594778776168823,
        0.9298421740531921,
        0.07854465395212173
      ],
      "plane_d": -1620.70263671875,
      "bbox_min": [
        -1726.0,
        -2100.0,
        130.0
      ],
      "bbox_max": [
        -800.0,
        2399.27880859375,
        508.155517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112057685852051,
        -0.4043944478034973,
        0.07854446023702621
      ],
      "plane_d": 2450.442138671875,
      "bbox_min": [
        -1699.8333740234375,
        -2100.0,
        130.0
      ],
      "bbox_max": [
        -800.0,
        2381.661376953125,
        508.155517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112057685852051,
        0.4043944180011749,
        0.07854437828063965
      ],
      "plane_d": 557.8760986328125,
      "bbox_min": [
        -1699.8333740234375,
        2340.0,
        130.0
      ],
      "bbox_max": [
        -1661.9405517578125,
        2381.661376953125,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -900.0,
        -2100.0,
        287.1609191894531
      ],
      "bbox_max": [
        -800.0,
        -1855.504150390625,
        508.155517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        650.0,
        -2850.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1600.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        650.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -800.0,
        -2598.9130859375,
        0.0
      ],
      "bbox_max": [
        650.0,
        -1371.68505859375,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -800.0,
        -2500.0,
        0.0
      ],
      "bbox_max": [
        0.0,
        -1371.68505859375,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        252.5999755859375
      ],
      "bbox_max": [
        650.0,
        -1600.0,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        1284.1875
      ],
      "bbox_max": [
        650.0,
        -2378.125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        -309.5,
        460.0,
        60.0
      ],
      "bbox_max": [
        2130.0,
        2050.0,
        1180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        1550.0,
        1830.0,
        120.0
      ],
      "bbox_max": [
        2025.0,
        2050.0,
        1180.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1550.0,
        1830.0,
        140.0
      ],
      "bbox_max": [
        1588.2843017578125,
        2050.0,
        1060.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -326.482421875,
      "bbox_min": [
        1550.0001220703125,
        2011.7158203125,
        500.0
      ],
      "bbox_max": [
        1588.2843017578125,
        2050.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        -0.24771343171596527,
        -0.0
      ],
      "plane_d": 2410.359130859375,
      "bbox_min": [
        1660.0,
        1830.0,
        320.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2740.887451171875,
      "bbox_min": [
        1660.0,
        1830.0,
        320.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        1660.0,
        1830.0,
        320.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1668.9998779296875,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2011.0,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 9.8994140625,
      "bbox_min": [
        1909.74462890625,
        1895.74462890625,
        980.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1668.9998779296875,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1704.19970703125,
        1865.1998291015625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 319.9999694824219,
      "bbox_min": [
        1692.8388671875,
        1830.0,
        320.0
      ],
      "bbox_max": [
        1864.1424560546875,
        1845.0643310546875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9679223895072937,
        0.251249760389328,
        0.0
      ],
      "plane_d": 1178.7496337890625,
      "bbox_min": [
        1692.8388671875,
        1830.0,
        340.0
      ],
      "bbox_max": [
        1705.76611328125,
        1845.0643310546875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        1692.8388671875,
        1830.0,
        340.0
      ],
      "bbox_max": [
        1705.76611328125,
        1845.0643310546875,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1550.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        2020.0,
        2050.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -326.482421875,
      "bbox_min": [
        1550.0001220703125,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        2020.0,
        2050.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        -0.24771343171596527,
        -0.0
      ],
      "plane_d": 2410.359130859375,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        2020.0,
        1891.7369384765625,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1973.3603515625,
        1891.7369384765625,
        1130.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.25882136821746826,
        -0.9659252762794495,
        6.868348805255664e-07
      ],
      "plane_d": 1310.7298583984375,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1892.9427490234375,
        1850.0001220703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588171064853668,
        -0.9659263491630554,
        6.86823625528632e-07
      ],
      "plane_d": 2263.1865234375,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1892.9427490234375,
        1850.0001220703125,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1852.5001220703125,
        1841.2916259765625,
        1110.0
      ],
      "bbox_max": [
        1873.0001220703125,
        1848.516845703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882038474082947,
        0.0
      ],
      "plane_d": 1311.42626953125,
      "bbox_min": [
        1852.5001220703125,
        1846.6507568359375,
        1110.0
      ],
      "bbox_max": [
        1853.0001220703125,
        1848.516845703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1892.9427490234375,
        1846.6507568359375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1872.5,
        1846.6507568359375,
        1115.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882038474082947,
        0.0
      ],
      "plane_d": 1311.42626953125,
      "bbox_min": [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1846.6507568359375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1689.9998779296875,
      "bbox_min": [
        -309.5,
        460.0,
        60.0
      ],
      "bbox_max": [
        2110.0,
        1830.0001220703125,
        1180.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        365.8096618652344,
        1689.9998779296875,
        120.0
      ],
      "bbox_max": [
        2025.0,
        1830.0001220703125,
        1180.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.1961161494255066,
        0.0,
        0.980580747127533
      ],
      "plane_d": 45.106719970703125,
      "bbox_min": [
        365.8096618652344,
        1689.9998779296875,
        140.0
      ],
      "bbox_max": [
        1655.0,
        1830.0001220703125,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        365.8096618652344,
        1689.9998779296875,
        140.0
      ],
      "bbox_max": [
        1655.0,
        1830.0001220703125,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        8.719300694792764e-07,
        0.0
      ],
      "plane_d": 1549.9984130859375,
      "bbox_min": [
        1549.9998779296875,
        1689.9998779296875,
        350.0
      ],
      "bbox_max": [
        1550.0,
        1830.0,
        390.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        365.8096618652344,
        1690.0,
        140.0
      ],
      "bbox_max": [
        1645.0,
        1830.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        365.8096618652344,
        1690.0,
        240.0
      ],
      "bbox_max": [
        450.0,
        1719.423583984375,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 230.0,
      "bbox_min": [
        1057.5947265625,
        1690.0,
        190.0
      ],
      "bbox_max": [
        1645.0,
        1830.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1057.5947265625,
        1690.0,
        230.0
      ],
      "bbox_max": [
        1645.0,
        1830.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707106351852417,
        0.0,
        0.7071071863174438
      ],
      "plane_d": 533.21337890625,
      "bbox_min": [
        1057.5947265625,
        1690.0,
        303.5163879394531
      ],
      "bbox_max": [
        1083.078369140625,
        1710.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.662087237898959e-06,
        -0.6000000238418579,
        -0.8000000715255737
      ],
      "plane_d": 1353.9942626953125,
      "bbox_min": [
        1565.0,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1645.0,
        1830.0001220703125,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1565.0,
      "bbox_min": [
        1565.0,
        1790.0,
        320.0
      ],
      "bbox_max": [
        1625.0001220703125,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -3.0517671802954283e-06,
        0.0
      ],
      "plane_d": 1625.005615234375,
      "bbox_min": [
        1625.0,
        1790.0001220703125,
        320.0
      ],
      "bbox_max": [
        1625.0001220703125,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.662132030513021e-06,
        0.6000000238418579,
        -0.8000000715255737
      ],
      "plane_d": -758.006103515625,
      "bbox_min": [
        1625.0,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1645.0,
        1730.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": -1426.6114501953125,
      "bbox_min": [
        1057.5947265625,
        1690.0,
        190.0
      ],
      "bbox_max": [
        1100.0,
        1710.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        778.5,
        1690.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1720.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -778.5,
      "bbox_min": [
        778.5,
        1690.0,
        140.0
      ],
      "bbox_max": [
        778.5,
        1695.0,
        145.16661071777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        1655.0,
        1689.9998779296875,
        220.0
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1060.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.355224609375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 319.9999694824219,
      "bbox_min": [
        1674.6685791015625,
        1690.0,
        220.0
      ],
      "bbox_max": [
        1920.0001220703125,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532833576202393,
        -0.27059581875801086,
        -0.707105815410614
      ],
      "plane_d": 1852.3011474609375,
      "bbox_min": [
        1674.6685791015625,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1783.4312744140625,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        1674.6685791015625,
        1690.0,
        340.0
      ],
      "bbox_max": [
        1703.17041015625,
        1830.0,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9679223895072937,
        -0.251249760389328,
        0.0
      ],
      "plane_d": 2063.14892578125,
      "bbox_min": [
        1674.6685791015625,
        1690.0,
        340.0
      ],
      "bbox_max": [
        1692.8388671875,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9679223895072937,
        0.251249760389328,
        0.0
      ],
      "plane_d": 1178.7496337890625,
      "bbox_min": [
        1674.6685791015625,
        1760.0,
        340.0
      ],
      "bbox_max": [
        1692.8388671875,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5,
        -0.8660253882408142,
        -0.0
      ],
      "plane_d": 2402.55419921875,
      "bbox_min": [
        1778.3494873046875,
        1735.0001220703125,
        220.0
      ],
      "bbox_max": [
        1800.0001220703125,
        1747.5001220703125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        8.719300694792764e-07,
        0.0
      ],
      "plane_d": 1659.9984130859375,
      "bbox_min": [
        1659.9998779296875,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1992.11669921875,
        1830.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1769.84228515625,
        1690.0,
        1060.0
      ],
      "bbox_max": [
        1992.11669921875,
        1830.0,
        1150.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.9659252762794495,
        0.25882136821746826,
        0.0
      ],
      "plane_d": 1408.710205078125,
      "bbox_min": [
        1917.9422607421875,
        1715.0,
        1130.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1760.0001220703125,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659252762794495,
        0.25882136821746826,
        -6.868348805255664e-07
      ],
      "plane_d": 1408.7109375,
      "bbox_min": [
        1769.84228515625,
        1690.0,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        3.2501047826372087e-06
      ],
      "plane_d": 2319.75244140625,
      "bbox_min": [
        1769.84228515625,
        1690.0,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1921.2918701171875,
        1772.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1928.516845703125,
        1793.0001220703125,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1769.84228515625,
        1690.0,
        1060.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        1.87645127880387e-06
      ],
      "plane_d": 143.4998779296875,
      "bbox_min": [
        1769.84228515625,
        1690.0,
        1060.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1830.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1894.150634765625,
        1690.0,
        1110.0
      ],
      "bbox_max": [
        1910.15771484375,
        1705.849365234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2535.23193359375,
      "bbox_min": [
        1894.150634765625,
        1690.0,
        1110.0
      ],
      "bbox_max": [
        1895.3590087890625,
        1691.2083740234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1769.84228515625,
        1690.0,
        1110.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1830.0,
        1115.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2535.23193359375,
      "bbox_min": [
        1805.3590087890625,
        1690.0,
        1110.0
      ],
      "bbox_max": [
        1894.150634765625,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882038474082947,
        0.0
      ],
      "plane_d": 1311.42626953125,
      "bbox_min": [
        1840.0,
        1800.0,
        1110.0
      ],
      "bbox_max": [
        1848.03857421875,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659259915351868,
        0.25881874561309814,
        0.0
      ],
      "plane_d": 1311.4300537109375,
      "bbox_min": [
        1805.3590087890625,
        1690.0,
        1110.0
      ],
      "bbox_max": [
        1820.0,
        1740.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2506.947509765625,
      "bbox_min": [
        1805.3590087890625,
        1725.3590087890625,
        1110.0
      ],
      "bbox_max": [
        1820.0,
        1740.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        -309.5,
        460.0,
        60.0
      ],
      "bbox_max": [
        2110.0,
        1690.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        2110.0,
        1690.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        2025.0,
        1690.0,
        1180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6532833576202393,
        -0.27059581875801086,
        -0.707105815410614
      ],
      "plane_d": 1852.3011474609375,
      "bbox_min": [
        1692.8388671875,
        1674.9356689453125,
        337.5488586425781
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9679223895072937,
        -0.251249760389328,
        0.0
      ],
      "plane_d": 2063.14892578125,
      "bbox_min": [
        1692.8388671875,
        1674.9356689453125,
        340.0
      ],
      "bbox_max": [
        1705.76611328125,
        1690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        1692.8388671875,
        1674.9356689453125,
        340.0
      ],
      "bbox_max": [
        1705.76611328125,
        1690.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1973.3599853515625,
        1690.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        1.87645127880387e-06
      ],
      "plane_d": 143.4998779296875,
      "bbox_min": [
        1807.0,
        1670.0,
        1060.0
      ],
      "bbox_max": [
        1973.3599853515625,
        1690.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1895.3590087890625,
        1683.941650390625,
        1110.0
      ],
      "bbox_max": [
        1973.3599853515625,
        1690.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2535.23193359375,
      "bbox_min": [
        1895.3590087890625,
        1689.84228515625,
        1110.0
      ],
      "bbox_max": [
        1895.6744384765625,
        1690.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1895.3590087890625,
        1689.84228515625,
        1110.0
      ],
      "bbox_max": [
        1895.6744384765625,
        1690.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1807.0,
        1670.0,
        1110.0
      ],
      "bbox_max": [
        1892.9422607421875,
        1690.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1807.0,
        1671.4832763671875,
        1110.0
      ],
      "bbox_max": [
        1831.9615478515625,
        1690.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659259915351868,
        0.25881874561309814,
        0.0
      ],
      "plane_d": 1311.4300537109375,
      "bbox_min": [
        1807.0,
        1676.84228515625,
        1110.0
      ],
      "bbox_max": [
        1810.525634765625,
        1690.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        -309.5,
        460.0,
        60.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        900.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.0
      ],
      "bbox_max": [
        -100.0,
        1219.021728515625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660252094268799,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.00611877441406
      ],
      "bbox_max": [
        -100.0,
        1219.021728515625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.00611877441406
      ],
      "bbox_max": [
        -109.5,
        1219.021728515625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.00611877441406
      ],
      "bbox_max": [
        -109.5,
        1219.021728515625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.00611877441406
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        210.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -229.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1045.8167724609375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        210.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -229.5,
        971.800048828125,
        225.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241961479187,
        0.5000022649765015,
        -0.0
      ],
      "plane_d": -363.12939453125,
      "bbox_min": [
        -224.5,
        1045.8167724609375,
        225.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241961479187,
        0.5000022649765015,
        -0.0
      ],
      "plane_d": -363.12939453125,
      "bbox_min": [
        -224.5,
        1045.8167724609375,
        210.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -160.0,
        1050.0,
        144.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        120.0,
        460.0,
        60.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        900.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        260.0,
        515.8578491210938,
        60.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        80.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -608.2105102539062,
      "bbox_min": [
        780.0,
        635.8578491210938,
        60.0
      ],
      "bbox_max": [
        1200.0,
        1650.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        780.0,
        635.8578491210938,
        60.0
      ],
      "bbox_max": [
        784.1421508789062,
        650.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1650.0,
        80.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        820.0,
        1310.0,
        64.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        890.0,
        1310.0,
        71.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1472.83544921875,
        71.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1650.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999991655349731,
        0.0013020822079852223
      ],
      "plane_d": 1629.8984375,
      "bbox_min": [
        860.0,
        1615.0,
        77.0
      ],
      "bbox_max": [
        895.0,
        1650.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        895.0,
        1630.0,
        77.0
      ],
      "bbox_max": [
        895.0,
        1650.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        870.0,
        1615.0,
        77.0
      ],
      "bbox_max": [
        890.0,
        1630.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1625.0,
        77.0
      ],
      "bbox_max": [
        890.0,
        1630.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1150.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        78.88888549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        780.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        950.0,
        970.0,
        78.88890075683594
      ],
      "bbox_max": [
        950.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        780.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        900.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        780.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        895.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        780.0,
        1280.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        780.0,
        1310.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        780.0,
        1310.0,
        78.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        780.0,
        1310.0,
        78.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1320.0,
        78.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        78.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        820.0,
        1310.0,
        78.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1400.0,
        78.0
      ],
      "bbox_max": [
        871.1104736328125,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747211158275604,
        0.0,
        -0.9615239500999451
      ],
      "plane_d": -150.27244567871094,
      "bbox_min": [
        820.0,
        1404.0,
        78.0
      ],
      "bbox_max": [
        829.75048828125,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        820.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        827.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        78.0
      ],
      "bbox_max": [
        826.9999389648438,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        78.0
      ],
      "bbox_max": [
        829.75048828125,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        829.75048828125,
        1377.16455078125,
        78.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        829.75048828125,
        1450.0,
        78.0
      ],
      "bbox_max": [
        871.110595703125,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        871.1104736328125,
        1377.16455078125,
        78.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        871.1104736328125,
        1400.0,
        78.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        871.110595703125,
        1450.0,
        78.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15730521082878113,
        0.0,
        -0.9875500798225403
      ],
      "plane_d": -51.96137237548828,
      "bbox_min": [
        820.0,
        1540.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1550.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15730521082878113,
        0.0,
        -0.9875500798225403
      ],
      "plane_d": -51.96137237548828,
      "bbox_min": [
        820.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        780.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        820.0,
        1310.0,
        64.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1400.0,
        64.0
      ],
      "bbox_max": [
        871.1104736328125,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        64.0
      ],
      "bbox_max": [
        829.75048828125,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        829.75048828125,
        1377.16455078125,
        64.97505187988281
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        829.75048828125,
        1450.0,
        64.97505187988281
      ],
      "bbox_max": [
        871.110595703125,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        871.1104736328125,
        1377.16455078125,
        69.11104583740234
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        871.1104736328125,
        1400.0,
        69.11104583740234
      ],
      "bbox_max": [
        890.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        871.110595703125,
        1450.0,
        69.1110610961914
      ],
      "bbox_max": [
        890.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        790.0,
        1310.0,
        61.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        790.0,
        1530.0,
        61.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        260.0,
        515.8578491210938,
        60.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        260.0,
        515.8578491210938,
        60.0
      ],
      "bbox_max": [
        780.0,
        1300.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        740.0,
        595.8578491210938,
        60.0
      ],
      "bbox_max": [
        780.0,
        1300.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        740.0,
        595.8578491210938,
        60.0
      ],
      "bbox_max": [
        760.0,
        1300.0,
        80.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        740.0,
        595.8578491210938,
        78.0
      ],
      "bbox_max": [
        760.0,
        617.2720947265625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        740.0,
        597.2720947265625,
        60.0
      ],
      "bbox_max": [
        760.0,
        630.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.45172518491744995,
        0.892157256603241
      ],
      "plane_d": -381.2560729980469,
      "bbox_min": [
        760.0,
        615.8578491210938,
        60.0
      ],
      "bbox_max": [
        780.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        760.0,
        615.8578491210938,
        60.0
      ],
      "bbox_max": [
        780.0,
        686.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        760.0,
        676.1616821289062,
        78.0
      ],
      "bbox_max": [
        770.0,
        686.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        760.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1300.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        760.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        260.0,
        515.8578491210938,
        60.0
      ],
      "bbox_max": [
        740.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        260.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1144.86669921875,
      "bbox_min": [
        260.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        340.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1240.9998779296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1028.5911865234375,
      "bbox_min": [
        340.0,
        1110.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1240.9998779296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        340.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        1240.9998779296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        340.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        480.0,
        1290.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1300.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        500.0,
        515.8578491210938,
        60.0
      ],
      "bbox_max": [
        740.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        650.0,
        515.8578491210938,
        60.0
      ],
      "bbox_max": [
        740.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        650.0,
        515.8578491210938,
        60.0
      ],
      "bbox_max": [
        730.0,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        689.3480224609375,
        611.4901733398438,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        750.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7072440385818481,
        0.7069695591926575,
        0.0
      ],
      "plane_d": 45.334869384765625,
      "bbox_min": [
        689.698486328125,
        625.8406372070312,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -750.0,
      "bbox_min": [
        720.0,
        750.0,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        575.8578491210938,
        60.0
      ],
      "bbox_max": [
        740.0,
        750.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7072440385818481,
        0.7069695591926575,
        0.0
      ],
      "plane_d": 45.334869384765625,
      "bbox_min": [
        720.0,
        656.1539306640625,
        78.0
      ],
      "bbox_max": [
        740.0,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -750.0,
      "bbox_min": [
        720.0,
        750.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        721.0,
        578.2720947265625,
        60.0
      ],
      "bbox_max": [
        740.0,
        610.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1028.5911865234375,
      "bbox_min": [
        500.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        720.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        720.0,
        940.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        940.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        720.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        940.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        720.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        615.0,
        1130.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        615.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        730.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        625.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        730.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        730.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        730.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        260.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        740.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1570.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        740.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        740.0,
        1570.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        740.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        1440.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        760.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        760.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        760.0,
        1550.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        760.0,
        1550.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1550.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        260.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1690.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        260.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1500.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        260.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1460.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        260.0,
        1459.0001220703125,
        78.0
      ],
      "bbox_max": [
        500.0,
        1460.0,
        78.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1301.3914794921875,
      "bbox_min": [
        260.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1459.0001220703125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        390.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1425.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -429.3250427246094,
      "bbox_min": [
        400.0,
        1309.0,
        78.0
      ],
      "bbox_max": [
        441.0,
        1416.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -109.1201171875,
      "bbox_min": [
        400.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1415.9998779296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -429.3250427246094,
      "bbox_min": [
        441.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1425.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        260.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1459.0001220703125,
        80.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        260.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1440.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        400.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -109.1201171875,
      "bbox_min": [
        400.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1425.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1424.9998779296875,
      "bbox_min": [
        400.0,
        1425.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1425.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        500.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        730.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        500.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        500.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        550.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        1690.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        500.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        721.0000610351562,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        500.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        721.0000610351562,
        1460.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        500.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1449.9998779296875,
      "bbox_min": [
        500.0,
        1450.0,
        78.0
      ],
      "bbox_max": [
        504.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        720.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        -0.0,
        0.8944272398948669
      ],
      "plane_d": -295.1610107421875,
      "bbox_min": [
        500.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        540.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1439.9998779296875,
      "bbox_min": [
        500.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        540.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1449.9998779296875,
      "bbox_min": [
        500.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        540.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1690.0,
        80.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        720.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1420.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        120.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        900.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 997.0205688476562,
      "bbox_min": [
        1480.0,
        1480.0,
        120.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1547.9998779296875,
        1480.0,
        138.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1480.0,
        1480.0,
        120.0
      ],
      "bbox_max": [
        1547.9998779296875,
        1690.0,
        179.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 176.99998474121094,
      "bbox_min": [
        1480.0,
        1610.0,
        138.0
      ],
      "bbox_max": [
        1500.0,
        1690.0,
        179.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1480.0,
        1610.0,
        177.0
      ],
      "bbox_max": [
        1488.300048828125,
        1610.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        1480.0,
        1610.0,
        138.0
      ],
      "bbox_max": [
        1500.0,
        1610.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1480.0,
        1500.0,
        120.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        120.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        900.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1000.0,
        126.0
      ],
      "bbox_max": [
        260.0,
        1460.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        210.0,
        1240.0,
        190.0
      ],
      "bbox_max": [
        260.0,
        1460.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        230.0,
        1460.0,
        240.0
      ],
      "bbox_max": [
        260.0,
        1460.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        260.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        900.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        260.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1690.0,
        460.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1414.9998779296875,
      "bbox_min": [
        260.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1460.0,
        460.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        260.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        460.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        260.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        260.0,
        1240.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        340.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        310.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -806.1017456054688,
      "bbox_min": [
        310.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -183.8477783203125,
      "bbox_min": [
        430.0000305175781,
        1310.0,
        170.0000457763672
      ],
      "bbox_max": [
        440.0,
        1320.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1340.0,
      "bbox_min": [
        310.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -183.8477783203125,
      "bbox_min": [
        400.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1340.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        400.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1340.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        400.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        400.0,
        1340.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 1124.2998046875,
      "bbox_min": [
        310.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -183.8477783203125,
      "bbox_min": [
        435.0,
        1410.0,
        175.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        310.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        210.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -185.0,
      "bbox_min": [
        330.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -183.8477783203125,
      "bbox_min": [
        400.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        400.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        400.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1370.0,
      "bbox_min": [
        330.0,
        1350.0,
        185.0
      ],
      "bbox_max": [
        440.0,
        1380.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1350.0,
      "bbox_min": [
        330.0,
        1350.0,
        185.0
      ],
      "bbox_max": [
        440.0,
        1360.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -330.0,
      "bbox_min": [
        330.0,
        1350.0,
        185.0
      ],
      "bbox_max": [
        330.0,
        1360.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -330.0,
      "bbox_min": [
        330.0,
        1370.0,
        185.0
      ],
      "bbox_max": [
        330.0,
        1380.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        310.0,
        1340.0,
        190.0
      ],
      "bbox_max": [
        310.0,
        1390.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        440.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        440.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        440.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        440.0,
        980.0,
        98.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        440.0,
        1110.0,
        98.0
      ],
      "bbox_max": [
        450.0,
        1110.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        440.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        440.0,
        980.0,
        160.0
      ],
      "bbox_max": [
        450.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        440.0,
        1090.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1110.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        440.0,
        1090.0,
        160.0
      ],
      "bbox_max": [
        450.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        440.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5449883937835693,
        0.0,
        -0.8384436964988708
      ],
      "plane_d": -168.5271759033203,
      "bbox_min": [
        440.0,
        1310.0,
        85.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        440.0,
        1320.0,
        85.0
      ],
      "bbox_max": [
        450.0,
        1405.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1405.0,
      "bbox_min": [
        440.0,
        1405.0,
        85.0
      ],
      "bbox_max": [
        450.0,
        1405.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        300.0,
        1415.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        360.0,
        1415.0,
        190.0
      ],
      "bbox_max": [
        360.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1424.9998779296875,
      "bbox_min": [
        400.0,
        1415.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1425.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        440.0,
        1415.0,
        100.0
      ],
      "bbox_max": [
        444.0,
        1425.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        440.0,
        1415.0,
        98.0
      ],
      "bbox_max": [
        450.0,
        1425.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        444.0,
        1415.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1425.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4490928053855896,
        -0.08933013677597046,
        0.8890084028244019
      ],
      "plane_d": -285.03179931640625,
      "bbox_min": [
        260.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1690.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        348.0,
        1495.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1690.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        348.0,
        1495.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1600.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        348.0,
        1510.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1600.0,
        105.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -350.0,
      "bbox_min": [
        350.0,
        1535.0,
        95.0
      ],
      "bbox_max": [
        350.0,
        1565.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1520.0,
      "bbox_min": [
        348.0,
        1520.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1600.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        348.0,
        1529.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1600.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -389.0,
      "bbox_min": [
        348.0,
        1529.0,
        80.0
      ],
      "bbox_max": [
        389.0,
        1555.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -350.0,
      "bbox_min": [
        348.0,
        1529.0,
        80.0
      ],
      "bbox_max": [
        389.0,
        1555.0,
        95.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -348.0,
      "bbox_min": [
        348.0,
        1540.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1544.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.0,
        0.8944272994995117
      ],
      "plane_d": -231.65667724609375,
      "bbox_min": [
        348.0,
        1540.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1544.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -81.5,
      "bbox_min": [
        381.0,
        1530.1282958984375,
        80.0
      ],
      "bbox_max": [
        389.0,
        1545.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1530.1282958984375,
      "bbox_min": [
        381.0,
        1530.1282958984375,
        80.0
      ],
      "bbox_max": [
        389.0,
        1530.1282958984375,
        81.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9899495244026184,
        -0.0,
        0.1414213627576828
      ],
      "plane_d": -393.6463623046875,
      "bbox_min": [
        384.0,
        1530.1282958984375,
        81.5
      ],
      "bbox_max": [
        386.0,
        1545.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1530.128173828125,
      "bbox_min": [
        384.0,
        1530.1282958984375,
        81.5
      ],
      "bbox_max": [
        386.0,
        1530.1282958984375,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        380.0,
        1495.0,
        95.0
      ],
      "bbox_max": [
        450.0,
        1510.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        425.0,
        1500.0,
        95.0
      ],
      "bbox_max": [
        450.0,
        1510.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        380.0,
        1495.0,
        150.0
      ],
      "bbox_max": [
        450.0,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4657464623451233,
        -0.0,
        0.8849182724952698
      ],
      "plane_d": -421.96630859375,
      "bbox_min": [
        260.0,
        1460.0,
        240.0
      ],
      "bbox_max": [
        450.0,
        1500.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        450.0,
        515.8578491210938,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        100.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.10459312796592712,
        0.04183724895119667,
        0.9936347007751465
      ],
      "plane_d": -20.709434509277344,
      "bbox_min": [
        1030.0,
        640.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1030.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        880.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        1030.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1078.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1030.0,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        1090.0,
        1390.0,
        87.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        87.05882263183594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        1030.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        1030.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1550.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1030.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1030.0,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1460.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1030.0,
        867.8525390625,
        92.5525131225586
      ],
      "bbox_max": [
        1087.4879150390625,
        871.8778076171875,
        98.77336120605469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        1030.0,
        1390.0,
        87.05882263183594
      ],
      "bbox_max": [
        1120.0,
        1460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25640997290611267,
        0.3589743673801422,
        0.8974359035491943
      ],
      "plane_d": -324.3080139160156,
      "bbox_min": [
        1110.0,
        1392.142822265625,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1457.857177734375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25640997290611267,
        -0.3589743673801422,
        0.8974359035491943
      ],
      "plane_d": 698.7689208984375,
      "bbox_min": [
        1110.0,
        1392.142822265625,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1403.7142333984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        1110.0,
        1392.142822265625,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1403.7142333984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05594536289572716,
        0.9790449142456055,
        0.19580897688865662
      ],
      "plane_d": -1320.451904296875,
      "bbox_min": [
        1110.0,
        1392.142822265625,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1396.5714111328125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1120.0,
        1392.7142333984375,
        98.57142639160156
      ],
      "bbox_max": [
        1120.0,
        1396.5714111328125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1109.9998779296875,
      "bbox_min": [
        1110.0,
        1446.2857666015625,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1457.857177734375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05594536289572716,
        -0.9790449142456055,
        0.19580897688865662
      ],
      "plane_d": 1469.8260498046875,
      "bbox_min": [
        1110.0,
        1453.4285888671875,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1457.857177734375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1120.0,
        1453.4285888671875,
        98.57142639160156
      ],
      "bbox_max": [
        1120.0,
        1457.2857666015625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1030.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1030.0,
        1410.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        1030.0,
        1410.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1410.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        450.0,
        515.8578491210938,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        100.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        780.0,
        635.8577880859375,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        780.0,
        635.8577880859375,
        80.0
      ],
      "bbox_max": [
        980.0,
        1650.0,
        100.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        780.0,
        635.8578491210938,
        98.0
      ],
      "bbox_max": [
        980.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        780.0,
        635.8578491210938,
        98.0
      ],
      "bbox_max": [
        784.1421508789062,
        640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 784.1422119140625,
      "bbox_min": [
        780.0,
        658.2842407226562,
        98.0
      ],
      "bbox_max": [
        784.1422119140625,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826822340488434,
        0.9238800406455994,
        0.0
      ],
      "plane_d": -309.68353271484375,
      "bbox_min": [
        780.0,
        658.2842407226562,
        98.0
      ],
      "bbox_max": [
        784.1422119140625,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        780.0,
        707.730224609375,
        98.0
      ],
      "bbox_max": [
        980.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        930.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1120.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        780.0,
        970.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1120.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        950.0,
        970.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -959.9999389648438,
      "bbox_min": [
        960.0,
        1096.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        780.0,
        1280.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1650.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -885.0,
      "bbox_min": [
        885.0,
        1625.0,
        98.0
      ],
      "bbox_max": [
        920.0,
        1650.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1961161345243454,
        0.0,
        0.9805806875228882
      ],
      "plane_d": 79.42704010009766,
      "bbox_min": [
        885.0,
        1625.0,
        98.0
      ],
      "bbox_max": [
        920.0,
        1635.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1634.330078125,
      "bbox_min": [
        912.5,
        1625.669921875,
        98.0
      ],
      "bbox_max": [
        920.0,
        1634.330078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1625.669921875,
      "bbox_min": [
        912.5,
        1625.669921875,
        98.0
      ],
      "bbox_max": [
        920.0,
        1634.330078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -1605.2529296875,
      "bbox_min": [
        912.5,
        1625.669921875,
        98.0
      ],
      "bbox_max": [
        915.0,
        1634.330078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 24.76092529296875,
      "bbox_min": [
        912.5,
        1630.0,
        98.0
      ],
      "bbox_max": [
        915.0,
        1634.330078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        885.0,
        1625.0,
        98.0
      ],
      "bbox_max": [
        905.0,
        1635.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1635.0,
      "bbox_min": [
        895.0,
        1635.0,
        98.0
      ],
      "bbox_max": [
        905.0,
        1635.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1280.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        780.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        820.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1400.0,
        98.0
      ],
      "bbox_max": [
        871.1104736328125,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        98.0
      ],
      "bbox_max": [
        829.75048828125,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        829.75048828125,
        1377.16455078125,
        98.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        829.75048828125,
        1450.0,
        98.0
      ],
      "bbox_max": [
        871.110595703125,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211158275604,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 148.34939575195312,
      "bbox_min": [
        871.1104736328125,
        1377.16455078125,
        98.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        882.9999389648438,
        1377.16455078125,
        98.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        882.9999389648438,
        1400.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        882.9999389648438,
        1400.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1400.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        882.9999389648438,
        1450.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        871.1104736328125,
        1400.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        871.110595703125,
        1450.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        780.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1320.0,
        98.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        98.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15730521082878113,
        0.0,
        0.9875500798225403
      ],
      "plane_d": 49.98626708984375,
      "bbox_min": [
        933.0026245117188,
        1540.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1550.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15730521082878113,
        0.0,
        0.9875500798225403
      ],
      "plane_d": 49.98627471923828,
      "bbox_min": [
        933.0026245117188,
        1280.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1280.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        780.0,
        635.8578491210938,
        80.0
      ],
      "bbox_max": [
        980.0,
        1650.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        885.0,
        1630.00390625,
        80.0
      ],
      "bbox_max": [
        895.0,
        1650.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.47058823704719543,
        0.8823529481887817
      ],
      "plane_d": -855.88232421875,
      "bbox_min": [
        885.0,
        1635.0,
        90.0
      ],
      "bbox_max": [
        895.0,
        1650.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -885.0,
      "bbox_min": [
        885.0,
        1635.0,
        90.0
      ],
      "bbox_max": [
        885.0,
        1650.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        870.0,
        1615.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1630.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -87.0,
      "bbox_min": [
        870.0,
        1625.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1630.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1625.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1630.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        780.0,
        635.8578491210938,
        80.0
      ],
      "bbox_max": [
        980.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        780.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        980.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        960.0,
        1120.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        780.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        950.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        820.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211158275604,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 148.34939575195312,
      "bbox_min": [
        820.0,
        1400.0,
        80.0
      ],
      "bbox_max": [
        871.1104736328125,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1400.0,
        80.0
      ],
      "bbox_max": [
        871.1104736328125,
        1450.0,
        94.6030044555664
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        820.0,
        1440.0,
        80.0
      ],
      "bbox_max": [
        838.0225219726562,
        1450.0,
        85.1492919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        80.0
      ],
      "bbox_max": [
        829.75048828125,
        1450.0,
        82.7858657836914
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        826.9999389648438,
        1450.0,
        80.0
      ],
      "bbox_max": [
        829.75048828125,
        1450.0,
        80.7858657836914
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1400.0,
        80.0
      ],
      "bbox_max": [
        871.1104736328125,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        80.0
      ],
      "bbox_max": [
        829.75048828125,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        829.75048828125,
        1377.16455078125,
        80.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        829.75048828125,
        1424.9998779296875,
        80.0
      ],
      "bbox_max": [
        871.110595703125,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211158275604,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 148.34939575195312,
      "bbox_min": [
        838.0225219726562,
        1424.9998779296875,
        83.14928436279297
      ],
      "bbox_max": [
        862.8385620117188,
        1440.0,
        92.23958587646484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747211158275604,
        0.0,
        -0.9615239500999451
      ],
      "plane_d": -150.27244567871094,
      "bbox_min": [
        838.0225219726562,
        1424.9998779296875,
        83.14928436279297
      ],
      "bbox_max": [
        862.8385620117188,
        1440.0,
        92.23958587646484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        838.0225219726562,
        1440.0,
        83.14928436279297
      ],
      "bbox_max": [
        862.8385620117188,
        1440.0,
        92.23958587646484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211158275604,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 148.34939575195312,
      "bbox_min": [
        850.4305419921875,
        1400.0,
        88.69444274902344
      ],
      "bbox_max": [
        890.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        862.8385620117188,
        1400.0,
        90.23957824707031
      ],
      "bbox_max": [
        890.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        871.1104736328125,
        1400.0,
        92.60299682617188
      ],
      "bbox_max": [
        890.0,
        1400.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        871.110595703125,
        1450.0,
        92.60302734375
      ],
      "bbox_max": [
        890.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        871.1104736328125,
        1400.0,
        94.60298919677734
      ],
      "bbox_max": [
        882.9999389648438,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        871.1104736328125,
        1377.16455078125,
        80.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        871.1104736328125,
        1400.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        871.110595703125,
        1450.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1320.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15730521082878113,
        0.0,
        -0.9875500798225403
      ],
      "plane_d": -51.96137237548828,
      "bbox_min": [
        820.0,
        1540.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15730521082878113,
        0.0,
        0.9875500798225403
      ],
      "plane_d": 49.98626708984375,
      "bbox_min": [
        820.0,
        1540.0,
        80.0
      ],
      "bbox_max": [
        933.0026245117188,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15730521082878113,
        0.0,
        -0.9875500798225403
      ],
      "plane_d": -51.96137237548828,
      "bbox_min": [
        820.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15730521082878113,
        0.0,
        0.9875500798225403
      ],
      "plane_d": 49.98627471923828,
      "bbox_min": [
        820.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        933.0026245117188,
        1310.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15643525123596191,
        0.0,
        0.9876882433891296
      ],
      "plane_d": 49.22123718261719,
      "bbox_min": [
        858.0009765625,
        1299.0,
        86.0599136352539
      ],
      "bbox_max": [
        867.8778686523438,
        1309.0,
        87.624267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        980.0,
        640.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1010.0,
        640.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        100.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1010.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1010.0,
        863.6924438476562,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        1010.0,
        863.6924438476562,
        98.0
      ],
      "bbox_max": [
        1020.0,
        868.3529663085938,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1013.9887084960938,
        867.8525390625,
        98.0
      ],
      "bbox_max": [
        1020.0,
        868.3529663085938,
        98.77336120605469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        1010.0,
        863.6924438476562,
        98.31112670898438
      ],
      "bbox_max": [
        1014.1600952148438,
        867.8525390625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        1010.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        1010.0,
        1460.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1640.0,
      "bbox_min": [
        1010.0,
        1640.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1010.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1410.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1010.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1020.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        1020.0,
        1410.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1020.0,
        1410.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        1020.0,
        1440.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1640.0,
      "bbox_min": [
        1020.0,
        1640.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1020.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1260.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        1020.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        868.3529663085938,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1020.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1020.0,
        867.8525390625,
        98.0
      ],
      "bbox_max": [
        1030.0,
        868.3529663085938,
        98.77336120605469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1260.0,
      "bbox_min": [
        1020.0,
        1260.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1260.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10459312796592712,
        0.04183724895119667,
        0.9936347007751465
      ],
      "plane_d": -20.709434509277344,
      "bbox_min": [
        1010.0,
        640.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1010.0,
        870.6498413085938,
        80.0
      ],
      "bbox_max": [
        1030.0,
        880.0,
        92.5525131225586
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        1010.0,
        870.6498413085938,
        80.0
      ],
      "bbox_max": [
        1012.3585205078125,
        880.0,
        90.64350891113281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1010.0,
        863.9695434570312,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        1010.0,
        863.9695434570312,
        90.49895477294922
      ],
      "bbox_max": [
        1013.9887084960938,
        873.113037109375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        640.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1690.0,
        100.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        980.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1640.0,
        100.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        980.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        980.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        980.0,
        1160.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1160.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        1000.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        1000.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 532.1842041015625,
      "bbox_min": [
        1000.0,
        860.8922729492188,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        1000.0,
        1410.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1000.0,
        1410.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        1000.0,
        1440.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1640.0,
      "bbox_min": [
        1000.0,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        1000.0,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1003.75,
        1620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1000.0,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1003.75,
        1620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1000.0,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1003.75,
        1610.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        1000.0,
        860.8922729492188,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1300.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        1007.1998291015625,
        860.8922729492188,
        98.0
      ],
      "bbox_max": [
        1010.0,
        863.9695434570312,
        98.31112670898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        980.0,
        640.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        980.0,
        640.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        640.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 532.1842041015625,
      "bbox_min": [
        980.0,
        833.6924438476562,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 999.9999389648438,
      "bbox_min": [
        1000.0,
        1350.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1390.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1361.5,
      "bbox_min": [
        1000.0,
        1361.5,
        83.74996948242188
      ],
      "bbox_max": [
        1010.0,
        1361.5,
        85.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1361.5,
      "bbox_min": [
        1000.0,
        1361.5,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1361.5,
        83.74996948242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        980.0,
        833.6924438476562,
        94.97779846191406
      ],
      "bbox_max": [
        1007.1998291015625,
        860.8922729492188,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        450.0,
        515.8578491210938,
        80.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        450.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        500.0,
        1690.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        450.0,
        1110.0,
        98.0
      ],
      "bbox_max": [
        500.0,
        1690.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 1745.3179931640625,
      "bbox_min": [
        450.0,
        1110.0,
        98.0
      ],
      "bbox_max": [
        460.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        450.0,
        1110.0,
        98.0
      ],
      "bbox_max": [
        460.0,
        1425.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1425.0,
      "bbox_min": [
        450.0,
        1425.0,
        98.0
      ],
      "bbox_max": [
        460.0,
        1425.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 1745.3179931640625,
      "bbox_min": [
        460.0,
        1110.0,
        98.0
      ],
      "bbox_max": [
        500.0,
        1688.0108642578125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        460.0,
        1110.0,
        98.0
      ],
      "bbox_max": [
        500.0,
        1110.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 1745.3179931640625,
      "bbox_min": [
        450.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        500.0,
        1690.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5449883937835693,
        0.0,
        -0.8384436964988708
      ],
      "plane_d": -168.5271759033203,
      "bbox_min": [
        450.0,
        1310.0,
        91.5
      ],
      "bbox_max": [
        460.0,
        1415.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1405.0,
      "bbox_min": [
        450.0,
        1320.0,
        91.5
      ],
      "bbox_max": [
        460.0,
        1415.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1415.0,
      "bbox_min": [
        450.0,
        1415.0,
        91.5
      ],
      "bbox_max": [
        460.0,
        1415.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        450.0,
        1320.0,
        91.5
      ],
      "bbox_max": [
        460.0,
        1320.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        500.0,
        515.8578491210938,
        80.0
      ],
      "bbox_max": [
        720.0,
        1394.3714599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        660.0,
        515.8578491210938,
        80.0
      ],
      "bbox_max": [
        720.0,
        604.2505493164062,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        677.8394165039062,
        540.836669921875,
        98.0
      ],
      "bbox_max": [
        720.0,
        604.2505493164062,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7063384652137756,
        0.7078742384910583,
        0.0
      ],
      "plane_d": 80.83029174804688,
      "bbox_min": [
        677.8394165039062,
        562.1814575195312,
        98.0
      ],
      "bbox_max": [
        720.0,
        604.2505493164062,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257304906845093,
        0.7236071825027466,
        0.44721391797065735
      ],
      "plane_d": -740.1129150390625,
      "bbox_min": [
        521.9630737304688,
        1217.4046630859375,
        80.0
      ],
      "bbox_max": [
        720.0,
        1394.3714599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257307887077332,
        0.72360759973526,
        0.4472127854824066
      ],
      "plane_d": -1386.7620849609375,
      "bbox_min": [
        579.4630737304688,
        1217.4046630859375,
        80.0
      ],
      "bbox_max": [
        720.0,
        1394.3714599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1282.9407958984375,
      "bbox_min": [
        579.4630737304688,
        1217.4046630859375,
        80.0
      ],
      "bbox_max": [
        720.0,
        1394.3714599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506506085395813,
        -0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": -301.5865478515625,
      "bbox_min": [
        699.5303955078125,
        1217.4046630859375,
        80.0
      ],
      "bbox_max": [
        720.0,
        1352.5953369140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506503105163574,
        0.2763932943344116,
        0.4472144842147827
      ],
      "plane_d": -1011.917236328125,
      "bbox_min": [
        699.5303955078125,
        1285.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1352.5953369140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        500.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        -0.5555698871612549,
        0.0
      ],
      "plane_d": 1393.865478515625,
      "bbox_min": [
        500.0,
        1500.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        660.0,
        1640.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -660.0,
      "bbox_min": [
        660.0,
        1640.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 270.395751953125,
      "bbox_min": [
        685.0,
        1670.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1670.0,
      "bbox_min": [
        685.0,
        1670.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        -0.1950903981924057,
        0.0
      ],
      "plane_d": 920.3382568359375,
      "bbox_min": [
        500.0,
        1500.0,
        80.0
      ],
      "bbox_max": [
        640.0,
        1680.0543212890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555696487426758,
        -0.8314700126647949,
        0.0
      ],
      "plane_d": 1683.560546875,
      "bbox_min": [
        500.0,
        1634.350341796875,
        80.0
      ],
      "bbox_max": [
        584.3502807617188,
        1680.0543212890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 1745.3179931640625,
      "bbox_min": [
        500.0,
        1675.537109375,
        80.0
      ],
      "bbox_max": [
        522.7098388671875,
        1680.0543212890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        740.0,
        595.8578491210938,
        80.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        740.0,
        595.8578491210938,
        80.0
      ],
      "bbox_max": [
        760.0,
        1690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7063384652137756,
        0.7078742384910583,
        0.0
      ],
      "plane_d": 80.83029174804688,
      "bbox_min": [
        740.0,
        624.2071533203125,
        98.0
      ],
      "bbox_max": [
        760.0,
        1670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1670.0,
      "bbox_min": [
        740.0,
        1670.0,
        98.0
      ],
      "bbox_max": [
        760.0,
        1670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        740.0,
        595.8578491210938,
        80.0
      ],
      "bbox_max": [
        760.0,
        615.8578491210938,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        760.0,
        615.8577880859375,
        80.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        760.0,
        644.1637573242188,
        98.0
      ],
      "bbox_max": [
        780.0,
        1570.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7063384652137756,
        0.7078742384910583,
        0.0
      ],
      "plane_d": 80.83029174804688,
      "bbox_min": [
        760.0,
        644.1637573242188,
        98.0
      ],
      "bbox_max": [
        780.0,
        658.2842407226562,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826822340488434,
        0.9238800406455994,
        0.0
      ],
      "plane_d": -309.68353271484375,
      "bbox_min": [
        770.0000610351562,
        654.1421508789062,
        98.0
      ],
      "bbox_max": [
        780.0,
        658.2842407226562,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        760.0,
        615.8578491210938,
        80.0
      ],
      "bbox_max": [
        780.0,
        635.8578491210938,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        720.0,
        575.8578491210938,
        80.0
      ],
      "bbox_max": [
        740.0,
        1315.77685546875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        720.0,
        575.8578491210938,
        98.0
      ],
      "bbox_max": [
        740.0,
        1286.652099609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7063384652137756,
        0.7078742384910583,
        0.0
      ],
      "plane_d": 80.83029174804688,
      "bbox_min": [
        720.0,
        604.2505493164062,
        98.0
      ],
      "bbox_max": [
        740.0,
        1286.652099609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506506085395813,
        -0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": -301.5865478515625,
      "bbox_min": [
        720.0,
        1283.347900390625,
        98.0
      ],
      "bbox_max": [
        720.5368041992188,
        1286.652099609375,
        99.02108764648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506503105163574,
        0.2763932943344116,
        0.4472144842147827
      ],
      "plane_d": -1011.917236328125,
      "bbox_min": [
        720.0,
        1285.0,
        98.0
      ],
      "bbox_max": [
        720.5368041992188,
        1286.652099609375,
        99.02108001708984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506506085395813,
        -0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": -301.5865478515625,
      "bbox_min": [
        720.0,
        575.8578491210938,
        80.0
      ],
      "bbox_max": [
        740.0,
        1315.77685546875,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        720.0,
        1670.0,
        98.0
      ],
      "bbox_max": [
        740.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1670.0,
      "bbox_min": [
        720.0,
        1670.0,
        98.0
      ],
      "bbox_max": [
        740.0,
        1670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        450.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        900.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1030.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        900.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1030.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        429.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1250.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        429.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.08662962168455124,
        0.0,
        0.9962406754493713
      ],
      "plane_d": 8.662956237792969,
      "bbox_min": [
        1250.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1250.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03874197229743004,
        -0.8944270610809326,
        0.4455326497554779
      ],
      "plane_d": 1443.9354248046875,
      "bbox_min": [
        1250.0,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        429.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1258.199951171875,
      "bbox_min": [
        1250.0,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        261.2411804199219
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 176.99998474121094,
      "bbox_min": [
        1468.300048828125,
        1638.430419921875,
        177.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9302632212638855,
        0.0,
        0.36689305305480957
      ],
      "plane_d": 1118.8017578125,
      "bbox_min": [
        1250.0,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        148.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 148.0,
      "bbox_min": [
        1250.0,
        1633.59228515625,
        148.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        148.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1250.0,
        1620.0,
        140.79110717773438
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        429.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1258.199951171875,
      "bbox_min": [
        1250.0,
        1630.0,
        140.79110717773438
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        379.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 176.99998474121094,
      "bbox_min": [
        1468.300048828125,
        1630.0,
        177.0
      ],
      "bbox_max": [
        1480.0,
        1638.9371337890625,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 379.0,
      "bbox_min": [
        1250.0,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 148.0,
      "bbox_min": [
        1250.0,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1258.199951171875,
        1633.9473876953125,
        148.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 176.99998474121094,
      "bbox_min": [
        1250.0,
        1620.0,
        156.46153259277344
      ],
      "bbox_max": [
        1480.0,
        1630.0,
        179.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1350.0,
        1620.0,
        177.0
      ],
      "bbox_max": [
        1350.0,
        1630.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.030754676088690758,
        0.0,
        -0.9995269775390625
      ],
      "plane_d": 117.94418334960938,
      "bbox_min": [
        1250.0,
        1620.0,
        156.46153259277344
      ],
      "bbox_max": [
        1320.0,
        1630.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 157.99998474121094,
      "bbox_min": [
        1300.0,
        1620.0,
        158.0
      ],
      "bbox_max": [
        1320.0,
        1630.0,
        158.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 176.99998474121094,
      "bbox_min": [
        1250.0,
        1610.0,
        156.46153259277344
      ],
      "bbox_max": [
        1480.0,
        1620.0,
        179.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1350.0,
        1610.0,
        177.0
      ],
      "bbox_max": [
        1350.0,
        1620.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.030754676088690758,
        0.0,
        -0.9995269775390625
      ],
      "plane_d": 117.94418334960938,
      "bbox_min": [
        1250.0,
        1610.0,
        156.46153259277344
      ],
      "bbox_max": [
        1320.0,
        1620.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 158.0,
      "bbox_min": [
        1300.0,
        1610.0,
        158.0
      ],
      "bbox_max": [
        1320.0,
        1620.0,
        158.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1250.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        200.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.08662962168455124,
        0.0,
        0.9962406754493713
      ],
      "plane_d": 8.662956237792969,
      "bbox_min": [
        1250.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1250.0,
        1570.0,
        101.43550872802734
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        179.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 157.99998474121094,
      "bbox_min": [
        1266.5,
        1570.0,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        179.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1590.0,
      "bbox_min": [
        1300.0,
        1570.0,
        158.0
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1300.0,
        1570.0,
        158.0
      ],
      "bbox_max": [
        1480.0,
        1590.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 590.4053955078125,
      "bbox_min": [
        1466.5,
        1570.0,
        158.0
      ],
      "bbox_max": [
        1480.0,
        1580.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        1466.5,
        1580.0,
        158.0
      ],
      "bbox_max": [
        1480.0,
        1580.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5350520610809326,
        0.0,
        0.8448190689086914
      ],
      "plane_d": 571.09765625,
      "bbox_min": [
        1300.0,
        1590.0,
        158.0
      ],
      "bbox_max": [
        1360.0,
        1610.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        1320.0,
        1600.0,
        158.0
      ],
      "bbox_max": [
        1360.0,
        1610.0,
        179.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 177.0,
      "bbox_min": [
        1350.0,
        1600.0,
        177.0
      ],
      "bbox_max": [
        1360.0,
        1610.0,
        177.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1300.0,
        1590.0,
        158.0
      ],
      "bbox_max": [
        1300.0,
        1610.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        1266.5,
        1570.0,
        138.0
      ],
      "bbox_max": [
        1470.0,
        1610.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1415.0,
      "bbox_min": [
        1415.0,
        1570.0,
        138.0
      ],
      "bbox_max": [
        1415.0,
        1580.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1266.5,
        1580.0,
        138.0
      ],
      "bbox_max": [
        1415.0,
        1610.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        1270.0,
        1580.0,
        138.0
      ],
      "bbox_max": [
        1415.0,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1415.0,
      "bbox_min": [
        1415.0,
        1580.0,
        138.0
      ],
      "bbox_max": [
        1415.0,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 508.5424499511719,
      "bbox_min": [
        1266.5,
        1580.0,
        138.0
      ],
      "bbox_max": [
        1270.0,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1590.0,
      "bbox_min": [
        1266.5,
        1590.0,
        138.0
      ],
      "bbox_max": [
        1270.0,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 508.5424499511719,
      "bbox_min": [
        1250.0,
        1580.0,
        101.43550872802734
      ],
      "bbox_max": [
        1270.0,
        1598.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1590.0,
      "bbox_min": [
        1250.0,
        1590.0,
        101.43550872802734
      ],
      "bbox_max": [
        1270.0,
        1598.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.46532946825027466,
        0.0,
        -0.885137677192688
      ],
      "plane_d": 679.1281127929688,
      "bbox_min": [
        1250.0,
        1590.0,
        101.43550872802734
      ],
      "bbox_max": [
        1266.508544921875,
        1598.0,
        110.11428833007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1266.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1297.5,
        1570.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8000000715255737,
        0.0,
        0.6000000238418579
      ],
      "plane_d": 918.0001220703125,
      "bbox_min": [
        1290.0,
        1565.0,
        190.0
      ],
      "bbox_max": [
        1297.5,
        1570.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1250.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1266.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1030.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        429.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1200.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1200.0,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1250.0,
        1630.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1200.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1684.594970703125,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 148.0,
      "bbox_min": [
        1200.0,
        1630.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1684.594970703125,
        158.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        0.3826870620250702,
        0.0
      ],
      "plane_d": 510.3482666015625,
      "bbox_min": [
        1220.0,
        1640.0,
        148.0
      ],
      "bbox_max": [
        1240.0,
        1674.14208984375,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1048.28173828125,
      "bbox_min": [
        1220.0,
        1640.0,
        148.0
      ],
      "bbox_max": [
        1240.0,
        1674.14208984375,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        -0.3826870620250702,
        -0.0
      ],
      "plane_d": 1780.869384765625,
      "bbox_min": [
        1234.14208984375,
        1660.0,
        148.0
      ],
      "bbox_max": [
        1240.0,
        1674.14208984375,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1215.0,
        1630.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1670.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        1630.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1660.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1630.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1650.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1650.0,
      "bbox_min": [
        1235.0,
        1650.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1650.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1215.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1630.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1630.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1630.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 156.0,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1250.0,
        1630.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.030754676088690758,
        0.0,
        -0.9995269775390625
      ],
      "plane_d": 117.94418334960938,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1250.0,
        1630.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1215.0,
        1630.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1030.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        429.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.05225301533937454,
        -0.8944270610809326,
        0.4441506266593933
      ],
      "plane_d": 1458.3773193359375,
      "bbox_min": [
        1030.0,
        1620.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9405532479286194,
        0.0,
        0.3396463692188263
      ],
      "plane_d": 934.80517578125,
      "bbox_min": [
        1030.0,
        1620.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        251.81817626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1170.0,
        1633.904052734375,
        148.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        251.81817626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 148.0,
      "bbox_min": [
        1192.6827392578125,
        1633.904052734375,
        148.0
      ],
      "bbox_max": [
        1200.0,
        1640.7330322265625,
        148.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.5947265625,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        121.03141784667969
      ],
      "bbox_max": [
        1057.5947265625,
        1690.0,
        244.21194458007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1057.5947265625,
      "bbox_min": [
        1037.5947265625,
        1648.357666015625,
        158.0
      ],
      "bbox_max": [
        1057.5947265625,
        1690.0,
        244.21194458007812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7241379618644714,
        0.0,
        0.6896552443504333
      ],
      "plane_d": 642.396240234375,
      "bbox_min": [
        1037.5947265625,
        1648.357666015625,
        158.0
      ],
      "bbox_max": [
        1057.5947265625,
        1690.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1037.5947265625,
        1620.0,
        121.03141784667969
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        429.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1057.5947265625,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        121.03141784667969
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        429.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 543.9276733398438,
      "bbox_min": [
        1057.5947265625,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 379.0,
      "bbox_min": [
        1148.2298583984375,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1170.0,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1200.0,
        1685.4576416015625,
        251.81817626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 148.0,
      "bbox_min": [
        1187.731689453125,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1200.0,
        1634.3314208984375,
        148.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707106351852417,
        0.0,
        0.7071071863174438
      ],
      "plane_d": 533.21337890625,
      "bbox_min": [
        1057.5947265625,
        1630.0,
        303.5163879394531
      ],
      "bbox_max": [
        1083.078369140625,
        1690.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.5947265625,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        121.03141784667969
      ],
      "bbox_max": [
        1057.5947265625,
        1657.6171875,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7241379618644714,
        0.0,
        0.6896552443504333
      ],
      "plane_d": 642.396240234375,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        158.0
      ],
      "bbox_max": [
        1057.5947265625,
        1657.6171875,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1057.5947265625,
      "bbox_min": [
        1057.5947265625,
        1620.0,
        190.0
      ],
      "bbox_max": [
        1200.0,
        1630.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1057.5947265625,
        1620.0,
        230.0
      ],
      "bbox_max": [
        1200.0,
        1630.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707106351852417,
        0.0,
        0.7071071863174438
      ],
      "plane_d": 533.21337890625,
      "bbox_min": [
        1057.5947265625,
        1620.0,
        303.5163879394531
      ],
      "bbox_max": [
        1083.078369140625,
        1630.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1542.886962890625,
      "bbox_min": [
        1057.5947265625,
        1620.0,
        190.0
      ],
      "bbox_max": [
        1100.0,
        1630.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1099.9998779296875,
      "bbox_min": [
        1100.0,
        1620.0,
        190.0
      ],
      "bbox_max": [
        1100.0,
        1630.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1057.5947265625,
      "bbox_min": [
        1030.0,
        1610.0,
        114.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 230.0,
      "bbox_min": [
        1057.5947265625,
        1610.0,
        210.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1057.5947265625,
        1610.0,
        230.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707106351852417,
        0.0,
        0.7071071863174438
      ],
      "plane_d": 533.21337890625,
      "bbox_min": [
        1057.5947265625,
        1610.0,
        303.5163879394531
      ],
      "bbox_max": [
        1083.078369140625,
        1620.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1542.886962890625,
      "bbox_min": [
        1057.5947265625,
        1610.0,
        210.0
      ],
      "bbox_max": [
        1100.0,
        1620.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1099.9998779296875,
      "bbox_min": [
        1100.0,
        1610.0,
        210.0
      ],
      "bbox_max": [
        1100.0,
        1620.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1030.0,
        1610.0,
        114.0
      ],
      "bbox_max": [
        1047.5,
        1620.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        1030.0,
        1610.0,
        114.0
      ],
      "bbox_max": [
        1047.5,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47058823704719543,
        0.0,
        0.8823529481887817
      ],
      "plane_d": 382.3529357910156,
      "bbox_min": [
        1030.0,
        1610.0,
        116.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1037.5,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1047.5,
        1620.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1047.5,
      "bbox_min": [
        1047.5,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1047.5,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1200.0,
        1550.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1610.0,
        128.57142639160156
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1200.0,
        1550.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1610.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1200.0,
        1550.0,
        118.0
      ],
      "bbox_max": [
        1238.8043212890625,
        1598.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1235.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1238.8043212890625,
        1598.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1598.0,
      "bbox_min": [
        1235.0,
        1598.0,
        118.0
      ],
      "bbox_max": [
        1238.8043212890625,
        1598.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1200.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1590.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46532946825027466,
        0.0,
        -0.885137677192688
      ],
      "plane_d": 679.1281127929688,
      "bbox_min": [
        1235.0,
        1590.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1598.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1235.0,
        1590.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1598.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1598.0,
      "bbox_min": [
        1235.0,
        1598.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1598.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 508.5424499511719,
      "bbox_min": [
        1235.0,
        1580.0,
        120.0
      ],
      "bbox_max": [
        1250.0,
        1590.0,
        128.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1590.0,
      "bbox_min": [
        1235.0,
        1590.0,
        120.0
      ],
      "bbox_max": [
        1250.0,
        1590.0,
        128.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        1030.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1610.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        1030.0,
        1550.0,
        180.0
      ],
      "bbox_max": [
        1200.0,
        1570.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1030.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1030.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1610.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1030.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1550.0,
        900.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1266.0,
        1469.9998779296875,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        693.0361938476562
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1266.0,
        1469.9998779296875,
        160.0
      ],
      "bbox_max": [
        1290.0,
        1550.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1250.0,
        1469.9998779296875,
        140.0
      ],
      "bbox_max": [
        1266.0,
        1550.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1250.0,
        1320.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1469.9998779296875,
        636.467529296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1250.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1469.9998779296875,
        636.467529296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1250.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1337.320556640625,
        1469.9998779296875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071045637130737,
        0.0,
        -0.7071089744567871
      ],
      "plane_d": 1051.69189453125,
      "bbox_min": [
        1320.0,
        1450.0,
        150.0
      ],
      "bbox_max": [
        1337.320556640625,
        1460.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588188052177429,
        0.0,
        -0.965925931930542
      ],
      "plane_d": 496.18896484375,
      "bbox_min": [
        1320.0,
        1450.0,
        157.3205108642578
      ],
      "bbox_max": [
        1330.0,
        1460.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1350.0,
        1320.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1450.0,
        622.3255004882812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1030.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1460.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1030.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1390.0,
        580.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1175.0,
        1390.0,
        580.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1175.0,
        1390.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1075.0,
        1380.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1380.0,
        390.0852355957031
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1330.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1329.9998779296875,
      "bbox_min": [
        1030.0,
        1330.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1330.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1030.0,
        1380.0,
        370.0852355957031
      ],
      "bbox_max": [
        1050.0,
        1390.0,
        390.0852355957031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        1030.0,
        1280.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1030.0,
        1280.0,
        160.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        1030.0,
        1280.0,
        180.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        1030.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        515.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1090.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        145.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1139.9998779296875,
      "bbox_min": [
        1120.0,
        1390.0,
        101.42857360839844
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        145.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.06913001090288162,
        -0.9678215980529785,
        -0.24195531010627747
      ],
      "plane_d": 1338.8775634765625,
      "bbox_min": [
        1140.0,
        1415.0,
        114.28571319580078
      ],
      "bbox_max": [
        1160.0,
        1435.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913010776042938,
        0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": -1419.4141845703125,
      "bbox_min": [
        1140.0,
        1415.0,
        114.28571319580078
      ],
      "bbox_max": [
        1160.0,
        1435.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211754322052,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 203.293701171875,
      "bbox_min": [
        1140.0,
        1415.0,
        114.28571319580078
      ],
      "bbox_max": [
        1160.0,
        1435.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747208774089813,
        0.0,
        -0.9615241289138794
      ],
      "plane_d": -179.2552032470703,
      "bbox_min": [
        1140.0,
        1415.0,
        114.28571319580078
      ],
      "bbox_max": [
        1160.0,
        1435.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": -1095.374267578125,
      "bbox_min": [
        1140.0,
        1415.0,
        114.28571319580078
      ],
      "bbox_max": [
        1160.0,
        1435.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        -0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": 1322.49658203125,
      "bbox_min": [
        1140.0,
        1432.0,
        114.28571319580078
      ],
      "bbox_max": [
        1160.0,
        1435.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1129.9998779296875,
      "bbox_min": [
        1120.0,
        1390.0,
        101.42857360839844
      ],
      "bbox_max": [
        1140.0,
        1460.0,
        139.2857208251953
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.06912980228662491,
        0.9678215980529785,
        -0.2419552356004715
      ],
      "plane_d": -1419.4136962890625,
      "bbox_min": [
        1120.0,
        1415.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1435.0,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06912980228662491,
        -0.9678215980529785,
        -0.2419552356004715
      ],
      "plane_d": 1338.8778076171875,
      "bbox_min": [
        1120.0,
        1415.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1435.0,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27472153306007385,
        0.0,
        0.9615238904953003
      ],
      "plane_d": 203.29409790039062,
      "bbox_min": [
        1120.0,
        1415.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1435.0,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.274720162153244,
        0.0,
        -0.961524248123169
      ],
      "plane_d": -179.25439453125,
      "bbox_min": [
        1120.0,
        1415.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1435.0,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14543606340885162,
        0.848375678062439,
        0.5090254545211792
      ],
      "plane_d": -1095.3739013671875,
      "bbox_min": [
        1120.0,
        1415.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1435.0,
        116.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14543606340885162,
        -0.848375678062439,
        0.5090254545211792
      ],
      "plane_d": 1322.496826171875,
      "bbox_min": [
        1120.0,
        1432.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1435.0,
        116.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25640997290611267,
        -0.3589743673801422,
        0.8974359035491943
      ],
      "plane_d": 698.7689208984375,
      "bbox_min": [
        1130.0,
        1393.0,
        101.42857360839844
      ],
      "bbox_max": [
        1140.0,
        1460.0,
        139.2857208251953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25640997290611267,
        0.3589743673801422,
        0.8974359035491943
      ],
      "plane_d": -324.3080139160156,
      "bbox_min": [
        1130.0,
        1418.0,
        101.42857360839844
      ],
      "bbox_max": [
        1140.0,
        1460.0,
        119.28571319580078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747208774089813,
        0.0,
        0.9615241289138794
      ],
      "plane_d": 203.29331970214844,
      "bbox_min": [
        1130.0,
        1418.0,
        111.42857360839844
      ],
      "bbox_max": [
        1140.0,
        1432.0,
        114.28571319580078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05594536289572716,
        -0.9790449142456055,
        0.19580897688865662
      ],
      "plane_d": 1469.8260498046875,
      "bbox_min": [
        1130.0,
        1457.0,
        101.42857360839844
      ],
      "bbox_max": [
        1140.0,
        1460.0,
        119.28571319580078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27472153306007385,
        0.0,
        -0.9615238904953003
      ],
      "plane_d": -179.25601196289062,
      "bbox_min": [
        1130.0,
        1395.0,
        136.42857360839844
      ],
      "bbox_max": [
        1140.0,
        1455.0,
        139.2857208251953
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1109.9998779296875,
      "bbox_min": [
        1090.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1460.0,
        133.57144165039062
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.06913010776042938,
        -0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": 1338.877685546875,
      "bbox_min": [
        1090.0,
        1415.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1435.0,
        130.71429443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913018971681595,
        0.9678215980529785,
        -0.24195531010627747
      ],
      "plane_d": -1419.4140625,
      "bbox_min": [
        1090.0,
        1415.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1435.0,
        130.71429443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211754322052,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 203.29367065429688,
      "bbox_min": [
        1090.0,
        1415.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1435.0,
        130.71429443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27472153306007385,
        0.0,
        -0.9615238904953003
      ],
      "plane_d": -179.2559814453125,
      "bbox_min": [
        1090.0,
        1415.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1435.0,
        130.71429443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": -1095.374267578125,
      "bbox_min": [
        1090.0,
        1415.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1435.0,
        110.71428680419922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        -0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": 1322.4967041015625,
      "bbox_min": [
        1090.0,
        1432.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1435.0,
        110.71428680419922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27472153306007385,
        0.0,
        -0.9615238904953003
      ],
      "plane_d": -179.2559814453125,
      "bbox_min": [
        1110.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1460.0,
        133.57144165039062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.06912998855113983,
        -0.9678216576576233,
        -0.2419552356004715
      ],
      "plane_d": 1363.0733642578125,
      "bbox_min": [
        1110.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1460.0,
        133.57144165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913018971681595,
        0.9678215980529785,
        -0.24195531010627747
      ],
      "plane_d": -1395.218505859375,
      "bbox_min": [
        1110.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1460.0,
        133.57144165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25640997290611267,
        0.3589743673801422,
        0.8974359035491943
      ],
      "plane_d": -324.3080139160156,
      "bbox_min": [
        1110.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1460.0,
        113.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25640997290611267,
        -0.3589743673801422,
        0.8974359035491943
      ],
      "plane_d": 698.7689208984375,
      "bbox_min": [
        1110.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1432.0,
        113.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747208774089813,
        0.0,
        0.9615241289138794
      ],
      "plane_d": 203.29335021972656,
      "bbox_min": [
        1110.0,
        1418.0,
        105.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1432.0,
        108.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05594536289572716,
        0.9790449142456055,
        0.19580897688865662
      ],
      "plane_d": -1320.451904296875,
      "bbox_min": [
        1110.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1392.7142333984375,
        113.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05594536289572716,
        -0.9790449142456055,
        0.19580897688865662
      ],
      "plane_d": 1469.8260498046875,
      "bbox_min": [
        1110.0,
        1457.2857666015625,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1460.0,
        113.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1030.0,
        1390.0,
        370.0852355957031
      ],
      "bbox_max": [
        1050.0,
        1460.0,
        390.0852355957031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1030.0,
        950.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1140.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1030.0,
        950.0,
        255.0
      ],
      "bbox_max": [
        1040.0,
        1100.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1030.0,
        1092.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1140.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1030.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1041.199951171875,
        1120.9599609375,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1040.47998046875,
        1120.9599609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1030.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1040.3997802734375,
        1120.7999267578125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1039.52001953125,
        1110.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1120.9599609375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        0.5547001957893372
      ],
      "plane_d": -1004.00732421875,
      "bbox_min": [
        1040.0,
        1110.0,
        130.0
      ],
      "bbox_max": [
        1170.0,
        1120.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1039.52001953125,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1110.0,
        1120.9599609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1039.5999755859375,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1110.0,
        1120.7999267578125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": -1112.6187744140625,
      "bbox_min": [
        1030.0,
        1092.0,
        118.0
      ],
      "bbox_max": [
        1180.0,
        1140.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1030.0,
        1092.0,
        380.0
      ],
      "bbox_max": [
        1037.0,
        1100.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        1120.9599609375,
        118.0
      ],
      "bbox_max": [
        1110.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1030.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1100.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1175.0,
        1380.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1037.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1075.0,
        1310.0,
        580.0
      ],
      "bbox_max": [
        1175.0,
        1380.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1075.0,
        1310.0,
        580.0
      ],
      "bbox_max": [
        1175.0,
        1380.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1075.0,
        1310.0,
        580.0
      ],
      "bbox_max": [
        1075.0,
        1380.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1118.2041015625,
      "bbox_min": [
        1030.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        1040.0,
        608.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1175.0,
        1380.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1075.0,
        1310.0,
        750.0
      ],
      "bbox_max": [
        1175.0,
        1380.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1075.0,
        1310.0,
        750.0
      ],
      "bbox_max": [
        1075.0,
        1380.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1160.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1515.329833984375,
      "bbox_min": [
        1050.0,
        1068.85791015625,
        750.0
      ],
      "bbox_max": [
        1160.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.37615966796875,
      "bbox_min": [
        1135.85791015625,
        1068.85791015625,
        750.0
      ],
      "bbox_max": [
        1160.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1061.0999755859375,
        994.1422119140625,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        1460.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1550.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1215.0,
        1460.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1550.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1460.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1550.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        1030.0,
        1460.0,
        355.9431457519531
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1030.0,
        1460.0,
        355.9431457519531
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1030.0,
        1470.0,
        355.9431457519531
      ],
      "bbox_max": [
        1075.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1030.0,
        1470.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1540.0,
        390.0852355957031
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1540.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1519.9998779296875,
      "bbox_min": [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1520.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      "bbox_max": [
        1050.0,
        1470.0,
        390.0852355957031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        450.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        450.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7921085953712463,
        -0.6103802919387817,
        0.0
      ],
      "plane_d": 534.706298828125,
      "bbox_min": [
        450.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        450.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        584.3502807617188,
        1690.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 1745.3179931640625,
      "bbox_min": [
        450.0,
        1634.350341796875,
        120.0
      ],
      "bbox_max": [
        584.3502807617188,
        1690.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555696487426758,
        -0.8314700126647949,
        0.0
      ],
      "plane_d": 1683.560546875,
      "bbox_min": [
        522.7098388671875,
        1634.350341796875,
        120.0
      ],
      "bbox_max": [
        584.3502807617188,
        1675.537109375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 1745.3179931640625,
      "bbox_min": [
        450.0,
        1634.350341796875,
        100.0
      ],
      "bbox_max": [
        584.3502807617188,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555696487426758,
        -0.8314700126647949,
        0.0
      ],
      "plane_d": 1683.560546875,
      "bbox_min": [
        522.7098388671875,
        1634.350341796875,
        100.0
      ],
      "bbox_max": [
        584.3502807617188,
        1675.537109375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        519.3518676757812,
        1550.0,
        100.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        519.3519897460938,
        1550.0,
        100.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        -0.5555698871612549,
        0.0
      ],
      "plane_d": 1393.865478515625,
      "bbox_min": [
        584.3502807617188,
        1550.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        660.0,
        1640.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -660.0,
      "bbox_min": [
        660.0,
        1640.0,
        120.0
      ],
      "bbox_max": [
        660.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        -0.1950903981924057,
        0.0
      ],
      "plane_d": 920.3382568359375,
      "bbox_min": [
        625.537109375,
        1550.0,
        120.0
      ],
      "bbox_max": [
        630.0543823242188,
        1572.7098388671875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        -0.5555698871612549,
        0.0
      ],
      "plane_d": 1393.865478515625,
      "bbox_min": [
        584.3502807617188,
        1550.0,
        100.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        660.0,
        1640.0,
        100.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -660.0,
      "bbox_min": [
        660.0,
        1640.0,
        100.0
      ],
      "bbox_max": [
        660.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        -0.1950903981924057,
        0.0
      ],
      "plane_d": 920.3382568359375,
      "bbox_min": [
        625.537109375,
        1550.0,
        100.0
      ],
      "bbox_max": [
        630.0543823242188,
        1572.7098388671875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -189.99998474121094,
      "bbox_min": [
        584.3502807617188,
        1550.0,
        140.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        -0.5555698871612549,
        0.0
      ],
      "plane_d": 1393.865478515625,
      "bbox_min": [
        584.3502807617188,
        1550.0,
        140.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        660.0,
        1640.0,
        140.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -660.0,
      "bbox_min": [
        660.0,
        1640.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        1690.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        -0.1950903981924057,
        0.0
      ],
      "plane_d": 920.3382568359375,
      "bbox_min": [
        625.537109375,
        1550.0,
        140.0
      ],
      "bbox_max": [
        630.0543823242188,
        1572.7098388671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        780.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        780.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 149.99998474121094,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1680.0,
        200.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        780.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        790.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        790.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        970.0,
        1680.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        790.0,
        1595.0,
        150.0
      ],
      "bbox_max": [
        815.0,
        1680.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        0.5144957304000854,
        -0.0
      ],
      "plane_d": -1555.4921875,
      "bbox_min": [
        805.0,
        1655.0,
        150.0
      ],
      "bbox_max": [
        815.0,
        1680.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 601.0408325195312,
      "bbox_min": [
        805.0,
        1655.0,
        150.0
      ],
      "bbox_max": [
        815.0,
        1665.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.8574929237365723,
        0.0
      ],
      "plane_d": -962.1070556640625,
      "bbox_min": [
        790.0,
        1595.0,
        150.0
      ],
      "bbox_max": [
        815.0,
        1605.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1704.12744140625,
      "bbox_min": [
        805.0,
        1595.0,
        150.0
      ],
      "bbox_max": [
        815.0,
        1605.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        945.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        970.0,
        1680.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1595.0,
        150.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.5144957304000854,
        0.0
      ],
      "plane_d": -46.3045654296875,
      "bbox_min": [
        945.0,
        1655.0,
        150.0
      ],
      "bbox_max": [
        970.0,
        1680.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        945.0,
        1655.0,
        150.0
      ],
      "bbox_max": [
        970.0,
        1665.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        945.0,
        1655.0,
        150.0
      ],
      "bbox_max": [
        955.0,
        1665.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        970.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1873.8330078125,
      "bbox_min": [
        970.0,
        1590.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        970.0,
        1590.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        970.0,
        1664.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        780.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        790.0,
        1680.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -629.3250732421875,
      "bbox_min": [
        780.0,
        1590.0,
        150.0
      ],
      "bbox_max": [
        790.0,
        1680.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.8574929237365723,
        0.0
      ],
      "plane_d": -962.1070556640625,
      "bbox_min": [
        780.0,
        1590.0,
        150.0
      ],
      "bbox_max": [
        790.0,
        1670.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        780.0,
        1664.0,
        150.0
      ],
      "bbox_max": [
        790.0,
        1670.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1680.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1074.80224609375,
      "bbox_min": [
        780.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 1230.3658447265625,
      "bbox_min": [
        780.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 671.7514038085938,
      "bbox_min": [
        780.0,
        1590.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -572.7564697265625,
      "bbox_min": [
        799.9999389648438,
        1590.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1704.12744140625,
      "bbox_min": [
        799.9999389648438,
        1590.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.8574929237365723,
        0.0
      ],
      "plane_d": -962.1070556640625,
      "bbox_min": [
        799.9999389648438,
        1590.0,
        144.9999542236328
      ],
      "bbox_max": [
        815.0,
        1605.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        812.0000610351562,
        1590.0,
        145.0
      ],
      "bbox_max": [
        815.0,
        1595.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 601.0408325195312,
      "bbox_min": [
        799.9999389648438,
        1590.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        799.9999389648438,
        1655.0,
        144.9999542236328
      ],
      "bbox_max": [
        815.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        0.5144957304000854,
        -0.0
      ],
      "plane_d": -1555.4921875,
      "bbox_min": [
        812.0,
        1665.0,
        145.0
      ],
      "bbox_max": [
        815.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1590.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1590.0,
        145.0
      ],
      "bbox_max": [
        960.0,
        1605.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        955.0,
        1602.0,
        145.0000457763672
      ],
      "bbox_max": [
        960.0,
        1605.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        945.0,
        1655.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.5144957304000854,
        0.0
      ],
      "plane_d": -46.3045654296875,
      "bbox_min": [
        945.0,
        1655.0,
        145.0
      ],
      "bbox_max": [
        960.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1655.0,
        145.0000457763672
      ],
      "bbox_max": [
        960.0,
        1658.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        950.0,
        1590.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        950.0,
        1655.0,
        140.0
      ],
      "bbox_max": [
        955.0,
        1660.0,
        145.0000457763672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.8574929237365723,
        0.0
      ],
      "plane_d": -962.1070556640625,
      "bbox_min": [
        780.0,
        1590.0,
        140.0
      ],
      "bbox_max": [
        810.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 601.0408325195312,
      "bbox_min": [
        805.0,
        1655.0,
        140.0
      ],
      "bbox_max": [
        810.0,
        1660.0,
        144.9999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.8574929237365723,
        0.0
      ],
      "plane_d": -962.1070556640625,
      "bbox_min": [
        780.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1600.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1704.12744140625,
      "bbox_min": [
        810.0,
        1595.0,
        140.0
      ],
      "bbox_max": [
        815.0,
        1600.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1600.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1595.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1600.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        780.0,
        1660.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 601.0408325195312,
      "bbox_min": [
        810.0,
        1660.0,
        140.0
      ],
      "bbox_max": [
        815.0,
        1665.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.5144957304000854,
        0.0
      ],
      "plane_d": -46.3045654296875,
      "bbox_min": [
        945.0,
        1660.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        945.0,
        1660.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1665.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1680.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1650.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        885.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1650.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -885.0,
      "bbox_min": [
        885.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        940.0,
        1650.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        885.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        940.0,
        1645.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9363291263580322,
        0.0,
        -0.3511234223842621
      ],
      "plane_d": -808.7542724609375,
      "bbox_min": [
        905.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9363291263580322,
        -0.0,
        -0.3511234223842621
      ],
      "plane_d": 909.40966796875,
      "bbox_min": [
        905.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.936329185962677,
        -0.3511234521865845
      ],
      "plane_d": -1473.548095703125,
      "bbox_min": [
        905.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.936329185962677,
        -0.3511234521865845
      ],
      "plane_d": 1578.885009765625,
      "bbox_min": [
        905.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8374775648117065,
        -0.41873878240585327,
        -0.3511256277561188
      ],
      "plane_d": -34.655479431152344,
      "bbox_min": [
        905.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8374775648117065,
        0.41873878240585327,
        -0.35112565755844116
      ],
      "plane_d": -1399.743896484375,
      "bbox_min": [
        905.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8374775648117065,
        -0.41873878240585327,
        -0.35112565755844116
      ],
      "plane_d": 1502.1158447265625,
      "bbox_min": [
        908.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8374775648117065,
        0.41873878240585327,
        -0.3511256277561188
      ],
      "plane_d": 137.02737426757812,
      "bbox_min": [
        908.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.584919810295105,
        0.7311497330665588,
        -0.3511250615119934
      ],
      "plane_d": -1676.21484375,
      "bbox_min": [
        908.0,
        1615.0,
        110.0
      ],
      "bbox_max": [
        918.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5849193930625916,
        -0.7311491966247559,
        -0.3511269986629486
      ],
      "plane_d": 707.3330078125,
      "bbox_min": [
        908.0,
        1629.5,
        110.0
      ],
      "bbox_max": [
        918.0,
        1645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -918.0,
      "bbox_min": [
        917.0,
        1629.5,
        113.0
      ],
      "bbox_max": [
        918.0,
        1630.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 113.0,
      "bbox_min": [
        917.0,
        1629.5,
        113.0
      ],
      "bbox_max": [
        918.0,
        1630.5,
        113.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        885.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        940.0,
        1645.0,
        110.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.44721364974975586,
        -0.0
      ],
      "plane_d": -1536.178955078125,
      "bbox_min": [
        905.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        930.0,
        1625.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        0.44721364974975586,
        0.0
      ],
      "plane_d": 105.09521484375,
      "bbox_min": [
        908.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        930.0,
        1625.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1831.4498291015625,
      "bbox_min": [
        908.0,
        1615.0,
        100.0
      ],
      "bbox_max": [
        913.0,
        1619.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1635.0,
      "bbox_min": [
        895.0,
        1635.0,
        100.0
      ],
      "bbox_max": [
        940.0,
        1645.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -78.26239013671875,
      "bbox_min": [
        905.0,
        1635.0,
        100.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": 1563.01171875,
      "bbox_min": [
        908.0,
        1635.0,
        100.0
      ],
      "bbox_max": [
        930.0,
        1645.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        -0.7808688282966614,
        0.0
      ],
      "plane_d": 714.1826171875,
      "bbox_min": [
        908.0,
        1641.0,
        100.0
      ],
      "bbox_max": [
        913.0,
        1645.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47058823704719543,
        0.0,
        0.8823529481887817
      ],
      "plane_d": 382.3529357910156,
      "bbox_min": [
        1000.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1620.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1000.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1620.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        1003.75,
        1610.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1620.0,
        114.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        780.0,
        1655.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        780.0,
        1655.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8574929237365723,
        0.5144957304000854,
        -0.0
      ],
      "plane_d": -1555.4921875,
      "bbox_min": [
        780.0,
        1655.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -629.3250732421875,
      "bbox_min": [
        780.0,
        1655.0,
        100.0
      ],
      "bbox_max": [
        815.0,
        1680.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 601.0408325195312,
      "bbox_min": [
        805.0,
        1655.0,
        100.0
      ],
      "bbox_max": [
        815.0,
        1665.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.5144957304000854,
        0.0
      ],
      "plane_d": -46.3045654296875,
      "bbox_min": [
        945.0,
        1655.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        945.0,
        1655.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1873.8330078125,
      "bbox_min": [
        970.0,
        1670.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1610.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.8574929237365723,
        0.0
      ],
      "plane_d": -962.1070556640625,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1704.12744140625,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        815.0,
        1605.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1590.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        970.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1590.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1020.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1590.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -629.3250732421875,
      "bbox_min": [
        790.0,
        1680.0,
        100.0
      ],
      "bbox_max": [
        970.0,
        1690.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1873.8330078125,
      "bbox_min": [
        800.0,
        1680.0,
        100.0
      ],
      "bbox_max": [
        970.0,
        1690.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8574929237365723,
        0.5144957304000854,
        -0.0
      ],
      "plane_d": -1555.4921875,
      "bbox_min": [
        800.0,
        1680.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1690.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.5144957304000854,
        0.0
      ],
      "plane_d": -46.3045654296875,
      "bbox_min": [
        954.0,
        1680.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1690.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        790.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1580.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        790.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1580.0,
        180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        820.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1550.0,
        120.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        945.5584716796875,
        1550.0,
        120.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        945.5584716796875,
        1550.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        945.5584716796875,
        1550.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1550.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -945.5584716796875,
      "bbox_min": [
        945.5584716796875,
        1550.0,
        120.0
      ],
      "bbox_max": [
        945.5584716796875,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        790.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        970.0,
        1580.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        800.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        970.0,
        1580.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        800.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1580.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        954.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1580.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        790.0,
        1570.0,
        180.0
      ],
      "bbox_max": [
        970.0,
        1580.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        800.0,
        1570.0,
        180.0
      ],
      "bbox_max": [
        970.0,
        1580.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        800.0,
        1570.0,
        180.0
      ],
      "bbox_max": [
        960.0,
        1580.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        954.0,
        1570.0,
        180.0
      ],
      "bbox_max": [
        960.0,
        1580.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -216.0,
      "bbox_min": [
        780.0,
        1570.0,
        200.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        216.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        780.0,
        1570.0,
        200.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        780.0,
        1570.0,
        200.0
      ],
      "bbox_max": [
        815.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        0.5144957304000854,
        -0.0
      ],
      "plane_d": -1555.4921875,
      "bbox_min": [
        780.0,
        1655.0,
        200.0
      ],
      "bbox_max": [
        815.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -629.3250732421875,
      "bbox_min": [
        780.0,
        1655.0,
        200.0
      ],
      "bbox_max": [
        815.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 601.0408325195312,
      "bbox_min": [
        805.0,
        1655.0,
        200.0
      ],
      "bbox_max": [
        815.0,
        1665.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.8574929237365723,
        0.0
      ],
      "plane_d": -962.1070556640625,
      "bbox_min": [
        780.0,
        1570.0,
        200.0
      ],
      "bbox_max": [
        815.0,
        1605.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        780.0,
        1570.0,
        200.0
      ],
      "bbox_max": [
        815.0,
        1605.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1704.12744140625,
      "bbox_min": [
        805.0,
        1595.0,
        200.0
      ],
      "bbox_max": [
        815.0,
        1605.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        945.0,
        1570.0,
        200.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1570.0,
        200.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        945.0,
        1570.0,
        200.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1595.0,
        200.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.5144957304000854,
        0.0
      ],
      "plane_d": -46.3045654296875,
      "bbox_min": [
        945.0,
        1655.0,
        200.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        945.0,
        1655.0,
        200.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1873.8330078125,
      "bbox_min": [
        945.0,
        1655.0,
        200.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        945.0,
        1655.0,
        200.0
      ],
      "bbox_max": [
        955.0,
        1665.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        450.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        450.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1460.0,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        450.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        900.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        950.0,
        950.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1018.7999877929688,
        970.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1120.9599609375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1019.5999755859375,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1030.0,
        1120.7999267578125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1019.5199584960938,
        1120.7999267578125,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -648.4597778320312,
      "bbox_min": [
        1019.5199584960938,
        1120.7999267578125,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1019.9999389648438,
      "bbox_min": [
        1019.5199584960938,
        1120.7999267578125,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1250.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1020.0,
        1120.7999267578125,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1210.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1020.0,
        1120.9599609375,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1210.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1020.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1019.5199584960938,
        1120.7999267578125,
        118.0
      ],
      "bbox_max": [
        1020.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1019.5199584960938,
        1120.9599609375,
        118.0
      ],
      "bbox_max": [
        1020.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1019.5199584960938,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1020.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974522560834885
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        950.0,
        950.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        380.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1010.0,
        950.0,
        100.0
      ],
      "bbox_max": [
        1010.0,
        961.199951171875,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1009.0399780273438,
        960.0,
        100.0
      ],
      "bbox_max": [
        1020.0,
        1120.9599609375,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1010.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1019.5199584960938,
        1120.9599609375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1009.0399780273438,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1010.0,
        1120.9599609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1009.2000122070312,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1010.0,
        1120.7999267578125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1009.0399780273438,
        1120.7999267578125,
        118.0
      ],
      "bbox_max": [
        1026.7122802734375,
        1280.0,
        297.8082275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1009.0399780273438,
        1120.7999267578125,
        118.0
      ],
      "bbox_max": [
        1019.5999755859375,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1009.0399780273438,
        1120.9599609375,
        118.0
      ],
      "bbox_max": [
        1019.5999755859375,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1009.0399780273438,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1019.5999755859375,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        950.0,
        950.0,
        100.0
      ],
      "bbox_max": [
        1023.239501953125,
        1280.0,
        295.4930419921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        950.0,
        950.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        1280.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        950.0,
        950.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        1280.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        976.0,
        990.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -989.9999389648438,
      "bbox_min": [
        976.0,
        990.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        988.9999389648438,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -831.8172607421875,
      "bbox_min": [
        950.0,
        970.0,
        100.0
      ],
      "bbox_max": [
        989.0,
        1280.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -332.7269287109375,
      "bbox_min": [
        950.0,
        970.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1100.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -989.9999389648438,
      "bbox_min": [
        950.0,
        990.0,
        103.00000762939453
      ],
      "bbox_max": [
        980.0,
        1094.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        960.0,
        1070.0,
        108.0
      ],
      "bbox_max": [
        960.0,
        1084.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -581.377685546875,
      "bbox_min": [
        950.0,
        1080.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        108.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -959.9999389648438,
      "bbox_min": [
        960.0,
        1080.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        108.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -831.8172607421875,
      "bbox_min": [
        990.0,
        1166.1483154296875,
        120.0
      ],
      "bbox_max": [
        1000.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1023.239501953125,
        1280.0,
        295.4930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1000.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1009.2000122070312,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1000.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1009.2000122070312,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1000.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1009.2000122070312,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        950.0,
        900.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1010.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1010.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        1010.0,
        950.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        950.0,
        900.0,
        100.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        337.72265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        950.0,
        900.0,
        100.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        950.0,
        900.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        950.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        950.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        950.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        950.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1118.2041015625,
      "bbox_min": [
        950.0,
        608.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        900.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        950.0,
        803.656982421875,
        100.0
      ],
      "bbox_max": [
        1014.2000122070312,
        900.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        950.0,
        803.656982421875,
        118.0
      ],
      "bbox_max": [
        1014.2000122070312,
        867.8925170898438,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        950.0,
        803.656982421875,
        120.0
      ],
      "bbox_max": [
        1014.2000122070312,
        867.8724365234375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        950.0,
        803.6924438476562,
        118.0
      ],
      "bbox_max": [
        1014.2000122070312,
        900.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.381051242351532,
        0.9245539903640747,
        0.0
      ],
      "plane_d": -434.4053649902344,
      "bbox_min": [
        1000.0,
        882.0,
        118.0
      ],
      "bbox_max": [
        1014.2000122070312,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        882.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        882.0472412109375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        882.0472412109375,
        118.0
      ],
      "bbox_max": [
        1000.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        950.0,
        891.7157592773438,
        140.0
      ],
      "bbox_max": [
        958.2842407226562,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        450.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        950.0,
        1280.0,
        600.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        780.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        950.0,
        1280.0,
        600.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -1355.414306640625,
      "bbox_min": [
        840.0,
        1045.0,
        100.0
      ],
      "bbox_max": [
        950.0,
        1280.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": -1293.248291015625,
      "bbox_min": [
        840.0,
        1045.0,
        100.0
      ],
      "bbox_max": [
        946.9471435546875,
        1130.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -741.3171997070312,
      "bbox_min": [
        840.0,
        1079.81103515625,
        100.0
      ],
      "bbox_max": [
        868.66943359375,
        1130.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        840.0,
        1079.81103515625,
        100.0
      ],
      "bbox_max": [
        868.66943359375,
        1121.3931884765625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        861.3306274414062,
        1120.0,
        100.0
      ],
      "bbox_max": [
        868.66943359375,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        840.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        861.3306274414062,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        840.0,
        1120.0,
        108.0
      ],
      "bbox_max": [
        845.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        840.0,
        1130.0,
        108.0
      ],
      "bbox_max": [
        842.3323364257812,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -874.6409912109375,
      "bbox_min": [
        840.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        950.0,
        1280.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": -1521.5843505859375,
      "bbox_min": [
        840.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        874.6409912109375,
        1280.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        840.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        874.6409912109375,
        1272.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        842.3323364257812,
        1120.0,
        100.0
      ],
      "bbox_max": [
        874.6409912109375,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        842.3323364257812,
        1128.9871826171875,
        108.0
      ],
      "bbox_max": [
        845.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        842.3323364257812,
        1128.9871826171875,
        108.0
      ],
      "bbox_max": [
        845.0,
        1130.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        840.0,
        1192.0,
        340.0
      ],
      "bbox_max": [
        874.6409912109375,
        1272.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        840.0,
        1252.0,
        140.0
      ],
      "bbox_max": [
        874.6409912109375,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 910.0,
      "bbox_min": [
        874.6409912109375,
        1120.0,
        100.0
      ],
      "bbox_max": [
        950.0,
        1280.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        910.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8479983806610107,
        0.5299989581108093,
        0.0
      ],
      "plane_d": 140.97979736328125,
      "bbox_min": [
        874.6409912109375,
        1120.0,
        100.0
      ],
      "bbox_max": [
        910.0,
        1280.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        874.6409912109375,
        1120.0,
        100.0
      ],
      "bbox_max": [
        910.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        874.6409912109375,
        1150.0,
        140.0
      ],
      "bbox_max": [
        910.0,
        1280.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        874.6409912109375,
        1212.0,
        320.0
      ],
      "bbox_max": [
        910.0,
        1252.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1252.0,
      "bbox_min": [
        874.6409912109375,
        1252.0,
        320.0
      ],
      "bbox_max": [
        910.0,
        1252.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": 283.2706604003906,
      "bbox_min": [
        780.0,
        990.3443603515625,
        100.0
      ],
      "bbox_max": [
        840.0,
        1280.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -741.3171997070312,
      "bbox_min": [
        783.0528564453125,
        990.3443603515625,
        100.0
      ],
      "bbox_max": [
        840.0,
        1171.0252685546875,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        0.4117811918258667,
        0.0
      ],
      "plane_d": 303.2713623046875,
      "bbox_min": [
        783.0528564453125,
        990.3443603515625,
        110.0
      ],
      "bbox_max": [
        840.0,
        1111.9007568359375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        794.0264282226562,
        990.3443603515625,
        170.0
      ],
      "bbox_max": [
        840.0,
        1111.9007568359375,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        783.0528564453125,
        1020.7152099609375,
        170.0
      ],
      "bbox_max": [
        834.24267578125,
        1109.7147216796875,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        816.9431762695312,
        1120.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1171.0252685546875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        816.9431762695312,
        1120.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        1171.0252685546875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        821.4618530273438,
        1130.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        1171.0252685546875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        821.4618530273438,
        1130.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": -681.5838623046875,
      "bbox_min": [
        780.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1280.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 805.3590087890625,
      "bbox_min": [
        780.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1272.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        805.3590087890625,
        1120.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1272.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        805.3590087890625,
        1120.0,
        100.0
      ],
      "bbox_max": [
        821.4618530273438,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        805.3590087890625,
        1120.0,
        108.0
      ],
      "bbox_max": [
        816.9431762695312,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        805.3590087890625,
        1120.0,
        100.0
      ],
      "bbox_max": [
        816.9431762695312,
        1120.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        805.3590087890625,
        1192.0,
        340.0
      ],
      "bbox_max": [
        840.0,
        1272.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        780.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        805.3590087890625,
        1252.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        780.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        805.3590087890625,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        780.0,
        1120.0,
        108.0
      ],
      "bbox_max": [
        805.3590087890625,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        780.0,
        1130.0,
        108.0
      ],
      "bbox_max": [
        805.3590087890625,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        780.0,
        1237.35888671875,
        140.0
      ],
      "bbox_max": [
        840.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0,
      "bbox_min": [
        780.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        950.0,
        950.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        780.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        516.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        780.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        780.0,
        701.7156982421875,
        100.0
      ],
      "bbox_max": [
        950.0,
        950.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        780.0,
        701.7156982421875,
        100.0
      ],
      "bbox_max": [
        950.0,
        950.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        950.0,
        803.6924438476562,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        780.0,
        701.7156982421875,
        100.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        866.452880859375,
        720.11572265625,
        118.0
      ],
      "bbox_max": [
        950.0,
        803.6924438476562,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        866.452880859375,
        720.11572265625,
        120.0
      ],
      "bbox_max": [
        950.0,
        803.6924438476562,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        780.0,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        886.0660400390625,
        856.0660400390625,
        118.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        780.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        820.0,
        950.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        450.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        450.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        450.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        500.0,
        1240.0,
        330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        450.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        500.0,
        1240.0,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        450.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        490.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        450.0,
        980.0,
        160.0
      ],
      "bbox_max": [
        490.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        450.0,
        1090.0,
        100.0
      ],
      "bbox_max": [
        490.0,
        1110.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        450.0,
        1090.0,
        160.0
      ],
      "bbox_max": [
        490.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        490.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        500.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        490.0,
        980.0,
        160.0
      ],
      "bbox_max": [
        500.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        490.0,
        1090.0,
        100.0
      ],
      "bbox_max": [
        500.0,
        1110.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        490.0,
        1090.0,
        160.0
      ],
      "bbox_max": [
        500.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        500.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        720.0,
        1280.0,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        500.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        662.6244506835938,
        1110.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        500.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        662.6243896484375,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        500.0,
        980.0,
        160.0
      ],
      "bbox_max": [
        626.8832397460938,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        500.0,
        1090.0,
        160.0
      ],
      "bbox_max": [
        662.6243896484375,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        620.3848876953125,
        980.0,
        100.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        662.6243896484375,
        1110.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        656.1259765625,
        1000.0,
        100.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        656.1259765625,
        1090.0,
        100.0
      ],
      "bbox_max": [
        700.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        662.6243896484375,
        1110.0,
        100.0
      ],
      "bbox_max": [
        700.0,
        1110.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        700.0,
        1110.0,
        100.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        760.0,
        1040.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        1040.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.0,
        -0.44721364974975586
      ],
      "plane_d": 742.3746948242188,
      "bbox_min": [
        760.0,
        1040.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        775.0000610351562,
        1040.0,
        108.0
      ],
      "bbox_max": [
        780.0,
        1130.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        775.0000610351562,
        1130.0,
        108.0
      ],
      "bbox_max": [
        780.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        760.0,
        1040.0,
        108.0
      ],
      "bbox_max": [
        776.0,
        1130.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        760.0,
        1130.0,
        108.0
      ],
      "bbox_max": [
        776.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0,
      "bbox_min": [
        450.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        660.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        516.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        660.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        450.0,
        516.0999755859375,
        100.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        460.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        450.0,
        516.0999755859375,
        100.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        460.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        499.80194091796875,
        516.0999755859375,
        140.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0002752529107965529,
        -0.0
      ],
      "plane_d": -550.2064208984375,
      "bbox_min": [
        512.6419067382812,
        516.0999755859375,
        145.0
      ],
      "bbox_max": [
        720.0,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7121667861938477,
        0.7020103335380554,
        -0.0
      ],
      "plane_d": -953.280517578125,
      "bbox_min": [
        512.6419067382812,
        799.9862060546875,
        360.0
      ],
      "bbox_max": [
        549.9862060546875,
        837.8707885742188,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0999755859375,
      "bbox_min": [
        715.0,
        516.0999755859375,
        145.0
      ],
      "bbox_max": [
        720.0,
        516.0999755859375,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -226.18081665039062,
      "bbox_min": [
        549.9669799804688,
        850.0,
        140.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        650.0,
        850.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        650.0,
        850.0,
        160.0
      ],
      "bbox_max": [
        650.0,
        920.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        720.0,
        516.0999755859375,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        313.3333435058594
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        516.0999755859375,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        313.3333435058594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 139.99998474121094,
      "bbox_min": [
        760.0,
        516.0999755859375,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        313.3333435058594
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        760.0,
        516.0999755859375,
        145.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        313.3333435058594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0999755859375,
      "bbox_min": [
        760.0,
        516.0999755859375,
        145.0
      ],
      "bbox_max": [
        775.0,
        516.0999755859375,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        760.0,
        710.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0999755859375,
      "bbox_min": [
        720.0,
        516.0999755859375,
        145.0
      ],
      "bbox_max": [
        760.0,
        516.0999755859375,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        840.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        840.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        840.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1330.0,
        355.9431457519531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        840.0,
        1310.0,
        180.0
      ],
      "bbox_max": [
        854.056884765625,
        1330.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        854.056884765625,
        1310.0,
        100.0
      ],
      "bbox_max": [
        945.5584716796875,
        1330.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        840.0,
        1330.0,
        100.0
      ],
      "bbox_max": [
        929.0144653320312,
        1460.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        840.0,
        1330.0,
        100.0
      ],
      "bbox_max": [
        929.0144653320312,
        1437.609375,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        840.0,
        1400.0,
        140.0
      ],
      "bbox_max": [
        871.1104736328125,
        1437.609375,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1416.0,
      "bbox_min": [
        840.0,
        1416.0,
        140.0
      ],
      "bbox_max": [
        850.0,
        1434.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 850.0,
      "bbox_min": [
        840.0,
        1416.0,
        140.0
      ],
      "bbox_max": [
        850.0,
        1434.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1434.0,
      "bbox_min": [
        840.0,
        1434.0,
        140.0
      ],
      "bbox_max": [
        842.9856567382812,
        1434.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        840.0,
        1377.16455078125,
        100.0
      ],
      "bbox_max": [
        890.0,
        1460.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        840.0,
        1377.16455078125,
        100.0
      ],
      "bbox_max": [
        890.0,
        1460.0,
        180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        840.0,
        1400.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        840.0,
        1400.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1434.0,
      "bbox_min": [
        842.9856567382812,
        1425.5203857421875,
        140.0
      ],
      "bbox_max": [
        850.0,
        1434.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        842.9856567382812,
        1425.5203857421875,
        155.0
      ],
      "bbox_max": [
        850.0,
        1434.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        871.1104736328125,
        1400.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        840.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1310.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        840.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1310.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        945.5584716796875,
        1280.0,
        120.0
      ],
      "bbox_max": [
        1030.0,
        1310.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        945.5584716796875,
        1300.0,
        160.0
      ],
      "bbox_max": [
        1030.0,
        1310.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27883198857307434,
        0.9603399634361267,
        -0.0
      ],
      "plane_d": -1521.6973876953125,
      "bbox_min": [
        945.5584716796875,
        1300.0,
        160.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        945.5584716796875,
        1280.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27883198857307434,
        0.9603399634361267,
        -0.0
      ],
      "plane_d": -1521.6973876953125,
      "bbox_min": [
        945.5584716796875,
        1280.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -945.5584716796875,
      "bbox_min": [
        945.5584716796875,
        1280.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1280.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1280.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1280.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 452.5483703613281,
      "bbox_min": [
        780.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1460.0,
        180.08523559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        780.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1460.0,
        180.08523559570312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        780.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1460.0,
        180.08523559570312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1280.0,
        120.0
      ],
      "bbox_max": [
        840.0,
        1460.0,
        180.08523559570312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        780.0,
        1280.0,
        120.0
      ],
      "bbox_max": [
        840.0,
        1460.0,
        180.08523559570312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        780.0,
        1280.0,
        120.0
      ],
      "bbox_max": [
        840.0,
        1450.0,
        160.08518981933594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        780.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        840.0,
        1450.0,
        155.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        820.0,
        1416.0,
        140.0
      ],
      "bbox_max": [
        840.0,
        1434.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        820.0,
        1416.0,
        140.0
      ],
      "bbox_max": [
        840.0,
        1434.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1434.0,
      "bbox_min": [
        820.0,
        1416.0,
        140.0
      ],
      "bbox_max": [
        840.0,
        1434.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1416.0,
      "bbox_min": [
        820.0,
        1416.0,
        140.0
      ],
      "bbox_max": [
        840.0,
        1416.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        780.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        840.0,
        1450.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        780.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        840.0,
        1400.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1280.0,
        120.0
      ],
      "bbox_max": [
        820.0,
        1310.0,
        160.08518981933594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1329.9998779296875,
      "bbox_min": [
        839.914794921875,
        1310.0,
        180.0
      ],
      "bbox_max": [
        840.0,
        1330.0,
        180.08523559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        839.914794921875,
        1310.0,
        180.00003051757812
      ],
      "bbox_max": [
        840.0,
        1310.0,
        180.08523559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1450.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        820.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1310.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1450.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        780.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1320.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1280.0,
        120.08523559570312
      ],
      "bbox_max": [
        839.914794921875,
        1460.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        780.0,
        1280.0,
        120.08523559570312
      ],
      "bbox_max": [
        839.914794921875,
        1460.0,
        180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        780.0,
        1400.0,
        120.08523559570312
      ],
      "bbox_max": [
        799.914794921875,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        780.0,
        1400.0,
        120.08523559570312
      ],
      "bbox_max": [
        799.914794921875,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        780.0,
        1450.0,
        120.08523559570312
      ],
      "bbox_max": [
        799.914794921875,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1280.0,
        160.08517456054688
      ],
      "bbox_max": [
        820.0,
        1310.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        0.30901700258255005,
        -0.0
      ],
      "plane_d": -1081.358154296875,
      "bbox_min": [
        530.4696044921875,
        1280.0,
        100.0
      ],
      "bbox_max": [
        719.4853515625,
        1384.3714599609375,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        0.8090178370475769,
        0.0
      ],
      "plane_d": -777.47216796875,
      "bbox_min": [
        530.4696044921875,
        1280.0,
        100.0
      ],
      "bbox_max": [
        719.4853515625,
        1384.3714599609375,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1384.3714599609375,
      "bbox_min": [
        582.7122802734375,
        1280.0,
        100.0
      ],
      "bbox_max": [
        719.4853515625,
        1384.3714599609375,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5877842307090759,
        0.8090178370475769,
        -0.0
      ],
      "plane_d": -1500.44677734375,
      "bbox_min": [
        647.2877197265625,
        1280.0,
        100.0
      ],
      "bbox_max": [
        719.4853515625,
        1384.3714599609375,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        717.8607788085938,
        1280.0,
        100.0
      ],
      "bbox_max": [
        719.4853515625,
        1285.0,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        450.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        370.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7921085953712463,
        -0.6103802919387817,
        0.0
      ],
      "plane_d": 534.706298828125,
      "bbox_min": [
        450.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        720.0,
        1550.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        450.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        519.3519897460938,
        1550.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        450.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        488.5288391113281,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        450.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        488.5288391113281,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        450.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        488.5288391113281,
        1510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        450.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        720.0,
        1550.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        450.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        640.0,
        1550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        -0.1950903981924057,
        0.0
      ],
      "plane_d": 920.3382568359375,
      "bbox_min": [
        630.0543823242188,
        1500.0,
        120.0
      ],
      "bbox_max": [
        640.0,
        1550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        -0.1950903981924057,
        0.0
      ],
      "plane_d": 920.3382568359375,
      "bbox_min": [
        630.0543823242188,
        1500.0,
        100.0
      ],
      "bbox_max": [
        640.0,
        1550.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        630.0543823242188,
        1460.0,
        140.0
      ],
      "bbox_max": [
        720.0,
        1550.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        -0.1950903981924057,
        0.0
      ],
      "plane_d": 920.3382568359375,
      "bbox_min": [
        630.0543823242188,
        1500.0,
        140.0
      ],
      "bbox_max": [
        640.0,
        1550.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        780.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        370.0852355957031
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1539.9998779296875,
      "bbox_min": [
        780.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        370.0852355957031
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1519.9998779296875,
      "bbox_min": [
        780.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1540.0,
        370.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        780.0,
        1520.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1540.0,
        355.9431457519531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        780.0,
        1520.0,
        105.943115234375
      ],
      "bbox_max": [
        854.056884765625,
        1540.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1520.0,
        120.0
      ],
      "bbox_max": [
        780.0,
        1540.0,
        120.08523559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        790.0,
        1530.0,
        115.94307708740234
      ],
      "bbox_max": [
        790.0,
        1540.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        780.0,
        1520.0,
        100.0
      ],
      "bbox_max": [
        820.0,
        1540.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        115.94307708740234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1530.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1540.0,
        105.943115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        780.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        929.0144653320312,
        1520.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        780.0,
        1520.0,
        120.08523559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        820.0,
        1520.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        879.382568359375,
        1460.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        879.382568359375,
        1460.0,
        180.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        820.0,
        1540.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        820.0,
        1540.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27883198857307434,
        -0.9603399634361267,
        0.0
      ],
      "plane_d": 1215.2716064453125,
      "bbox_min": [
        820.0,
        1540.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1540.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        160.08517456054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        945.5584716796875,
        1540.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -945.5584716796875,
      "bbox_min": [
        945.5584716796875,
        1540.0,
        120.0
      ],
      "bbox_max": [
        945.5584716796875,
        1550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 452.5483703613281,
      "bbox_min": [
        780.0,
        1460.0,
        120.08523559570312
      ],
      "bbox_max": [
        839.914794921875,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1460.0,
        120.08523559570312
      ],
      "bbox_max": [
        839.914794921875,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        780.0,
        1460.0,
        120.08523559570312
      ],
      "bbox_max": [
        839.914794921875,
        1550.0,
        180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        780.0,
        1540.0,
        120.08523559570312
      ],
      "bbox_max": [
        820.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1540.0,
        160.08517456054688
      ],
      "bbox_max": [
        820.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}